/* ------------------------------------------ GRYFF MODULE - Chris 04.07.2016 ----------------------------------------- */
import { GET } from '@/app/api/index';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import config from '@/app/editor/config/index';
import atom from '@/app/editor/iframe/atom';
import { delay } from '@/app/editor/sidebar/actions/actions.animations.config';
import { keyAddAction, keyAddEvent } from '@/app/editor/sidebar/actions/actions.config';
import { base, moduleTypes, SCROLL_VIEW_KEY } from '@/app/editor/sidebar/constant';
import AssignProduct from "@/app/editor/sidebar/module/AssignProduct";
import readStyle from '@/app/editor/sidebar/module/readStyle';
import moduleInfo from '@/app/editor/sidebar/module/register';
import writeStyle from '@/app/editor/sidebar/module/writeStyle';
import { getModuleData } from '@/app/editor/sidebar/utils/getModuleData';
import snippetSettingLinks from '@/app/editor/sidebar/utils/gfSnippetSettingLinks';
import { validateInput } from '@/app/editor/sidebar/utils/validateInput.ts';
import api from '@/app/endpoints.js';
import store from '@/app/store/store';
import { getLatestProduct, getProductPreview, getProductSelectorInstance } from "@/app/utils/assignedProductHelper";
import { autoCheckTemplate } from '@/app/utils/autoCheckTemplate.ts';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';
import { convertImgUrlToImageUrl } from '@/app/utils/convertImgUrlToImageUrl.ts';
import utils from '@/app/utils/gfUtils';
import HELPER, { copyToClipboard, initAce, sanitizeDescription } from '@/app/utils/HELPER';
import {
  getNaturalSizeImage,
  getValuesInFields,
  isBlockedScript,
  listForms,
  setValuesToFields,
  trimUrlCss,
} from '@/app/utils/helpers';
import { convertProductFormHtmlToLiquid, updateDynamicProduct } from '@/app/utils/helpers.ts';
import loadLoopItems from '@/app/utils/loadLoopItems';
import { getKeyFromModuleName } from '@/app/utils/moduleKeyName';
import emitter from '@/emitter';
import { ACTIVE_CLASSES, addElement, isLandingPage, removeElement } from '@/modules/gem-meter';
import storeX, { app } from '@/store';
import { handleModifyItemStyle } from '@/utils/apply-preset';
import { renderTabSettings } from './global-style/renderTabSetting';
import { handleAddToLibrary } from './utils/validateAddToLibrary';

(function (jQuery) {
  jQuery.gfModule = function (element, options) {
    const defaults = {
      notInitChildren: false,
    };
    this.settings = {};

    const _this = this;
    const $element = jQuery(element);

    let dataHolder;

    /* Editor */
    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
    const $gfResTool = getGlobalVariable('gfResTool');
    const $divContentHidden = getGlobalVariable('divContentHidden');
    const assignProduct = new AssignProduct(this, $element, $gfLeftSideBar);

    /* Iframe */
    const $gfFrame = getGlobalVariable('gfFrame');
    const $gryffEditor = getGlobalVariable('gryffEditor');
    const $gryffBody = getGlobalVariable('gryffBody');
    const $divContentBk = getGlobalVariable('divContentBk');
    const $divTopBar = getGlobalVariable('divTopBar');
    // COLLECTION 2019
    const mode = $gryffEditor.hasClass('editing') ? 'dev' : 'production';

    const _mdModule =
      '<div id="md-module"> <span class="md-title"> <span class="mer-title"> <i class="gpicon-liquid"></i> <span>Module</span> </span> </span> <div class="simple-tabs"> <ul class="simple-tabs-item"> <li> <a href="#">' +
      utils.svgIcon('settings') +
      ' Settings </a> </li> <li> <a href="#">' +
      utils.svgIcon('design') +
      ' Design </a> </li> </ul> <div class="md-body settings-panel"></div> <div class="md-body design-panel"></div> <textarea class="txtDataHidden inptxt gf-hide"></textarea> <textarea class="txtStyleHidden inptxt gf-hide"></textarea> </div> <div class="md-footer"> <button class="btnSave">APPLY</button> <button class="btnCancel">CANCEL</button> </div></div>';
    const _mdEditor =
      '<div id="md-editor" class="md-modal md-draggable">' +
      '<div class="md-content">' +
      '<div class="md-modal-handle">' +
      '<span class="md-title">' +
      '<span gf-tag="title">Code Editor</span>' +
      '<span gf-tag="type" gf-action="click:copyToClipboard" title="Click to copy"></span>' +
      '</span>' +
      '</div>' +
      '<div class="md-body code-panel">' +
      '<div class="section" gf-tabs="coding">' +
      '<div class="section-item disabled" gf-tab="template">Template</div>' +
      '<div class="section-item disabled" gf-tab="style">CSS</div>' +
      '<div class="section-item disabled" gf-tab="script">Script</div>' +
      '<div class="section-item disabled" gf-tab="data">Data</div>' +
      '</div>' +
      '<textarea id="templateCode" class="inptxt"></textarea>' +
      '<textarea id="styleCode" class="inptxt"></textarea>' +
      '<textarea id="scriptCode" class="inptxt"></textarea>' +
      '<textarea id="dataCode" class="inptxt"></textarea>' +
      '</div>' +
      '<div class="md-footer">' +
      '<button class="btnSave">Save</button>' +
      '<button class="btnCancel" class="cancel">Cancel</button>' +
      '</div>' +
      '</div>' +
      '<div class="md-controls">' +
      '<button class="btnClose"><i class="fa fa-times" aria-hidden="true"></i></button>' +
      '</div>' +
      '</div>';

    /* Style */
    const $moduleStyleContainer = getGlobalVariable('gfFrameContents').find('#' + moduleTypes._moduleStyleContainer);
    /* Script */
    const $moduleScriptContainer = getGlobalVariable('gfFrameContents').find('#' + moduleTypes._moduleScriptContainer);

    this.init = function () {
      // TODO(thanhdx): add class global style for module
      this.settings = jQuery.extend({}, defaults, options);
      const label = _this.getModuleName();

      this.registerFlowActions(label);

      if (label != '') {
        const moduleId = _this.getModuleId();
        var existingContent = '';

        let isInitNewElement = false;
        const keySnippet = HELPER.getKeyDataSetting(base._snippet, moduleId);
        const elmData = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySnippet);
        if (!elmData) {
          isInitNewElement = true;
          let $snippet;
          if (_this.settings.snippet) {
            $snippet = jQuery(_this.settings.snippet);
          } else {
            const moduleKey = _this.getModuleKey();
            $snippet = jQuery(app.$store.getters['editor/GET_SNIPPETS_BY_KEY'](moduleKey));
            var existingContent = $element.html();
          }
          const snippet = $snippet.html();
          const icon = $snippet.attr('data-icon') ? $snippet.attr('data-icon') : 'images/icons/default.png';
          const ver = $snippet.attr('data-ver') ? $snippet.attr('data-ver') : '1';

          _this.initWithLabel(label, moduleId, icon, ver, snippet, existingContent);
        }

        if (window.__gpAutoFixTemplate) {
          autoCheckTemplate(_this);
        }

        _this.initDataEditorInfo();
        _this.refresh();

        if (!_this.settings.isClone) {
          _this.afterRefreshInitClassGs(isInitNewElement);
        }

        // ===== GemMeter Feature ===== //
        const __countElement = () => {
          if (window.__countElement === 0) {
            storeX.state.editor.loadFinishALLMER = true;
          } else {
            window.__countElement = window.__countElement - 1;
          }
        };
        if (isLandingPage()) {
          __countElement();
        }
        // =========================== //
      } else {
        return false;
      }
    };
    this.initDataEditorInfo = function () {
      const isExistEditorInfo = app.$store.getters['editor/EXIST_KEY_DATA_SETTING'](this.getModuleId());
      if (isExistEditorInfo) return;
      const dataEditorInfo = {};
      dataEditorInfo.id = this.getModuleId();
      dataEditorInfo.merId = this.getModuleTargetId();
      dataEditorInfo.key = this.getModuleKey();
      dataEditorInfo.label = this.getModuleName();
      dataEditorInfo.data = {
        globalStyle: [],
      };

      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: this.getModuleId(),
        value: JSON.stringify(dataEditorInfo),
      });

      setTimeout(() => {
        addElement(dataEditorInfo.merId, dataEditorInfo.key);
      }, 0);
    };
    this.afterRefreshInitClassGs = function (isInitNewElement) {
      const merKey = _this.getModuleKey();
      const merId = _this.getModuleTargetId();
      const attrId = _this.getModuleId();
      const paramInitClass = {
        mer: $element,
        type: merKey,
        merId: merId,
        attrId: attrId,
        merType: 'module',
        isInitMER: true,
        isUpdateClassInDom: true,
      };
      renderTabSettings.initGlobalStyleClass(paramInitClass);
      if (!isInitNewElement) {
        // Improve Perform: Nếu không phải case kéo mới thì mới modify style
        const keyStyle = HELPER.getKeyDataSetting(base._style, _this.getModuleId());
        const preset = app.$store.getters['sidebar/getPresetByPagePresetId'];
        if (preset && Object.keys(preset).length) {
          handleModifyItemStyle({ keyStyle, merKey, merId });
        }
      }
      return false;
    };

    this.registerFlowActions = function (label = '') {
      //add custom action for Video Bg
      /* if (label == 'Video Bg') {
                //set action
                store.setValue(keyAddAction, {
                    key: "playVideo",
                    type: 3,
                    name: "Play Video",
                    description: "",
                    atomLabel: "Video Bg",
                    settings: [
                        delay
                    ]
                });
                store.setValue(keyAddAction, {
                    key: "pauseVideo",
                    type: 3,
                    name: "Pause Video",
                    description: "",
                    atomLabel: "Video Bg",
                    settings: [
                        delay
                    ]
                });
                store.setValue(keyAddAction, {
                    key: "stopVideo",
                    type: 3,
                    name: "Stop Video",
                    description: "",
                    atomLabel: "Video Bg",
                    settings: [
                        delay
                    ]
                });
                store.setValue(keyAddAction, {
                    key: "playPauseVideo",
                    type: 3,
                    name: "Play/Pause Video",
                    description: "",
                    atomLabel: "Video Bg",
                    settings: [
                        delay
                    ]
                });


                //set event
                store.setValue(keyAddEvent, {
                    key: "endVideo",
                    name: "End Video",
                    type: 2,
                    description: "Trigger when the video end",
                    atomLabel: "Video Bg"
                });
            } */

      //add custom action for Popup
      if (label == 'Popup') {
        //set action
        store.setValue(keyAddAction, {
          key: 'showPopup',
          type: 3,
          name: 'Show Popup',
          description: '',
          atomLabel: 'Popup',
          settings: [delay],
        });
        store.setValue(keyAddAction, {
          key: 'hidePopup',
          type: 3,
          name: 'Hide Popup',
          description: '',
          atomLabel: 'Popup',
          settings: [delay],
        });
        /* store.setValue(keyAddAction, {
                    key: "togglePopup",
                    type: 3,
                    name: "Toggle Popup",
                    description: "",
                    atomLabel: "Popup",
                    settings: [
                        delay
                    ]
                }); */

        //set event
        store.setValue(keyAddEvent, {
          key: 'openPopup',
          name: 'Open Popup',
          type: 2,
          description: 'Trigger when the Popup open',
          atomLabel: 'Popup',
        });

        //set event
        store.setValue(keyAddEvent, {
          key: 'closePopup',
          name: 'Close Popup',
          type: 2,
          description: 'Trigger when the Popup close',
          atomLabel: 'Popup',
        });
      }

      //add custom action for Product
      if (label == 'Product') {
        //set action
        // store.setValue(keyAddAction, {
        //     key: "showPopup",
        //     type: 3,
        //     name: "Show Popup",
        //     description: "",
        //     atomLabel: "Popup",
        //     settings: [
        //         delay
        //     ]
        // });

        //set event
        store.setValue(keyAddEvent, {
          key: 'addToCartSuccess',
          name: 'Added To Cart',
          type: 2,
          description: 'Trigger when the Product added to cart via Ajax',
          atomLabel: 'Product',
        });
      }
    };

    this.initWithLabel = function (label, moduleId, icon, ver, snippet, existingContent) {
      $element
        .attr('id', 'm-' + moduleId)
        .addClass('module-wrap')
        .attr('data-label', label)
        .attr('data-icon', icon)
        .attr('data-ver', ver)
        .attr('data-id', moduleId);

      const $snippet = jQuery('<div/>').html(snippet);
      const $template = $snippet.find('.template');
      const $data = $snippet.find('.data');
      const $script = $snippet.find('.script');
      const $style = $snippet.find('.style');

      let template = $template.html();

      let jsonData = {};
      if ($data.length > 0) {
        var jsonHtml = $data.text().trim();

        if (jsonHtml != undefined && jsonHtml != '') {
          jsonHtml = jsonHtml.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

          var moduleIdSlug = moduleId.toString().replace(/-/g, '');
          jsonHtml = jsonHtml.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);
        } else {
          jsonHtml = '{ "items": [] }';
        }
        try {
          jsonData = jQuery.parseJSON(jsonHtml);
        } catch (err) {
          console.log(err.message);
        }

        if (_this.settings.notInitChildren && jsonData.items) {
          jsonData.items.forEach(function (item) {
            if (item.content) {
              item.content = '';
            }

            if (item.content1) {
              item.content1 = '';
            }
          });
        }
      }

      let script = $script.html();
      if (script != undefined) {
        script = script.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

        // module slugs for Tabs element inside Product List or Related Products or Artice List
        var moduleIdSlug = moduleId.toString().replace(/-/g, '');
        script = script.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);

        $script.html(script);
      }

      let style = $style.html();
      if (style != undefined) {
        style = style.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

        var moduleIdSlug = moduleId.toString().replace(/-/g, '');
        style = style.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);

        $style.html(style).attr('type', 'text/css');
      }

      // them id cho tat ca cac row, columns ben trong template
      const $wrapper = jQuery('<div>').append(template);
      $wrapper.find('.gf_row').each(function () {
        const id = HELPER.MakeId();
        jQuery(this).attr('id', 'r-' + id + '-{{forloop.index}}');
      });

      $wrapper.find('.gf_column').each(function () {
        const id = HELPER.MakeId();
        jQuery(this).attr('id', 'c-' + id + '-{{forloop.index}}');
      });
      template = $wrapper.html();

      let html = '';
      if (existingContent != '') {
        html = existingContent;
        $element.html(html);
      }

      // tu dong them id cho cac items
      if (jsonData['items'] != undefined) {
        for (let i = 0; i < jsonData['items'].length; i++) {
          jsonData['items'][i]['id'] = 'i-' + moduleId + i;
        }
      }
      var jsonHtml = JSON.stringify(jsonData, null, '\t');
      $data.text(jsonHtml);

      HELPER.addContentBk('<div id="module-' + moduleId + '">' + $snippet.html() + '</div>');
      if (label == 'LAI AliExpress Reviews') {
        if (!window.gemDragging) {
          window.gemDragging = {};
          window.gemDragging.newLAI = [];
        }
        if (window.gemDragging && window.gemDragging.newLAI && window.gemDragging.newLAI.length >= 0) {
          let found = false;
          const newLocal = window.gemDragging.newLAI;
          newLocal.forEach((element) => {
            if (element.id == 'm-' + moduleId) {
              element.status = 'new';
              found = true;
            }
          });
          try {
            window.gemDragging.newLAI = JSON.parse(JSON.stringify(newLocal));
          } catch (err) {}
          if (!found) {
            window.gemDragging.newLAI.push({ id: 'm-' + moduleId, status: 'new' });
          }
        }
      }
      return false;
    };

    this.getArticleData = async function (callback) {
      const jsonData = {
        article: {},
      };
      const $articleList = $element.closest('[data-articles]');
      if ($articleList.length > 0) {
        var index = 0;
        if ($element.attr('data-index') != undefined) {
          var index = parseInt($element.attr('data-index')) - 1;
        }
        const jsonList = jQuery.parseJSON($articleList.attr('data-articles'));
        if (jsonList['articles'][index] != undefined) {
          jsonData.article = jsonList['articles'][index];
        }
        callback(jsonData);
      } else {
        const articleId = $element.children('.module').attr('data-aid');
        const shop = $gfFrame.data('gfframe').getShopDomain();
        const data = {
          shop: shop,
          articleId: articleId,
        };

        _this.showLoading();
        try {
          const res = await GET(api.getArticles().url, data);
          const jsonData = res.data;
          callback(jsonData);
          _this.hideLoading();
        } catch (err) {
          $gfFrame.data('gfframe').hideLoading();
          _this.hideLoading();

          if (articleId != '') {
            $element.children('.module').attr('data-bid', '').attr('data-bhandle', '');
            const moduleId = _this.getModuleId();
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            let fields = [];
            try {
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'blog') {
                fields[i].default_value = '';
              }
              if (fields[i].name == 'bId') {
                fields[i].default_value = '';
              }
              if (fields[i].name == 'bHandle') {
                fields[i].default_value = '';
              }
            }
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });

            return _this.getArticleData(callback);
          } else {
            callback(jsonData);
            HELPER.showNotify('There are some errors occurred please try again. Error: 100', 'error');
          }
        }
      }
      return false;
    };

    this.getSettingById = function (id) {
      const keySettings = HELPER.getKeyDataSetting(base._settings, _this.getModuleId());
      const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
      let fields = [];
      try {
        fields = jQuery.parseJSON($settings);
      } catch (err) {
        console.log(err.message);
      }
      for (let i = 0; i < fields.length; i++) {
        if (fields[i].id === id) {
          return fields[i];
        }
      }
    };

    this.getDataSettings = function () {
      const keySettings = HELPER.getKeyDataSetting(base._settings, _this.getModuleId());
      const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
      let fields = [];
      try {
        fields = jQuery.parseJSON($settings);
      } catch (err) {
        console.log(err.message);
      }
      return fields;
    };

    this.getRelatedProductsData = async function (callback) {
      let jsonData = {
        collection: {
          product: {},
        },
      };
      var productId = $element.children('.module').attr('data-pid');
      if (productId == 'auto') {
        $gryffBody.find('[data-label="Product"]').each(function () {
          if (jQuery(this).attr('data-status') == 'default' || jQuery(this).attr('data-status') == 'dynamic') {
            productId = jQuery(this).children('.module').attr('data-pid');
          }
        });
      }
      if (productId == undefined) {
        productId = 'auto';
      }
      const limit = parseInt($element.find('.module').attr('data-limit'));

      let excludes = '';
      if ($element.find('.module').attr('data-excludes') != undefined) {
        excludes = $element.find('.module').attr('data-excludes');
      }
      const relatedListData = HELPER.searchRelatedListInList(productId, limit, excludes);

      let isLoading = false;
      if (!jQuery.isEmptyObject(relatedListData)) {
        if (limit <= relatedListData['limit']) {
          jsonData = relatedListData['list'];
          callback(jsonData);
          window._isFirstLoadRelated = false;
        } else {
          isLoading = true;
        }
      } else {
        isLoading = true;
      }

      if (isLoading) {
        const shop = $gfFrame.data('gfframe').getShopDomain();

        var data = {
          shop: shop,
          productId: productId,
          limit: limit,
          excludes: excludes,
        };

        _this.showLoading();
        try {
          const res = await GET(api.getRelatedProducts().url, data);
          const jsonData = res.data;
          _this.hideLoading();
          if (jsonData.collection) {
            for (var i = 0; i < jsonData.collection.product.collections.length; i++) {
              const collection = jsonData.collection.product.collections[i];

              var productId = jsonData.collection.product.id;
              const productHandle = jsonData.collection.product.handle;
              // set collection id
              $element
                .children('.module')
                .attr('data-cid', collection.id)
                .attr('data-pId', productId)
                .attr('data-pHandle', productHandle);

              const products = [];
              for (var k = 0; k < collection.products.length; k++) {
                const id = collection.products[k].id;
                if (id != productId) {
                  products.push(collection.products[k]);
                }
              }
              collection.products = products;

              for (var k = 0; k < collection.products.length; k++) {
                const productData = collection.products[k];

                var data = HELPER.searchProductInList(productData.id);
                if (jQuery.isEmptyObject(data)) {
                  HELPER.updateProductInList(productData);
                }
              }

              const relatedListObject = {
                pid: productId,
                limit: limit,
                excludes: excludes,
                list: jsonData,
              };

              HELPER.updateRelatedListInList(relatedListObject);
            }
          }

          callback(jsonData);
          window._isFirstLoadRelated = false;
        } catch (err) {
          $gfFrame.data('gfframe').hideLoading();
          _this.hideLoading();

          if (productId != 'auto') {
            $element.children('.module').attr('data-pid', 'auto').attr('data-phandle', 'auto');
            const moduleId = _this.getModuleId();
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            let fields = [];
            try {
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }
            for (var i = 0; i < fields.length; i++) {
              if (fields[i].name == 'product') {
                fields[i].default_value = 'Auto';
              }
              if (fields[i].name == 'pid') {
                fields[i].default_value = 'auto';
              }
              if (fields[i].name == 'pHandle') {
                fields[i].default_value = 'auto';
              }
            }
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });
            return _this.getRelatedProductsData(callback);
          } else {
            callback(jsonData);
            HELPER.showNotify('There are some errors occurred please try again. Error: 108', 'error');
          }
        }
      }

      return false;
    };

    this.getProductListData = async function (callback) {
      const jsonData = {
        products: [],
      };

      let collectionId = 'auto';
      let limit = 12;

      const moduleName = _this.getModuleName();

      //hotfix for Collection Dupplicate API
      let isCollection = false;
      switch (moduleName) {
        case 'Collection Banner':
        case 'Collection Title':
        case 'Collection Desc':
        case 'Collection Toolbar':
          isCollection = true;
          if (!jQuery.isEmptyObject(window._collectionJsonData)) {
            //khi đã có dữ liệu
            callback(window._collectionJsonData);
            return false;
          } else {
            //chưa có dữ liệu lưu hết callback vào 1 list global để gọi sau khi có dữ liệu
            window._collectionStackElement.push($element);
          }
        default:
          break;
      }

      if (moduleName == 'Product List') {
        collectionId = $element.children('.module').attr('data-cid');
        limit = parseInt($element.find('.module').attr('data-limit'));
      } else {
        var $productList = $gryffEditor.find('.module-wrap[data-label="Product List"]').first();
        if ($productList.length > 0) {
          collectionId = $productList.children('.module').attr('data-cid');
          limit = parseInt($productList.find('.module').attr('data-limit'));
        }
      }

      const productListData = HELPER.searchProductListInList(collectionId, limit);

      let isLoading = false;
      if (!jQuery.isEmptyObject(productListData)) {
        if (limit <= productListData['limit']) {
          jsonData.products = productListData['list'];
          if (collectionId != '' && collectionId != 'auto' && jsonData.products.length == 0) {
            var $productList = $element;
            if (moduleName != 'Product List') {
              $productList = $gryffEditor.find('.module-wrap[data-label="Product List"]').first();
            }
            const productListId = $productList.attr('data-id');
            const keySettings = HELPER.getKeyDataSetting(base._settings, productListId);
            const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            var fields = [];
            try {
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }
            for (var i = 0; i < fields.length; i++) {
              if (fields[i].name == 'collection') {
                fields[i].default_value = 'All Collections';
              }
              if (fields[i].name == 'cId') {
                fields[i].default_value = 'auto';
              }
              if (fields[i].name == 'cHandle') {
                fields[i].default_value = 'latest-products';
              }
            }

            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });
            return _this.refresh();
          } else {
            window._isFirstLoadCollection = false;
            window._collectionJsonData = jsonData;
            callback(jsonData);
          }
        } else {
          isLoading = true;
        }
      } else {
        isLoading = true;
      }
      if (isLoading) {
        _this.showLoading();

        //hotfix for Collection Dupplicate API
        if (isCollection && !window._isFirstLoadCollection) {
          return false;
        }
        window._isFirstLoadCollection = false;
        try {
          let products = []
          if (checkKeyValid('getProductsInListByCollectionId')) {
            const ids = [{ cid: collectionId, limit: limit }];
            const params = {
              cids: JSON.stringify(ids),
            };
            const res = await GET(api.getProductsByCollectionIds().url, params)
            const jsonData = res.data;
            if (jsonData && jsonData.products && jsonData.products.length) {
              const productListData = jsonData.products[0]
              if (!jQuery.isEmptyObject(productListData)) {
                products = productListData.list
                window._productListArray.push(productListData);
                const collection = {
                  id: productListData.cid,
                  published_at: productListData.publishedAt,
                };
                HELPER.updateCollectionInList(collection);
              }
            }
          } else {
            const shop = $gfFrame.data('gfframe').getShopDomain();
            const params = {
              shop: shop,
              collectionId: collectionId,
              limit: limit,
            };
            const res = await GET(api.getProducts().url, params);
            const jsonData = res.data;
            products = jsonData.products
          }
          _this.hideLoading();
          const productlistObject = {
            cid: collectionId,
            limit: limit,
            list: products,
          };
          HELPER.updateProductListInList(productlistObject);

          for (let i = 0; i < products.length; i++) {
            const productData = products[i];
            // check the nay de uu tien khi load san pham no update variant.available
            const data = HELPER.searchProductInList(productData.id);
            if (jQuery.isEmptyObject(data)) {
              HELPER.updateProductInList(productData);
            }
          }
          callback({products});

          //hotfix for Collection Dupplicate API
          window._collectionJsonData = {products};
          //run all callback
          let count = 0;
          while (window._collectionStackElement.length && count < 100) {
            count++;
            const _cElement = window._collectionStackElement.pop();
            if (_cElement) {
              _cElement.data('gfmodule').refresh();
            }
          }
        } catch (err) {
          $gfFrame.data('gfframe').hideLoading();
          _this.hideLoading();
          if (collectionId != 'auto') {
            $element.children('.module').attr('data-cid', 'auto').attr('data-chandle', 'latest-products');
            const moduleId = _this.getModuleId();
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            var fields = [];
            try {
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }
            for (var i = 0; i < fields.length; i++) {
              if (fields[i].name == 'collection') {
                fields[i].default_value = 'All Collections';
              }
              if (fields[i].name == 'cId') {
                fields[i].default_value = 'auto';
              }
              if (fields[i].name == 'cHandle') {
                fields[i].default_value = 'latest-products';
              }
            }
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });
            return _this.getProductListData(callback);
          } else {
            callback(jsonData);
            HELPER.showNotify('There are some errors occurred please try again. Error: 108', 'error');

            //hotfix for Collection Dupplicate API
            window._collectionJsonData = jsonData;
            //run all callback
            let count = 0;
            while (window._collectionStackElement.length && count < 100) {
              count++;
              const _cElement = window._collectionStackElement.pop();
              if (_cElement) {
                _cElement.data('gfmodule').refresh();
              }
            }
          }
        }
      }
      return false;
    };

    this.getProductData = function (callback) {
      var jsonData = {
        product: {},
      };
      if ($element.closest('[data-label="Product List"]').length > 0) {
        var $productList = $element.closest('[data-label="Product List"]');
        if ($productList.length > 0) {
          const collectionId = $productList.children('.module').attr('data-cid');
          var limit = $productList.children('.module').attr('data-limit');
          var productListData = HELPER.searchProductListInList(collectionId, limit);

          if (!jQuery.isEmptyObject(productListData)) {
            var index = 0;
            if ($element.attr('data-index') != undefined) {
              var index = parseInt($element.attr('data-index')) - 1;
            }
            var productId = productListData.list[index].id;
          } else {
            var productId = 'auto';
          }
        }
      } else if ($element.closest('[data-label="Related Products"]').length > 0) {
        // todo: check this
        var $productList = $element.closest('[data-label="Related Products"]');

        if ($productList.length > 0) {
          var productId = $productList.children('.module').attr('data-pid');
          if (productId == 'auto') {
            $gryffBody.find('[data-label="Product"]').each(function () {
              if (jQuery(this).attr('data-status') == 'default' || jQuery(this).attr('data-status') == 'dynamic') {
                productId = jQuery(this).children('.module').attr('data-pid');
              }
            });
          }
          if (productId == undefined) {
            productId = 'auto';
          }
          var limit = $productList.children('.module').attr('data-limit');

          let excludes = '';
          if ($productList.find('.module').attr('data-excludes') != undefined) {
            excludes = $productList.find('.module').attr('data-excludes');
          }

          var productListData = HELPER.searchRelatedListInList(productId, limit, excludes);

          if (!jQuery.isEmptyObject(productListData)) {
            var index = 0;
            if ($element.attr('data-index') != undefined) {
              var index = parseInt($element.attr('data-index')) - 1;
            }

            var jsonData = productListData.list;

            if (
              jsonData.collection != undefined &&
              jsonData.collection.product != undefined &&
              jsonData.collection.product.collections.length > 0
            ) {
              var productId = jsonData.collection.product.collections[0].products[index].id;
            } else {
              var productId = 'auto';
            }
          } else {
            var productId = 'auto';
          }
        }
      } else {
        var productId = $element.children('.module').attr('data-pid');
      }

      const productData = HELPER.searchProductInList(productId);

      if (!jQuery.isEmptyObject(productData)) {
        jsonData.product = productData;
        callback(jsonData, productId);
      } else {
        // load ajax
        const shop = $gfFrame.data('gfframe').getShopDomain();
        if (!productId) productId = 'auto'
        const data = {
          shop: shop,
          productId: productId,
        };

        app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', true);
        app.$store.commit('page/SET_FRAME_LOADING_MESSAGE', 'Loading Product');

        _this.showLoading();

        const req = api.getProduct();
        let reqURL = req.url;
        if (!/(http|ftp|ws)s{0,1}:\/\//.test(reqURL)) {
          reqURL = config.serverDomain() + reqURL;
        }
        const gemSession = app.$store.getters['app/gemSession'] || '';
        jQuery.ajax({
          type: req.type,
          url: reqURL,
          headers: {
            'Gem-Session': gemSession
          },
          data: data,
          dataType: 'json',
          async: false,
          xhrFields: {
            withCredentials: true,
          },
          success: function (jsonData) {
            _this.hideLoading();
            app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);
            // app.$store.commit('page/SET_FRAME_LOADING_MESSAGE', 'Loading Product');

            let productData = {}
            if (jsonData != undefined) {
              productData = jsonData.product;
            }

            if (!productData || !productData.id) {
              getLatestProduct((product) => {
                productId = 'auto'
                _this.handleProductData(callback, product, productId)
              });
            } else {
              _this.handleProductData(callback, productData, productId)
            }
          },
          error: function () {
            app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);
            if (productId != 'auto') {
              $element.children('.module').attr('data-pid', 'auto').attr('data-phandle', 'auto');
              const moduleId = _this.getModuleId();
              const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
              const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
              let fields = [];
              try {
                fields = jQuery.parseJSON($settings);
              } catch (err) {
                console.log(err.message);
              }
              for (let i = 0; i < fields.length; i++) {
                if (fields[i].name == 'product') {
                  fields[i].default_value = 'Auto';
                }
                if (fields[i].name == 'pid') {
                  fields[i].default_value = 'auto';
                }
                if (fields[i].name == 'pHandle') {
                  fields[i].default_value = 'auto';
                }
              }
              app.$store.commit('editor/SET_DATA_SETTINGS', {
                id: keySettings,
                value: JSON.stringify(fields),
              });
              return _this.getProductData(callback);
            } else {
              let jsonData = {
                product: productData
              }
              callback(jsonData, productId);
              HELPER.showNotify('There are some errors occurred please try again. Error: 100', 'error');
            }
          },
        });
      }
      return false;
    };

    this.getCollectionData = async function (callback) {
      const collectionData = {
        collection: {},
      };
      const moduleName = _this.getModuleName();
      let collectionId = 'auto';
      if (moduleName == 'Product List') {
        collectionId = $element.children('.module').attr('data-cid');
      } else {
        const $productList = $gryffEditor.find('.module-wrap[data-label="Product List"][data-status="dynamic"]');
        if ($productList.length > 0) {
          collectionId = $productList.children('.module').attr('data-cid');
        }
      }

      if (collectionId != 'auto') {
        const searchCollection = HELPER.searchCollectionInList(collectionId);
        if (!jQuery.isEmptyObject(searchCollection)) {
          collectionData.collection = searchCollection;
          callback(collectionData, collectionId);
        } else {
          const ids = [collectionId];
          // load ajax
          const api = '/api/collection/getCollectionsByIds.html';
          const data = {
            ids: ids.join(','),
          };

          app.$store.commit('page/SET_FRAME_LOADING_MESSAGE', 'Loading Product');
          app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', true);
          try {
            const res = await GET(api, data);
            const jsonData = res.data;

            app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);
            for (let i = 0; i < jsonData.collections.length; i++) {
              HELPER.updateCollectionInList(jsonData.collections[i]);
              if (jsonData.collections[i].id == collectionId) {
                collectionData.collection = jsonData.collections[i];
              }
            }
            if (mode == 'dev') {
              collectionData.collection = jsonData.collections[0];
              callback(collectionData, collectionId);
            } else {
              callback(collectionData, collectionId);
            }
          } catch (err) {
            app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);

            callback(collectionData, collectionId);
            HELPER.showNotify('There are some errors occurred please try again. Error: 100', 'error');
          }
        }
      } else {
        _this.getProductListData(function (jsonData) {
          collectionData.collection = {
            sort_order: 'manual',
            products_count: jsonData.products.length,
          };
          callback(collectionData, collectionId);
        });
      }
      return false;
    };

    this.loadDynamicData = async function (moduleName, $input, callback) {
      switch (moduleName) {
        case 'Related Products':
          _this.runTemplate();

          $element.find('.module').hide();
          $element.css('min-height', '300px');
          _this.getRelatedProductsData(function (jsonData) {
            if (jsonData['collection']['product'].length == 0) {
              $element
                .find('.module')
                .html('<span style="display: block;text-align:center;">Products not found.</span>');

              HELPER.showNotify('Products not found.', 'error');
            } else {
              // runTemplate again
              const templateTmp = $element.html();
              const html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);

              $element.html(html);

              $element.css('min-height', 'auto');
              $element.find('.module').show();
            }
            callback(jsonData);
          });

          break;

        case 'Product List':
          _this.runTemplate();

          $element.css('min-height', '300px');
          $element.find('.module').hide();

          if (!window._isFirstLoadList) {
            const currentCHandle = $element.find('.module').attr('data-chandle');
            if (currentCHandle == 'latest-products') {
              const url = $divTopBar.find('#gf-preview').attr('href') || '';
              const matches = new RegExp(/(?:^|&)collection=([^&]*)/).exec(url);
              let cHandle = 'latest-products';
              if (matches && matches.length && matches[1]) {
                cHandle = matches[1];
                $element.find('.module').attr('data-chandle', cHandle);
              }
            }

            _this.getProductListData(function (jsonData) {
              if (jsonData['products'].length == 0) {
                $element
                  .find('.module')
                  .html('<span style="display: block;text-align:center;">Products not found.</span>');

                HELPER.showNotify('Products not found.', 'error');
              } else {
                // runTemplate again
                const templateTmp = $element.html();
                const html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);
                $element.html(html);

                $element.css('min-height', 'auto');
                $element.find('.module').show();

                if ($element.attr('data-status') == 'default' || $element.attr('data-status') == 'dynamic') {
                  const gType = $gfFrame.data('gfframe').getPageType();
                  const collectionHandle = $element.children('.module').attr('data-chandle');

                  if (gType == 'template-collection') {
                    let preViewPageLink = $gryffEditor.data('gryffeditor').getPreviewPageLink();
                    preViewPageLink = preViewPageLink.replace(/&collection(.*)/, '&collection=' + collectionHandle);

                    let viewPageLink = $gryffEditor.data('gryffeditor').getViewPageLink();
                    viewPageLink = viewPageLink.replace(/\/collections\/(.*)/, '/collections/' + collectionHandle);

                    $gryffEditor.data('gryffeditor').setPreviewPageLink(preViewPageLink);
                    $gryffEditor.data('gryffeditor').setViewPageLink(viewPageLink);
                  }
                }
              }
              callback();
            });
          }
          break;

        case 'Paginator':
          _this.runTemplate();

          $element.find('.module').hide();
          var templateTmp = $element.html();
          var jsonHtml = jQuery.parseJSON(_this.getModuleData());
          var html = _this.getModuleHtmlByTemplate(templateTmp, jsonHtml);
          $element.html(html);
          $element.find('.module').show();

          callback();
          break;

        // COLLECTION 2019
        case 'Collection Toolbar':
          _this.runTemplate();
          $element.find('.module')[0].style = 'display: none !important';
          _this.getProductListData(function (jsonData) {
            // Extract tags
            const tags = [];
            jsonData.products.forEach(function (product) {
              const productTags = Array.isArray(product.tags) ? product.tags : product.tags.split(',')
              productTags.forEach(function (tag) {
                const tagTrim = tag.trim();
                if (tagTrim != '' && tags.indexOf(tagTrim) == -1) {
                  tags.push(tagTrim);
                }
              });
            });
            jsonData.tags = tags;
            _this.getCollectionData(function (collection) {
              collection = collection.collection;
              if (collection.sort_order) {
                jsonData.default_sort_by = collection.sort_order;
              } else {
                jsonData.default_sort_by = 'manual';
              }
              if (collection.products_count) {
                jsonData.products_count = collection.products_count;
              } else {
                jsonData.products_count = 12;
              }
              const templateTmp = $element.html();

              const jsonHtml = jQuery.parseJSON(_this.getModuleData());

              const html = _this.getModuleHtmlByTemplate(templateTmp, Object.assign(jsonData, jsonHtml));
              $element.html(html);
              $element.find('.module').show();

              callback();
            });
          });

          break;
        case 'Collection Banner':
        case 'Collection Title':
        case 'Collection Desc':
          _this.runTemplate();
          $element.find('.module').hide();

          var jsonData = {};
          _this.getCollectionData(function (collection) {
            collection = collection.collection;

            if (moduleName == 'Collection Banner') {
              if (collection.image) {
                jsonData.image = collection.image;
              } else {
                jsonData.image = {
                  src: '',
                };
              }
            } else if (moduleName == 'Collection Title') {
              if (collection.title) {
                jsonData.title = collection.title;
              } else {
                jsonData.title = 'Collection title';
              }
            } else if (moduleName == 'Collection Desc') {
              if (collection.body_html) {
                jsonData.description = collection.body_html;
              } else {
                jsonData.description = 'Collection description';
              }
            }

            const templateTmp = $element.html();

            const jsonHtml = jQuery.parseJSON(_this.getModuleData());

            const html = _this.getModuleHtmlByTemplate(templateTmp, Object.assign(jsonData, jsonHtml));
            $element.html(html);
            $element.find('.module').show();

            callback();
          });
          break;
        case 'Article List':
          var isLoading = false;
          var oldJsonHtml = '';

          if (moduleName == 'Article List') {
            var oldid = $element.children('.module').attr('data-bid');
            var oldLimit = $element.children('.module').attr('data-limit');

            if (checkKeyValid("syncBHandleForArticleList")) {
              await _this.syncBHandleForArticleList()
            }
          }
          if ($element.children('.module').attr('data-articles') != undefined) {
            oldJsonHtml = $element.children('.module').attr('data-articles');
          } else {
            isLoading = true;
          }

          _this.runTemplate();

          $element.css('min-height', '300px');
          $element.find('.module').hide();

          var shop = $gfFrame.data('gfframe').getShopDomain();
          if (moduleName == 'Article List') {
            let blogId = $element.find('.module').attr('data-bId');
            if (blogId == undefined) {
              blogId = $element.find('.module').attr('data-bid');
            }

            if (blogId == '') {
              $element
                .find('.module')
                .html(
                  '<span style="display: block;text-align:center;padding: 20px 0">Choose a blog from left sidebar to show articles.</span>',
                );
              $element.find('.module').show();
              $element.css('min-height', 'auto');

              callback();
              return false;
            }

            const limit = parseInt($element.find('.module').attr('data-limit'));

            var data = {
              shop: shop,
              blogId: blogId,
              limit: limit,
            };
            if (oldid != blogId) {
              isLoading = true;
            }
            if (oldLimit != limit) {
              isLoading = true;
            }
          }

          if (isLoading) {
            _this.showLoading();

            // should check and synce body html with getarticles.html from link picker
            try {
              const res = await GET(api.getArticles().url, data);
              const jsonData = res.data;
              if (moduleName == 'Article List' && jsonData['articles'].length == 0) {
                $element
                  .find('.module')
                  .html('<span style="display: block;text-align:center;">Articles not found.</span>');

                HELPER.showNotify('Articles not found.', 'error');
                var jsonHtml = JSON.stringify(jsonData);
                $element.find('.module').attr('data-articles', jsonHtml);
              } else {
                // runTemplate again
                var templateTmp = $element.html();

                // Pattern remove all script tag in article content
                const pattern = /<script[\s\S]*?>[\s\S]*?<\/script>/gi;

                for (let i = 0; i < jsonData['articles'].length; i++) {
                  if (jsonData['articles'][i].body_html) {
                    jsonData['articles'][i].body_html = jsonData['articles'][i].body_html.replace(pattern, '');
                  } else {
                    jsonData['articles'][i].body_html = '';
                  }
                }
                jsonData['articles'] = jsonData['articles'].sort(function (a, b) {
                  return new Date(a.created_at) <= new Date(b.created_at) ? 1 : -1;
                });

                var html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);
                $element.html(html);

                var jsonHtml = JSON.stringify(jsonData);
                $element.find('.module').attr('data-articles', jsonHtml);
              }

              $element.css('min-height', 'auto');
              $element.find('.module').show();

              callback();
              _this.hideLoading();
            } catch (err) {
              HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
              _this.hideLoading();

              $element.css('min-height', 'auto');
              $element.find('.module').show();
            }
          } else {
            try {
              var jsonData = jQuery.parseJSON(oldJsonHtml);

              if (moduleName == 'Article List' && jsonData['articles'].length == 0) {
                $element
                  .find('.module')
                  .html('<span style="display: block;text-align:center;">Articles not found.</span>');

                HELPER.showNotify('Articles not found.', 'error');
              } else {
                // runTemplate again
                var templateTmp = $element.html();
                var html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);

                $element.html(html);

                $element.css('min-height', 'auto');
                $element.find('.module').show();

                $element.find('.module').attr('data-articles', oldJsonHtml);
              }
            } catch (err) {
              console.log(err.message);
            }
            callback();
          }
          break;

        case '(P) Meta':
          var data = {};

          if ($element.closest('[data-label="Product"]').length > 0) {
            var productId = $element.closest('[data-label="Product"]').children('.module').attr('data-pid');
            var productData = HELPER.searchProductInList(productId);

            if (!jQuery.isEmptyObject(productData)) {
              try {
                var jsonHtml = '{ "product": ' + JSON.stringify(productData) + '}';
                data = jQuery.parseJSON(jsonHtml);
                if (!jQuery.isEmptyObject(data)) {
                  _this.runTemplate(data);
                } else {
                  $element.remove();

                  HELPER.showNotify('This field is dropped to Product only.', 'error');
                }
              } catch (err) {
                console.log(err.message);
                $element.remove();
              }
            }
          }
          callback();
          break;

        case '(P) Title':
        case '(P) Vendor':
        case '(P) SKU':
        case 'Ultimate Sales Boost':
        case 'WideBundle':
        case '(P) File Upload':
        case '(P) Description':
        case '(P) Price':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Quantity':
        case '(P) Variants':
        case '(P) Swatches':
          // case '(P) Meta':
          var data = {};

          if ($element.closest('[data-label="Product"]').length > 0) {
            var productId = $element.closest('[data-label="Product"]').children('.module').attr('data-pid');
            var productData = HELPER.searchProductInList(productId);

            if (!jQuery.isEmptyObject(productData)) {
              try {
                var jsonHtml = '{ "product": ' + JSON.stringify(productData) + '}';
                data = jQuery.parseJSON(jsonHtml);

                if (!jQuery.isEmptyObject(data)) {
                  // Run css only
                  if ($input != undefined && $input.length > 0) {
                    if (moduleName == '(P) Swatches') {
                      const inputName = $input.attr('name');
                      switch (inputName) {
                        case 'active-outline-size':
                        case 'active-outline-color':
                          // _this.runTemplate();
                          break;
                        default:
                          _this.runTemplate(data);
                          break;
                      }
                    } else {
                      _this.runTemplate(data);
                    }
                  } else {
                    _this.runTemplate(data);
                  }
                } else {
                  $element.remove();

                  HELPER.showNotify('This field is dropped to Product only.', 'error');
                }
              } catch (err) {
                console.log(err.message);
                $element.remove();
              }
            }
          }
          callback();
          break;

        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
          var data = {};

          if ($element.closest('[data-article]').length > 0) {
            const $dataProvider = $element.closest('[data-article]');
            const dataArticle = $dataProvider.attr('data-article');
            try {
              data = jQuery.parseJSON(dataArticle);
              if (!jQuery.isEmptyObject(data)) {
                _this.runTemplate(data);
              } else {
                $element.remove();

                HELPER.showNotify('This field is dropped to Product only.', 'error');
              }
            } catch (err) {
              console.log(err.message);
              $element.remove();
            }
          }
          callback();
          break;

        case 'Article':
          _this.runTemplate();
          _this.getArticleData(function (jsonData) {
            const jsonHtml = JSON.stringify(jsonData);
            $element.find('.module').attr('data-article', jsonHtml);

            const jsonDataArticle = jsonData['article'];
            let articleTitle, articleId, articleHandle;
            if (jsonDataArticle) {
              articleTitle = jsonDataArticle.title;
              articleId = jsonDataArticle.id;
              articleHandle = jsonDataArticle.handle;
            }

            var index = 0;
            if ($element.attr('data-index') != undefined) {
              var index = parseInt($element.attr('data-index')) - 1;
            }
            $element
              .find('.module')
              .attr('data-aid', articleId)
              .attr('data-aHandle', articleHandle)
              .attr('data-index', index + 1);

            const moduleId = _this.getModuleId();
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            let fields = [];
            try {
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }

            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'article') {
                fields[i].default_value = articleTitle;
              }
              if (fields[i].name == 'aid') {
                fields[i].default_value = articleId;
              }
              if (fields[i].name == 'aHandle') {
                fields[i].default_value = articleHandle;
              }
            }
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });
            callback();
          });
          break;

        case 'Product':
          _this.runTemplate();

          $element.css('min-height', '300px');
          $element.find('.module').hide();

          if (!window._isFirstLoad) {
            _this.getProductData(function (jsonData, pId) {
              let pResult = jsonData['product'];
              if (!pResult || !pResult.id) {
                pResult = window._productLatest
              }
              try {
                // if cant load
                if (pResult != undefined && pResult.id != undefined) {

                  const gType = $gfFrame.data('gfframe').getPageType();
                  if (gType === 'template-product') {
                    assignProduct.renderDemoProductMessage();
                  }

                  /* avoid infinity loop inside product description when customer copy gempages code into to it */
                  const body_html = pResult.body_html;
                  const $bodyHtml = jQuery('<div />').html(body_html);
                  $bodyHtml.find('.module-wrap').attr('class', '').attr('data-label', '');
                  $bodyHtml.find('.element-wrap').attr('class', '').attr('data-label', '');
                  $bodyHtml.find('.gf_row').attr('class', '').attr('data-label', '');
                  pResult.body_html = $bodyHtml.html();

                  $element.css('min-height', 'auto');
                  $element.find('.module').show();

                  // selected_or_first_available_variant cho liquid
                  let selectedVariant = {};
                  let selectedVariantIndex = 0;
                  let featured_image = '';
                  const last = ''; // last image

                  // set available
                  for (var i = 0; i < pResult['variants'].length; i++) {
                    const variant = pResult['variants'][i];

                    const inventory = parseInt(variant['inventory_quantity']);
                    const inventoryManagement = variant['inventory_management'];
                    const inventoryPolicy = variant['inventory_policy'];

                    if (inventory > 0 || inventoryManagement != 'shopify' || inventoryPolicy != 'deny') {
                      variant.available = true;
                    } else {
                      variant.available = false;
                    }
                  }
                  // selected variant
                  if (
                    $element.children('.module').attr('data-variant') != undefined &&
                    $element.children('.module').attr('data-variant') != 'auto'
                  ) {
                    const variantId = $element.children('.module').attr('data-variant');
                    for (var i = 0; i < pResult['variants'].length; i++) {
                      if (variantId.toString() == pResult['variants'][i].id.toString()) {
                        selectedVariantIndex = i;
                        break;
                      }
                    }
                  } else {
                    // or first available
                    for (var i = 0; i < pResult['variants'].length; i++) {
                      if (pResult['variants'][i].available) {
                        selectedVariantIndex = i;
                        break;
                      }
                    }
                  }

                  if (pResult['variants'] != undefined && pResult['variants'].length > 1) {
                    selectedVariant = pResult['variants'][selectedVariantIndex];

                    outer_loop: for (var i = 0; i < pResult['images'].length; i++) {
                      const selectedVariantImage = pResult['images'][i];

                      const variantIds = selectedVariantImage.variant_ids;
                      for (let j = 0; j < variantIds.length; j++) {
                        if (selectedVariant.id.toString() == variantIds[j].toString()) {
                          selectedVariant.image = selectedVariantImage.src;
                          featured_image = selectedVariantImage.src;
                          break outer_loop;
                        }
                      }
                    }
                    // set featured_image
                    if (
                      $element.children('.module').attr('data-variant') != undefined &&
                      $element.children('.module').attr('data-variant') != 'auto'
                    ) {
                      if (featured_image != '') {
                        selectedVariant.featured_image = featured_image;
                      } else if (pResult.image != undefined && pResult.image.src != '') {
                        selectedVariant.featured_image = pResult.image.src;
                      }
                    } else {
                      if (pResult.image != undefined && pResult.image.src != '') {
                        selectedVariant.featured_image = pResult.image.src;
                      } else {
                        selectedVariant.featured_image = '';
                      }
                    }
                    pResult.selected_or_first_available_variant = selectedVariant;
                    pResult.selected = selectedVariant;
                  } else if (pResult['variants'] != undefined && pResult['variants'].length == 1) {
                    pResult.selected_or_first_available_variant = pResult['variants'][0];
                    pResult.selected = pResult['variants'][0];

                    if (pResult['image'] != undefined) {
                      pResult.selected_or_first_available_variant.featured_image = pResult['image'].src;
                      pResult.selected.featured_image = pResult['image'].src;
                    } else {
                      pResult.selected_or_first_available_variant.featured_image = '';
                    }
                  }

                  /* --- */
                  const productData = jQuery.parseJSON(JSON.stringify(pResult));
                  HELPER.updateProductInList(productData);
                  // Update product dynamic in window
                  if (_this.isDynamicProduct()) {
                    updateDynamicProduct(productData);
                  }
                  const productTitle = pResult.title;
                  const productId = pResult.id;
                  const productHandle = pResult.handle;

                  var index = 0;
                  if ($element.attr('data-index') != undefined) {
                    var index = parseInt($element.attr('data-index')) - 1;
                  }
                  $element
                    .find('.module')
                    .attr('data-pid', productId)
                    .attr('data-pHandle', productHandle)
                    .attr('data-index', index + 1);

                  const dataIndex = $element.attr('data-index'); // Nếu có data-index là product nằm trong element khác -> không xử lý
                  if (pId !== 'auto' && !dataIndex) {
                    const img = pResult.image ? pResult.image.src : HELPER.getDefaultNoImage();
                    const pSmallImage = HELPER.getImageSmall(img, {
                      width: 100,
                      height: 100,
                    });

                    const moduleId = _this.getModuleId();
                    const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
                    const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
                    let fields = [];
                    try {
                      fields = jQuery.parseJSON($settings);
                    } catch (err) {
                      console.log(err.message);
                    }
                    const fieldSize = fields.length;
                    for (let i = 0; i < fieldSize; i++) {
                      if (fields[i].name === 'product') {
                        fields[i].default_value = productTitle;
                        // Update default_value của option a product
                        if(fields[i].items){
                          fields[i].items[1].default_value = productTitle;
                        fields[i].items[1].default_value_image = pSmallImage;
                        }

                      }
                      if (fields[i].name === 'pid') {
                        fields[i].default_value = productId;
                      }
                      if (fields[i].name === 'pHandle') {
                        fields[i].default_value = productHandle;
                      }
                    }
                    app.$store.commit('editor/SET_DATA_SETTINGS', {
                      id: keySettings,
                      value: JSON.stringify(fields),
                    });
                  }

                  /* Product */
                  if (moduleName == 'Product') {
                    if ($element.attr('data-status') == 'default' || $element.attr('data-status') == 'dynamic') {
                      const gType = $gfFrame.data('gfframe').getPageType();

                      if (gType == 'template-product') {
                        let preViewPageLink = $gryffEditor.data('gryffeditor').getPreviewPageLink();
                        preViewPageLink = preViewPageLink.replace(/&product(.*)/, '&product=' + productHandle);

                        let viewPageLink = $gryffEditor.data('gryffeditor').getViewPageLink();
                        viewPageLink = viewPageLink.replace(/\/products\/(.*)/, '/products/' + productHandle);

                        $gryffEditor.data('gryffeditor').setPreviewPageLink(preViewPageLink);
                        $gryffEditor.data('gryffeditor').setViewPageLink(viewPageLink);
                      }
                    }
                  }
                } else {
                  HELPER.handleProductNotFound(true);
                  $element.find('.module').show();
                  const shopifyDomain = app.$store.state['app'].shopInfo?.shopifyDomain;
                  const htmlProductNotFound = `<div class="gf_product-not-found">
                                                <p class="gf_product-not-found__title">Product not found. Have you uploaded products to your store?</p>
                                                <a class="gf_product-not-found__action" href="#" data-href="https://${shopifyDomain}/admin/products" target="_blank">Add products to Shopify</a>
                                              </div>`
                  $element.find('.module').html(htmlProductNotFound);
                  $element.find('.gf_product-not-found__action').on("click", function() {
                    const url = $(this).data("href");
                    window.open(url, '_blank').focus();
                  });
                }
              } catch (error) {
                console.log(error);
              }
              callback();
            });
          } else {
            callback();

            $element.css('min-height', 'auto');
            $element.find('.module').show();
          }
          break;
        default:
          _this.runTemplate();
      }
    };

    this.updatePIdByAssignedProduct = function(productId) {
      assignProduct.updatePIdByAssignedProduct(productId);
    }

    // Chạy lại hàm convert trong trường hợp tạo mới product page default:
    // Vì hàm convert đã chạy trước, sau đó hàm initProductTemplate mới chạy và hàm này setDynamic = true;
    // Nên cần chạy lại hàm convert để product type nhận kểu là assigned-product
    this.reConvertAssignVersion = function() {
      // Remove data-assigned-ver for reconvert
      $element.removeAttr('data-assigned-ver');
      assignProduct.convertProductToAssignVersion();
    }

    this.refresh = function ($input) {
      const moduleName = _this.getModuleName();
      const pageType = $gfFrame.data('gfframe').getPageType();

      const dataIndex = $element.attr('data-index');
      // Chỉ convert với kiểu product(không ở bên trong element nào) và kiểu related
      if ((moduleName === 'Product' || moduleName === 'Related Products') && !dataIndex) {
        assignProduct.convertProductToAssignVersion();
      }

      switch (moduleName) {
        case 'Product List':
        case 'Related Products':
        case 'Article List':
        case 'Product':

        // COLLECTION 2019
        case 'Collection Toolbar':
        case 'Paginator':
        case 'Collection Banner':
        case 'Collection Title':
        case 'Collection Desc':

        case 'Article':

        case '(P) Vendor':
        case '(P) SKU':
        case '(P) Title':
        case '(P) Description':
        case '(P) Price':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Quantity':
        case '(P) Variants':
        case '(P) Swatches':
        case '(P) Meta':

        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
          // COLLECTION 2019
          // This is about to fix a very subtle bug on collection page
          // Since we preload different modules to collection page, and the they all load async,
          // we need to generate place holder soon so other modules can initialize
          if (
            pageType == 'template-collection' &&
            (moduleName == 'Product List' ||
              moduleName == 'Collection Toolbar' ||
              moduleName == 'Paginator' ||
              moduleName == 'Collection Banner' ||
              moduleName == 'Collection Title' ||
              moduleName == 'Collection Desc')
          ) {
            HELPER.generatePlaceholderForm($element);
          }

          _this.loadDynamicData(moduleName, $input, function (jsonData) {
            _this.applyEvents();
            _this.runStyle();
            // after refresh itself, refresh its child elements & rows
            _this.refreshChildMERs();

            _this.runScript();

            // COLLECTION 2019
            if (
              pageType != 'page-collection' ||
              !(
                moduleName == 'Product List' ||
                moduleName == 'Collection Toolbar' ||
                moduleName == 'Paginator' ||
                moduleName == 'Collection Banner' ||
                moduleName == 'Collection Title' ||
                moduleName == 'Collection Desc'
              )
            ) {
              HELPER.generatePlaceholderForm($element);
            }

            /* Article List */
            /* Product List List */
            /* Related Products */
            if (moduleName == 'Article List' || moduleName == 'Product List' || moduleName == 'Related Products') {
              var moduleId = _this.getModuleId();
              let $templateChildHtml = '';
              let $templateChildBkHtml = '';
              const keyTemplateChildHtml = HELPER.getKeyDataSetting(base._templateChildHtml, moduleId, 'module');
              const dataTemplateChildHtml = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildHtml);
              $templateChildHtml = jQuery(
                `<script class="template-child-html" type="text/plain">${dataTemplateChildHtml}</script>`,
              );

              const keyTemplateChildBkHtml = HELPER.getKeyDataSetting(base._templateChildBkHtml, moduleId, 'module');
              const dataTemplateChildBkHtml =
                app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildBkHtml);
              $templateChildBkHtml = jQuery(
                `<script class="template-child-bkhtml" type="text/plain">${dataTemplateChildBkHtml}</script>`,
              );

              if (
                $templateChildHtml &&
                $templateChildBkHtml &&
                $templateChildHtml.html() &&
                $templateChildBkHtml.html()
              ) {
                var html = $templateChildHtml.html();
                html = html.replace(/scri-pt/g, 'script');
                html = HELPER.simpleHTMLEntities(html);

                var bkHtml = $templateChildBkHtml.html();
                bkHtml = bkHtml.replace(/scri-pt/g, 'script');
                bkHtml = HELPER.simpleHTMLEntities(bkHtml);

                // Replace template-child-bkhtml
                bkHtml = bkHtml
                  .replace(
                    `<div class="gf_template-child-bkhtml-product-data"></div>`,
                    `<script class="data" type="application/json">{"items": [{"content":"<div class=\\"module-wrap\\" id=\\"m-1538714838899-0\\" data-id=\\"1538714838899-0\\" data-label=\\"(P) Image\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-1\\" data-id=\\"1538714838899-1\\" data-label=\\"(P) Title\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-2\\" data-id=\\"1538714838899-2\\" data-label=\\"(P) Price\\"></div><div class=\\"module-wrap\\" id=\\"m-1538714838899-3\\" data-id=\\"1538714838899-3\\" data-label=\\"(P) Cart Button\\"></div>","id":"i-15387148388990"}]}</script>`,
                  )
                  .replace(
                    `<div class="gf_template-child-bkhtml-article-data"></div>`,
                    `<script class="data" type="application/json">{"items": [{"content": "<div class=\\"module-wrap\\" id=\\"m-1523941222422-0\\" data-id=\\"1523941222422-0\\" data-label=\\"(A) Image\\"></div><div class=\\"module-wrap\\" id=\\"m-1523941222422-1\\" data-id=\\"1523941222422-1\\" data-label=\\"(A) Title\\"></div><div class=\\"module-wrap\\" id=\\"m-1523941222422-2\\" data-id=\\"1523941222422-2\\" data-label=\\"(A) Content\\"></div>","id": "i-15239412224220"}]}</script>`,
                  );

                // Update Preview URL
                if (pageType == 'template-collection' && moduleName == 'Product List') {
                  const collectionHandle = $element.children('.module').attr('data-chandle');

                  let preViewPageLink = $gryffEditor.data('gryffeditor').getPreviewPageLink();
                  preViewPageLink = preViewPageLink.replace(/&collection(.*)/, '&collection=' + collectionHandle);

                  let viewPageLink = $gryffEditor.data('gryffeditor').getViewPageLink();
                  viewPageLink = viewPageLink.replace(/\/collections\/(.*)/, '/collections/' + collectionHandle);

                  $gryffEditor.data('gryffeditor').setPreviewPageLink(preViewPageLink);
                  $gryffEditor.data('gryffeditor').setViewPageLink(viewPageLink);
                }
              } else {
                const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');
                var moduleId = _this.getModuleId();
                var bkHtml = '';
                if (moduleName == 'Article List') {
                  var html = `<div data-label="Article" data-key=\"article\" id="m-{{module-id}}" class="module-wrap" data-id="{{module-id}}"></div>`;
                  var childrenLayout = [
                    {
                      label: 'Article',
                      key: 'article',
                      id: '{{module-id}}',
                    },
                    {
                      label: '(A) Image',
                      key: 'a-image',
                      id: '{{module-id}}-0',
                    },
                    {
                      label: '(A) Title',
                      key: 'a-title',
                      id: '{{module-id}}-1',
                    },
                    {
                      label: '(A) Content',
                      key: 'a-content',
                      id: '{{module-id}}-2',
                    },
                  ];
                } else {
                  // Product List & Related Product
                  let $productSnippet = '';
                  const storeSnippet = app.$store.getters['editor/GET_SNIPPETS_BY_KEY']('product');
                  $productSnippet = jQuery(storeSnippet);

                  //thêm attribute key, ver vì trường hợp kéo mới Product List thì Product child đang thiếu version
                  const snippetKey = $productSnippet.attr('data-key') || '';
                  const snippetVer = $productSnippet.attr('data-ver') || '1';
                  var html = `<div data-label="Product" data-key=\"product\" id="m-{{snippet-id}}" data-key="${snippetKey}" data-ver="${snippetVer}" class="module-wrap" data-id="{{snippet-id}}"></div>`;
                  var childrenLayout = [
                    {
                      label: 'Product',
                      key: 'product',
                      id: '{{snippet-id}}',
                    },
                    {
                      label: '(P) Image',
                      key: 'p-image',
                      id: '{{snippet-id}}-0',
                    },
                    {
                      label: '(P) Title',
                      key: 'p-title',
                      id: '{{snippet-id}}-1',
                    },
                    {
                      label: '(P) Price',
                      key: 'p-price',
                      id: '{{snippet-id}}-2',
                    },
                    {
                      label: '(P) Cart Button',
                      key: 'p-cart-button',
                      id: '{{snippet-id}}-3',
                    },
                  ];
                }

                for (let i = 0; i < childrenLayout.length; i++) {
                  let $snippet = '';
                  const storeSnippet = app.$store.getters['editor/GET_SNIPPETS_BY_KEY'](childrenLayout[i].key);
                  $snippet = jQuery(storeSnippet);

                  //thêm attribute key, ver vì trường hợp kéo mới Product List thì Product child đang thiếu version
                  const snippetKey = $snippet.attr('data-key') || '';
                  const snippetVer = $snippet.attr('data-ver') || '1';
                  bkHtml += `<div id=\"module-${childrenLayout[i].id}\" data-key="${snippetKey}" data-ver="${snippetVer}">`;
                  bkHtml += $snippet.html().replace(/{{module-id}}/gim, childrenLayout[i].id);
                  bkHtml += '</div>';
                }
              }
              if (checkKeyValid('atomLoadLoopItems')) {
                loadLoopItems($element, $gryffEditor, _this.getModuleId(), _this.getModuleName(), html, bkHtml);
              } else {
                var loadDQ = function ($_itemLoops, i, length) {
                  app.$store.commit('editor/SET_LOADING_DYNAMIC_DATA', true);
                  if (length <= i || length == undefined) {
                    const $el = $element
                      .find('.module-wrap[data-label="(P) Title"], .module-wrap[data-label="(A) Title"]')
                      .eq(0);
                    HELPER.flagListItemChange($el, 'settings');
                    const $itemContent = $el.closest('.item-content');
                    HELPER.detectContentChange($itemContent);

                    $_itemLoops.remove();

                    app.$store.commit('editor/SET_LOADING_DYNAMIC_DATA', false);
                    // emitter.emit('store:add-async-module-finish', {
                    //   id: _this.getModuleId(),
                    //   moduleName: _this.getModuleName(),
                    // });
                    return false;
                  }
                  const $itemLoop = jQuery($_itemLoops[i]);

                  const index = $itemLoop.attr('data-index');
                  const newChildId = moduleId + '-child' + index;
                  const rData = HELPER.replaceIds(html, bkHtml, newChildId);

                  html = rData.html;
                  bkHtml = rData.bkHtml;

                  // add data-index for module
                  const $html = jQuery('<div />').html(html);

                  if (moduleName == 'Product List' || moduleName == 'Related Products') {
                    if ($html.find('[data-label="Product"]').length > 0) {
                      $html.find('[data-label="Product"]').attr('data-index', index);
                    }
                  } else if (moduleName == 'Article List') {
                    if ($html.find('[data-label="Article"]').length > 0) {
                      $html.find('[data-label="Article"]').attr('data-index', index);
                    }
                  }

                  // IMPROTANT UPDATE clear all image tags to improve performance
                  $html.find('.item-content').html(' ');

                  html = $html.html();

                  if (i == 0) {
                    const replaceIds = false;
                    if ($gryffEditor.data('gryffeditor') != undefined) {
                      $gryffEditor.data('gryffeditor').addEditorContent(
                        html,
                        bkHtml,
                        $itemLoop,
                        function () {
                          $itemLoop.remove();
                          setTimeout(function () {
                            i++;
                            return loadDQ($_itemLoops, i, length);
                          }, 100);
                        },
                        replaceIds,
                      );
                    }
                  } else {
                    $itemLoop.after(html);
                    HELPER.addContentBk(bkHtml);
                    // $itemLoop.next('.module-wrap').gfModule();
                    atom.Init($itemLoop.next('.module-wrap'));
                    $itemLoop.remove();

                    setTimeout(function () {
                      i++;
                      return loadDQ($_itemLoops, i, length);
                    }, 100);
                  }
                };

                const $_itemLoops = $element.find('.item-loop');

                const length = $_itemLoops.length;

                loadDQ($_itemLoops, 0, length);
              }
            }

            /* Product Meta */
            if (moduleName == '(P) Meta') {
              const $product = $element.closest('[data-label="Product"]');
              const productId = $product.children('.module').attr('data-pid');
              const productData = HELPER.searchProductInList(productId);

              if (!jQuery.isEmptyObject(productData)) {
                const metaKey =
                  $element.children('.module').attr('data-meta') != 'auto'
                    ? $element.children('.module').attr('data-meta')
                    : $element.attr('data-id');
                if (productData.metafields == undefined || productData.metafields.gempages == undefined) {
                  productData.metafields = {
                    gempages: {},
                  };
                }

                if (
                  productData.metafields.gempages[metaKey] != undefined &&
                  productData.metafields.gempages[metaKey + '_bk'] != undefined
                ) {
                  var html = productData.metafields.gempages[metaKey];
                  var bkHtml = productData.metafields.gempages[metaKey + '_bk'];

                  const $itemContent = $element.find('.item-content').empty();
                  const $itemMeta = jQuery('<div class="item-meta"></div>').prependTo($itemContent);

                  if ($gryffEditor.data('gryffeditor') != undefined) {
                    const $html = jQuery('<div />').html(html);
                    $html.find('style').remove();
                    $html.find('script').remove();
                    $html.find('link').remove();

                    html = $html.html();

                    $gryffEditor.data('gryffeditor').addEditorContent(html, bkHtml, $itemMeta, function () {
                      $itemMeta.remove();
                    });
                  }
                }
              }
            }
          });
          break;
        case 'Vimeo':
          // Nếu lib nằm trong list libs blocked thì hiển thị template hướng dẫn tắt cookie
          if (_this.checkLibsIsBlocked()) {
            _this.runTemplateBlocked('Vimeo');
            _this.applyEvents();
          } else {
            _this.runTemplate();
            _this.applyEvents();
            _this.runStyle();
            _this.refreshChildMERs();
            _this.runScript();
          }

          HELPER.generatePlaceholderForm($element);
          break;
        case 'Popup':
          if ($input != undefined && $input.length > 0) {
            const inputName = $input.attr('name');
            switch (inputName) {
              case 'padding':
              case 'width':
              case 'height':
              case 'closeBtnColor':
              case 'closeBtnBg':
              case 'closeBtnPosX':
              case 'closeBtnRadius':
              case 'closeBtnSize':
              case 'closeBtnIconSize':
              case 'closeBtnIconSize':
                // _this.runTemplate();
                break;
              default:
                _this.runTemplate();
                break;
            }
          } else {
            _this.runTemplate();
          }

          _this.applyEvents();
          _this.runStyle();

          // after refresh itself, refresh its child elements & rows
          _this.refreshChildMERs();

          _this.runScript();

          HELPER.generatePlaceholderForm($element);

          break;
        default:
          _this.runTemplate();

          _this.applyEvents();
          _this.runStyle();

          // after refresh itself, refresh its child elements & rows
          _this.refreshChildMERs();

          _this.runScript();

          HELPER.generatePlaceholderForm($element);

          break;
      }

      // dynamic label
      if (moduleName == 'Product') {
        if ($element.attr('data-status') != undefined) {
          _this.setDynamic(true);
        } else {
          _this.setDynamic(false);
        }
      }

      switch (moduleName) {
        case '(P) Title':
        case '(P) Vendor':
        case '(P) SKU':
        case '(P) File Upload':
        case '(P) Description':
        case '(P) Price':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Quantity':
        case '(P) Variants':
        case '(P) Swatches':
        case '(P) Meta':
          var $product = $element.closest('[data-label="Product"]');
          if ($product.length > 0) {
            if ($product.attr('data-status') != undefined) {
              $element.attr('data-status', 'dynamic');
            } else {
              $element.removeAttr('data-status');
            }
          }
          break;
      }

      return false;
    };

    // libs là 1 mảng
    this.checkLibsIsBlocked = function (libs) {
      if (libs == undefined || (typeof libs == Array && libs.length == 0)) {
        libs = _this.getModuleLibrary();
      }
      if (libs.length > 0) {
        for (let i = 0; i < libs.length; i++) {
          if (isBlockedScript(libs[i])) {
            return true;
          }
        }
      }
      return false;
    };

    this.refreshChildMERs = function () {
      const moduleName = _this.getModuleName();
      if (moduleName == 'Tabs') {
        $element.find('> .module > ul > li.gf_tab > .item-content').each(function () {
          const $itemContent = jQuery(this);
          $itemContent.children('.element-wrap[data-label="Heading"]').attr('data-tool', '0');
          $itemContent.children('.element-wrap[data-label="Text Block"]').attr('data-tool', '0');
        });
      }
      $element.find('.item-content').each(function () {
        if (jQuery(this).closest('.module-wrap').is($element)) {
          const $itemContent = jQuery(this);

          // $itemContent.children('.gf_row').gfRow();
          atom.Init($itemContent.children('.gf_row, .element-wrap, .module-wrap'));
          // $itemContent.children('.module-wrap').gfModule();
          // atom.Init($itemContent.children(".module-wrap"));
          // $itemContent.children('.element-wrap').gfElement();
          // atom.Init($itemContent.children(".element-wrap"));
        }
      });

      return false;
    };

    this.setDynamic = function (flag) {
      if (flag) {
        $element.attr('data-status', 'dynamic');
        $element
          .find(
            '[data-label="(P) Title"], [data-label="(P) Vendor"], [data-label="(P) SKU"], [data-label="(P) Description"], [data-label="(P) Price"], [data-label="(P) Cart Button"], [data-label="(P) View More"], [data-label="(P) Image"], [data-label="(P) Image List"], [data-label="(P) Quantity"], [data-label="(P) Variants"], [data-label="(P) Swatches"], [data-label="(P) Meta"]',
          )
          .attr('data-status', 'dynamic');

        var value = '1';
      } else {
        $element.removeAttr('data-status');
        $element.find('[data-label="(P) Title"]').removeAttr('data-status');
        $element
          .find(
            '[data-label="(P) Title"], [data-label="(P) Vendor"], [data-label="(P) SKU"], [data-label="(P) Description"], [data-label="(P) Price"], [data-label="(P) Cart Button"], [data-label="(P) View More"], [data-label="(P) Image"], [data-label="(P) Image List"], [data-label="(P) Quantity"], [data-label="(P) Variants"], [data-label="(P) Swatches"], [data-label="(P) Meta"]',
          )
          .removeAttr('data-status');

        var value = '0';
      }
      const moduleId = _this.getModuleId();
      const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
      const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
      let fields = [];
      try {
        fields = jQuery.parseJSON($settings);
        for (let i = 0; i < fields.length; i++) {
          if (fields[i].name == 'dynamic') {
            fields[i].default_value = value;
          }
        }
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: keySettings,
          value: JSON.stringify(fields),
        });
      } catch (err) {
        console.log(err.message);
      }

      // Detect content change
      const $itemContent = $element.closest('.item-content');
      if ($itemContent.length > 0) {
        HELPER.detectContentChange($itemContent);
      }

      return false;
    };

    this.getTargetClass = function () {
      let targetClass = '';
      const moduleName = _this.getModuleName();
      for (let i = 0; i < moduleInfo.length; i++) {
        if (moduleName == moduleInfo[i]['name']) {
          targetClass = '.' + jQuery.trim(moduleInfo[i]['class']);
          break;
        }
      }
      return targetClass;
    };

    this.getTargetWrap = function () {
      let targetWrap = '';
      const moduleName = _this.getModuleName();
      for (let i = 0; i < moduleInfo.length; i++) {
        if (moduleName == moduleInfo[i]['name']) {
          targetWrap = '.' + jQuery.trim(moduleInfo[i]['wrap']);
          break;
        }
      }
      return targetWrap;
    };

    this.getModuleId = function () {
      let moduleId = HELPER.MakeIdInsideList($element);
      if (moduleId == '') {
        moduleId = $element.attr('data-id') || HELPER.MakeId();
      }
      return moduleId;
    };

    this.getModuleTargetId = function () {
      return `#m-${_this.getModuleId()}`;
    };

    this.getMDTemplate = function () {
      return _mdModule;
    };

    this.getModuleName = function () {
      return $element.attr('data-label') || '';
    };
    this.getModuleKey = function () {
      const key = $element.attr('data-key');
      if (key) {
        return key;
      } else {
        const name = _this.getModuleName();
        return getKeyFromModuleName(name);
      }
    };

    this.getModuleIcon = function () {
      let icon = '';
      const moduleId = _this.getModuleId();
      const keySnippet = HELPER.getKeyDataSetting(base._snippet, moduleId);
      const $snippet = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySnippet);
      const $icon = jQuery('<div />').html($snippet);
      if ($icon.length > 0) {
        icon = $icon.children('.snippet-icon').html();
      }
      return icon;
    };

    this.getModuleCSS = function () {
      const moduleId = this.getModuleId();
      const key = 'style-module-' + moduleId;
      return app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](key);
    };

    this.setModuleCSS = function (style) {
      return this.setModuleCSSUseStore(style);
    };

    this.manualStyleSetting = function (deOptions) {
      let style = _this.getModuleCSS();
      let targetClass = _this.getTargetClass();

      const screenType = $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
      const $targetElement = $element.find(targetClass).length > 0 ? $element.find(targetClass) : $element;

      style = HELPER.designOptions2Style($targetElement, screenType, style, deOptions, targetClass);
      _this.setModuleCSS(style);
      // _this.setModuleCSSUseDom(style);
    };


    this.setModuleCSSUseDom = function (style) {
      style = HELPER.formatCSS(style);
      const moduleId = this.getModuleId();
      const $bkActiveModule = $divContentBk.find('#module-' + moduleId);

      const $style = $bkActiveModule.find('.style');
      if ($style) {
        $style.html(style);
      } else {
        jQuery('<style class="style">' + style + '</style>').appendTo($bkActiveModule);
      }
      return _this;
    };

    this.setModuleCSSUseStore = function (style) {

      const moduleId = this.getModuleId();
      const _style = HELPER.formatCSS(style);

      let $moduleStyle = $moduleStyleContainer.find('#' + base._style + '-' + moduleId);
      if ($moduleStyle.length === 0) {
        jQuery(`<div id="${base._style}-${moduleId}"></div>`).appendTo($moduleStyleContainer);
        $moduleStyle = $moduleStyleContainer.find('#' + base._style + '-' + moduleId);
      }
      $moduleStyle.html('<style class="style" rel="stylesheet">' + _style + '</style>');
      const keyStyle = HELPER.getKeyDataSetting(base._style, moduleId);
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keyStyle,
        value: _style,
      });
      return _this;
    };

    /**
     * Get "Fix version" of auto fix theme
     */
    this.getModuleFixVersion = function () {
      const moduleId = this.getModuleId();
      let $template = '';
      const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
      $template = jQuery('<div />').html(app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate));

      let fixVersion = $template.attr('data-fixed') || 0;
      if (typeof fixVersion != 'number') {
        fixVersion = parseFloat(fixVersion);
      }
      return fixVersion;
    };

    // get "data-ver"
    this.getModuleVersion = function () {
      let version = $element.attr('data-ver') || 0;
      if (typeof version != 'number') {
        version = parseFloat(version);
      }
      return version;
    };

    /**
     * Set "Fix version" for auto fix theme
     */
    this.setModuleFixVersion = function (version) {
      $element.attr('data-fixed', version);
      const moduleId = this.getModuleId();
      const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
      const $template = jQuery('<div />').html(app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate));
      $template.attr('data-fixed', version);
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keyTemplate,
        value: $template.html(),
      });
    };

    this.getModuleTemplate = function () {
      const moduleId = this.getModuleId();
      let template = '';
      const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
      template = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate);
      if (template != undefined) {
        template = template.replace(/scri-pt/g, 'script');
      }
      template = HELPER.formatCode(template);
      return template;
    };

    this.setModuleTemplate = function (template, noRefresh) {
      // normally "noRefresh" is undefinded
      const moduleId = this.getModuleId();
      const moduleName = _this.getModuleName();

      const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
      const dataTemplate = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate);
      if (moduleName == 'Liquid') {
        const $templateHtml = jQuery('<div />').html(dataTemplate);
        if ($templateHtml.children('.module').length > 0) {
          $templateHtml.children('.module').html(template);
          template = $templateHtml.html();
        }
      }
      if (checkKeyValid('hotfixDisableScriptTag')) {
        template = template.replace(/(<\s*\/?\s*)script(\s*([^>]*)?\s*>)/gi, '$1scri-pt$2');
      } else {
        template = template.replace(/script/g, 'scri-pt');
      }

      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keyTemplate,
        value: template,
      });
      if (!noRefresh) {
        _this.refresh();
      }

      return _this;
    };

    this.getModuleScript = function () {
      const moduleId = this.getModuleId();
      let script = '';
      const keyScript = HELPER.getKeyDataSetting(base._script, moduleId);
      const $script = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyScript);
      script = HELPER.formatCode($script);
      return script;
    };

    this.setModuleScript = function (script, preventRun) {
      const moduleId = this.getModuleId();
      const keyScript = HELPER.getKeyDataSetting(base._script, moduleId);
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keyScript,
        value: script,
      });

      if (!preventRun) {
        _this.runScript();
      }

      return _this;
    };

    this.getModuleData = function () {
      const moduleId = this.getModuleId();
      return getModuleData(moduleId);
    };

    this.setModuleData = function (data) {
      const moduleId = this.getModuleId();

      const keyData = HELPER.getKeyDataSetting(base._data, moduleId);
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keyData,
        value: data,
      });

      _this.refresh();

      return _this;
    };

    this.getModuleSettings = function(id) {
      const moduleId = this.getModuleId();
      const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
      const fields = JSON.parse(app.$store.getters["editor/GET_DATA_SETTING_BY_KEY"](keySettings));
      const fieldSize = fields.length;
      if (id) {
        for (let i = 0; i < fieldSize; i++) {
          const item = fields[i];
          if (item.id === id) {
            return item;
          }
        }
      }

      return fields;
    }

    this.getModuleHtml = function () {
      const $moduleHtml = $element.clone();
      $moduleHtml.find('.module').empty();
      $moduleHtml.find('.gf-tool').remove();

      const moduleName = $moduleHtml.attr('data-label');
      switch (moduleName) {
        case 'Product':
          $moduleHtml.removeAttr('data-product');
          break;

        case 'Article':
          $moduleHtml.removeAttr('data-article');
          break;

        case 'Product List':
        case 'Related Products':
          $moduleHtml.removeAttr('data-products');
          break;

        case 'Article List':
          $moduleHtml.removeAttr('data-articles');
          break;
      }
      const html = $moduleHtml.html();
      return html;
    };

    this.getModuleHtmlByTemplate = function (template, jsonData) {
      const moduleName = _this.getModuleName();
      // important to fix < or > problem
      template = HELPER.simpleHTMLEntities(template);
      let html = undefined;
      switch (moduleName) {
        case 'Related Products':
          var productData = jsonData['collection']['product'];
          var ids = [];

          if (productData.collections.length > 1) {
            let i, j;
            for (i = 0; i < productData.collections[0].products.length; i++) {
              ids.push(productData.collections[0].products[i].id);
            }

            for (i = 1; i < productData.collections.length; i++) {
              for (j = 0; j < productData.collections[i].products.length; j++) {
                if (ids.indexOf(productData.collections[i].products[j].id) == -1) {
                  productData.collections[0].products.push(productData.collections[i].products[j]);
                }
              }
            }
          }
          var convertCollection = {};
          var convertAllProducts = {};
          if (productData.collections && productData.collections.length) {
            productData.collections.forEach((collection) => {
              convertCollection[collection.handle] = collection;
              if (collection.products && collection.products.length) {
                collection.products.forEach((product) => {
                  convertAllProducts[product.handle] = product;
                });
              }
            });
          }
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            product: productData,
            collections: convertCollection,
            all_products: convertAllProducts,
          });
          break;

        case 'Product List':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            products: jsonData['products'],
          });
          break;

        // COLLECTION 2019
        case 'Collection Toolbar':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            collection: {
              all_tags: jsonData['tags'],
              products_count: jsonData['products_count'],
              default_sort_by: jsonData['default_sort_by'],
              sort_options: [
                {
                  name: 'Best selling',
                  value: 'best-selling',
                },
                {
                  name: 'Featured',
                  value: 'manual',
                },
                {
                  name: 'Alphabetically, A-Z',
                  value: 'title-ascending',
                },
                {
                  name: 'Alphabetically, Z-A',
                  value: 'title-descending',
                },
                {
                  name: 'Price, low to high',
                  value: 'price-ascending',
                },
                {
                  name: 'Price, high to low',
                  value: 'price-descending',
                },
                {
                  name: 'Date, new to old',
                  value: 'created-descending',
                },
                {
                  name: 'Date, old to new',
                  value: 'created-ascending',
                },
              ],
            },

            items: jsonData['items'],
          });
          break;
        case 'Paginator':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            items: jsonData['items'],
          });
          break;

        case 'Collection Banner':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            collection: {
              image: jsonData['image'],
            },

            items: jsonData['items'],
          });
          break;
        case 'Collection Title':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            collection: {
              title: jsonData['title'],
            },

            items: jsonData['items'],
          });
          break;
        case 'Collection Desc':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            collection: {
              description: jsonData['description'],
            },

            items: jsonData['items'],
          });
          break;

        case 'Article List':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            articles: jsonData['articles'],
          });
          break;

        case '(P) Meta':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            product: jsonData['product'],
          });

          break;

        case 'Breadcrumbs':
          const templateLiquid = Liquid.parse(template);
          const gfframeData = $gfFrame.data('gfframe');
          const pageType = gfframeData.getPageType();
          const pageUrl = gfframeData.getPageUrl();
          let pageTitle = gfframeData.getPageTitle();
          let pageTemplate = 'page';
          switch (pageType) {
            case 'template-index': {
              pageTemplate = 'index';
              break;
            }
            case 'template-product': {
              pageTitle = 'Product Title';
              break;
            }
            case 'template-collection': {
              pageTitle = 'Collection Title';
              break;
            }
          }
          html = templateLiquid.render({
            template: pageTemplate,
            page: {
              url: pageUrl,
              title: pageTitle,
            },
          });
          html = HELPER.compressHTML(html);
          break;

        case '(P) Image List':
          if (jsonData['product']) {
            const mediaLength = jsonData['product'].media.length;
            /**
             * When "Hide list with one media" setting is on
             * Add "empty" item => Image List on GP Editor is still visible
             */
            if (mediaLength == 1) {
              jsonData['product'].media.push({});
            }
            /**
             * For product has only 1 video || 1 3D model
             * Add default image and "empty" item
             */
            //
            else if (!mediaLength) {
              jsonData['product'].media.push(
                {
                  media_type: 'image', //default image
                  width: 640,
                  height: 640,
                  src: 'https://cdn.shopify.com/s/images/admin/no-image-2048x2048.gif',
                },
                {},
              );
            }
          }
        case '(P) Vendor':
        case '(P) SKU':
        case '(P) Title':
        case '(P) Description':
        case '(P) Price':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case '(P) Image':
        case '(P) Quantity':
        case '(P) Variants':
        case '(P) Swatches':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            product: jsonData['product'],
          });
          if (moduleName == '(P) Description') {
            html = sanitizeDescription(html)
          }
          break;

        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            article: jsonData['article'],
          });
          break;

        case 'Liquid':
          html = '';
          break;

        default:
          var tmpl = Liquid.parse(template);
          html = tmpl.render({
            items: jsonData['items'],
          });
          break;
      }
      return html;
    };

    this.getModuleLibrary = function () {
      const moduleId = this.getModuleId();
      let $libs = '';
      const keyLibs = HELPER.getKeyDataSetting(base._libs, moduleId);
      $libs = jQuery('<div />').html(app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyLibs));
      let libs = [];
      if ($libs.html() != undefined && $libs.html().trim() != '') {
        let libJson = {};
        try {
          libJson = JSON.parse($libs.html().trim());
        } catch (err) {
          console.log(err.message);
        }
        if (libJson['libs'] != undefined && libJson['libs'].length > 0) {
          libs = libJson['libs'];
        }
      }
      return libs;
    };

    this.showLoading = function () {
      $element.gfLoader();
      $element.data('gfloader').show();
      return false;
    };

    this.hideLoading = function () {
      $element.data('gfloader').hide();
      if ($element.find('.gf_loader').length > 0) {
        $element.find('.gf_loader').remove();
      }
      return false;
    };

    // gfModule.cloneMe
    this.cloneAndMoveMeToAfter = function ($to) {
      const $newModule = _this.cloneMe(false, false);
      $newModule.detach();
      $newModule.insertAfter($to);

      return $newModule;
    };

    // gfModule.cloneMe
    this.cloneMe = function (removeOrigin, scrollToMe) {
      const label = $element.attr('data-label');
      if (
        label == 'Product' &&
        $element.attr('data-status') != 'default' &&
        $element.attr('data-status') != 'dynamic' &&
        $gryffEditor
          .find('[data-label="Product"]')
          .not('[id*="-child"]')
          .not('[data-status="default"],[data-status="dynamic"]').length >= 20
      ) {
        HELPER.showNotify('Non-dynamic Product quantity can not exceed 20.', 'error');
        return null;
      }

      if (removeOrigin == undefined) {
        var removeOrigin = false;
      }
      if (scrollToMe == undefined) {
        var scrollToMe = true;
      }
      const data = _this.export('clone');

      let html;
      let bkHtml;
      if (HELPER.isInsideTheList($element)) {
        html = data.html;
        bkHtml = data.bkHtml;

        const $tmpHtml = jQuery('<div />').html(html);
        const newIdList = [];

        $tmpHtml.find('[data-label][data-id]').each(function () {
          const oldId = jQuery(this).attr('data-id');
          const matchedString = new RegExp(oldId, 'g');

          var newId = HELPER.MakeIdInsideList($element, 'new');

          let increase = 0;
          while (jQuery.inArray(newId, newIdList) !== -1) {
            var newId = HELPER.MakeIdInsideList($element, 'new', increase);
            increase++;
          }
          newIdList.push(newId);

          html = html.replace(matchedString, newId);
          bkHtml = bkHtml.replace(matchedString, newId);
        });
      } else {
        var rData = HELPER.replaceIds(data.html, data.bkHtml);

        html = rData.html;
        bkHtml = rData.bkHtml;
      }

      $element.after(html);
      HELPER.addContentBk(bkHtml);

      // new module
      const $newModule = $element.next('.module-wrap');
      const moduleName = $newModule.attr('data-label');
      if (moduleName == '(P) Meta') {
        if ($newModule.closest('[data-pid]').length > 0) {
          const productId = $newModule.closest('[data-pid]').attr('data-pid');
          const productData = HELPER.searchProductInList(productId);

          if (!jQuery.isEmptyObject(productData)) {
            const oldMetaKey =
              $element.children('.module').attr('data-meta') == 'auto'
                ? $element.attr('data-id')
                : $element.children('.module').attr('data-meta');
            const newMetaKey =
              $newModule.children('.module').attr('data-meta') == 'auto'
                ? $newModule.attr('data-id')
                : $newModule.children('.module').attr('data-meta');

            if (productData.metafields.gempages[oldMetaKey] != undefined) {
              html = productData.metafields.gempages[oldMetaKey];
              bkHtml = '';

              const $html = jQuery('<div />').html(html);
              $html.children('.gf_row, .module-wrap, .element-wrap').each(function () {
                const id = jQuery(this).attr('data-id');
                if (jQuery(this).hasClass('gf_row')) {
                  var data = $gryffBody
                    .find('#r-' + id)
                    .data('gfrow')
                    .export();
                } else if (jQuery(this).hasClass('module-wrap')) {
                  var data = $gryffBody
                    .find('#m-' + id)
                    .data('gfmodule')
                    .export();
                } else if (jQuery(this).hasClass('element-wrap')) {
                  var data = $gryffBody
                    .find('#e-' + id)
                    .data('gfelement')
                    .export();
                }
                jQuery(this).replaceWith(data.html);
                bkHtml += data.bkHtml;
              });
              html = $html.html();

              var rData = HELPER.replaceIds(html, bkHtml);
              productData.metafields.gempages[newMetaKey] = rData.html;
              productData.metafields.gempages[newMetaKey + '_bk'] = rData.bkHtml;

              HELPER.updateProductInList(productData);
            }
          }
        }
      }

      // run new module
      // $newModule.gfModule();
      atom.Init($newModule, {
        isClone: true,
      });
      if (removeOrigin) {
        $element.data('gfmodule').doRemoveMe();
      }

      HELPER.flagListItemChange($newModule, 'new');
      // detect element or module change
      const $itemContent = $element.closest('.item-content');
      HELPER.detectContentChange($itemContent);

      HELPER.refreshFrame();
      if (!HELPER.isInsideTheList($newModule)) {
        if (!removeOrigin && scrollToMe) {
          if (
            $newModule.offset().top + $gfFrame.offset().top - $gfFrame.contents().scrollTop() >
            window.innerHeight - 250
          ) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $newModule.offset().top - 80,
              },
              800,
            );
          }
        }
      }

      setTimeout(function () {
        const $currentTargetElement = $newModule;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }
        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'add',
          position: position,
        };
        $gryffEditor.trigger('history', history);
      }, 300);

      return $newModule;
    };

    // generate html module with liquid for export
    this.getModuleHtmlForExport = function (moduleId) {
      if (!HELPER.isInsideTheList($element)) {
        var moduleId = this.getModuleId();
      } else {
        // avoid re-generate id when drag & drop from out side to the list
        var moduleId = $element.attr('data-id') || HELPER.MakeId();
      }

      const moduleName = this.getModuleName();

      let html = '';
      switch (moduleName) {
        case 'Mailchimp':
        case 'Product':
        case 'Article':
          var $cloneModule = $element.clone();
          var $moduleWrap = jQuery('<div />').html($cloneModule);
          html = $moduleWrap.html();
          break;

        case 'Product List':
        case 'Related Products':
        case 'Article List':
          var $cloneModule = $element.clone();
          var $moduleWrap = jQuery('<div />').html($cloneModule);
          var uniques = [];
          $moduleWrap.find('.gf_row').each(function () {
            const id = jQuery(this).attr('id');
            if (jQuery.inArray(id, uniques) !== -1) {
              jQuery(this).remove();
            } else {
              uniques.push(id);
            }
          });
          $moduleWrap.find('.gf_column').each(function () {
            const id = jQuery(this).attr('id');
            if (jQuery.inArray(id, uniques) !== -1) {
              jQuery(this).remove();
            } else {
              uniques.push(id);
            }
          });
          $moduleWrap.find('.module-wrap').each(function () {
            const id = jQuery(this).attr('id');
            if (jQuery.inArray(id, uniques) !== -1) {
              jQuery(this).remove();
            } else {
              uniques.push(id);
            }
          });

          $moduleWrap.find('.element-wrap').each(function () {
            const id = jQuery(this).attr('id');
            if (jQuery.inArray(id, uniques) !== -1) {
              jQuery(this).remove();
            } else {
              uniques.push(id);
            }
          });
          html = $moduleWrap.html();
          break;

        default:
          var $cloneModule = $element.clone();
          var $moduleWrap = jQuery('<div />').html($cloneModule);
          var templateTmp = '';
          var fields = [];
          var $settings = '';
          const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
          $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
          const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
          templateTmp = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate);
          try {
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }
          html = '';
          templateTmp = HELPER.replaceFields(fields, templateTmp);
          var jsonHtml = getModuleData(moduleId);
          try {
            var jsonData = jQuery.parseJSON(jsonHtml);
          } catch (err) {
            console.log(err.message);
          }

          //Liquid.Partial.registerTemplates();
          if ($element.attr('data-compile') != 'false' && moduleName != 'Liquid') {
            const tmpl = Liquid.parse(templateTmp);
            html = tmpl.render({
              items: jsonData['items'],
            });
          } else {
            html = templateTmp;
          }

          $moduleWrap.children('.module-wrap').html(html);
          html = $moduleWrap.html();
          break;
      }
      html = HELPER.clearExportedData(html);
      return html;
    };

    this.getModuleLibsForExport = function (moduleId) {
      if (moduleId == undefined) {
        if (!HELPER.isInsideTheList($element)) {
          moduleId = this.getModuleId();
        } else {
          // avoid re-generate id when drag & drop from out side to the list
          moduleId = $element.attr('data-id') || HELPER.MakeId();
        }
      }
      let result = [];
      const keyLibs = HELPER.getKeyDataSetting(base._libs, moduleId);

      if (checkKeyValid('moduleExportLibV2')) {
        const jsonStr = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyLibs);
        if (jsonStr.trim() !== '') {
          const jsonData = JSON.parse(jsonStr);
          result = [...jsonData.libs]; // Copy libs array to result array
        }
      } else {
        const $libs = jQuery('<div />').html(app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyLibs));
        if ($libs.html() != undefined && $libs.html().trim() != '') {
          const libJson = jQuery.parseJSON($libs.html().trim());
          if (libJson['libs'] != undefined && libJson['libs'].length > 0) {
            result = libJson['libs'];
          }
        }
      }
      return result;
    };

    this.updateNameQuantityInput = function ($product) {
      const $quantities = $product.find('[data-label="(P) Quantity"]');
      if ($quantities && $quantities.length > 1) {
        $quantities.each(function () {
          const $quantity = jQuery(this);
          const $quantityInput = $quantity.find('.gf_pq_qty');
          const quantityId = $quantity.attr('data-id');
          $quantityInput.attr('name', 'quantity-' + quantityId);
        });
        const $quantity = $quantities.eq(0);
        const $quantityInput = $quantity.find('.gf_pq_qty');
        $quantityInput.attr('name', 'quantity');
      }
    };
    // =============================== Export Module ===============================
    // gfModule.doExportMe
    this.doExportMe = function (exportType) {
      var html = _this.getModuleHtmlForExport();
      let bkHtml = '';
      let style = '';
      let script = '';
      const carouselScript = '';
      let libs = _this.getModuleLibsForExport();
      let fonts = [];

      const $html = jQuery('<div />').html(html);
      const $module = $html.children('.module-wrap');

      const moduleId = $module.attr('data-id');
      const moduleName = $module.attr('data-label');
      const moduleKey = $module.attr('data-key');

      // COLLECTION 2019
      // Layloading utilities
      var lazyload = jQuery('#gfFrame').data('gfframe').getPageLazyload();
      var excludes = ['Popup'];
      var checkExcludes = function ($el) {
        let excludeCount = 0;
        for (let i = 0; i < excludes.length; i++) {
          if ($el.parents('[data-label="' + excludes[i] + '"], .gf_nolazyload').length != 0) {
            excludeCount++;
          }
        }
        return excludeCount > 0;
      };

      switch (moduleName) {
        case 'Liquid':
          var template = '';
          const keyTemplateLiquid = HELPER.getKeyDataSetting(base._template, moduleId);
          template = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateLiquid);

          if ($module.children('.module').length > 0) {
            var $templateHtml = jQuery('<div />').html(template);
            if ($templateHtml.children('.module').length > 0) {
              template = $templateHtml.children('.module').html();
            }

            $module.children('.module').html(template);
          } else {
            $module.html(template);
          }
          break;

        case 'Newsletter':
          var tmpHtml = $module.html();

          var successMsg = $module.find('.module').attr('data-success-msg');
          var successColor = $module.find('.module').attr('data-success-color');

          var errorMsg = $module.find('.module').attr('data-error-msg');
          var errorColor = $module.find('.module').attr('data-error-color');

          var editLink = $module.find('.module').attr('data-editLink');

          var callBackCode = '';
          if (editLink != undefined && jQuery.trim(editLink) != '') {
            callBackCode = '<input type="hidden" name="gemcallback" value="' + editLink + '" />';
          }

          var liquid =
            '{% if form.posted_successfully? %}' +
            callBackCode +
            '<p class="note form-success" style="border-color: ' +
            successColor +
            '; color: ' +
            successColor +
            ';">' +
            successMsg +
            '</p>{% endif %}{% if form.errors %}<p class="note form-error" style="border-color: ' +
            errorColor +
            '; color: ' +
            errorColor +
            '">' +
            errorMsg +
            '</p>{% endif %}';

          var regex = '<form(.*?>)';
          if (tmpHtml.match(regex)) {
            var matched = tmpHtml.match(regex)[0];
            var matchedString = new RegExp(matched, 'g');
            tmpHtml = tmpHtml.replace(matchedString, "{% form 'customer' %}" + liquid);
          }
          tmpHtml = tmpHtml.replace('</form>', '{% endform %}');

          $module.html(tmpHtml);
          break;
        case 'Contact Form':
        case 'Firepush SMS Subscribers':
          var tmpHtml = $module.html();

          var successMsg = $module.find('.module').attr('data-success-msg');
          var successColor = $module.find('.module').attr('data-success-color');

          var errorMsg = $module.find('.module').attr('data-error-msg');
          var errorColor = $module.find('.module').attr('data-error-color');

          var editLink = $module.find('.module').attr('data-editLink');

          var callBackCode = '';
          if (editLink != undefined && jQuery.trim(editLink) != '') {
            callBackCode = '<input type="hidden" name="gemcallback" value="' + editLink + '" />';
          }

          var liquid =
            '{% if form.posted_successfully? %}' +
            callBackCode +
            '<p class="note form-success" style="border-color: ' +
            successColor +
            '; color: ' +
            successColor +
            ';">' +
            successMsg +
            '</p>{% endif %}{% if form.errors %}<p class="note form-error" style="border-color: ' +
            errorColor +
            '; color: ' +
            errorColor +
            '">' +
            errorMsg +
            '</p>{% endif %}';

          var regex = '<form(.*?>)';
          if (tmpHtml.match(regex)) {
            var matched = tmpHtml.match(regex)[0];
            var matchedString = new RegExp(matched, 'g');
            tmpHtml = tmpHtml.replace(matchedString, "{% form 'contact' %}" + liquid);
          }
          tmpHtml = tmpHtml.replace('</form>', '{% endform %}');

          $module.html(tmpHtml);
          break;

        case 'Mailchimp':
          //support new version
          var version = $module.attr('data-ver') != undefined ? parseFloat($module.attr('data-ver')) : 0;
          //nếu version lớn hơn 2 => new verion mailchimp
          if (version > 2) {
            //hiện tại k làm gì cả
          } else {
            const $mainModule = $module.children('.module');
            const elementId = $module.attr('id') || '';
            const apiKey = $mainModule.attr('data-apikey') || '';
            const listId = $mainModule.attr('data-listId') || '';

            //kiểm tra xem có element đó ở trong list chưa, tồn tại thì cập nhật
            const mailchimpData = window._mailchimpData;
            let flagCheck = false;
            for (let i = 0; i < mailchimpData.length; i++) {
              if (mailchimpData[i].elementId == elementId) {
                flagCheck = true;
                mailchimpData[i] = {
                  elementId: elementId,
                  apiKey: apiKey,
                  listId: listId,
                };
              }
            }

            //Nếu chưa tồn tại elementId thì push thêm vào
            if (!flagCheck) {
              mailchimpData.push({
                elementId: elementId,
                apiKey: apiKey,
                listId: listId,
              });
            }

            $module.children('.module').removeAttr('data-apikey').removeAttr('data-listId');
          }

          break;

        case 'Product':
          // VERSION 3 and greater, support {% form 'product' %} and Dynamic Checkout Button
          var version = $module.attr('data-ver') != undefined ? parseFloat($module.attr('data-ver')) : 0;
          var $form = $module.find('form');

          var pHandle = $module.find('.module').attr('data-pHandle');
          var liquid = '';

          var gType = $gfFrame.data('gfframe').getPageType();
          var $parentModule = $gryffBody
            .find('#m-' + moduleId)
            .parent()
            .closest('.module-wrap');

          // PRODUCT DESIGN
          if (
            $parentModule.attr('data-label') != 'Product List' &&
            $parentModule.attr('data-label') != 'Related Products'
          ) {
            if ($module.attr('data-status') != 'default' && $module.attr('data-status') != 'dynamic') {
              if (exportType != 'block') {
                // VERSION 3
                if (version >= 3) {
                  // $form.prepend("{% assign product = all_products['" + pHandle + "'] %}");
                  $form.before("{% assign product = all_products['" + pHandle + "'] %}");
                } else {
                  liquid += "{% assign product = all_products['" + pHandle + "'] %}";
                }
              }
            }
          }
          if ($module.data('status') == 'dynamic') {
            app.$store.commit('page/UPDATE_COUNT_PRODUCT_DYNAMIC');
          }
          if ($module.data('preload')) {
            app.$store.commit('page/UPDATE_IS_USED_PRELOAD_PRODUCT_SNIPPET', true);
          }

          liquid +=
            '<input name="id" type="hidden" value="{{product.selected_or_first_available_variant.id}}" data-productid="{{product.id}}">';
          $form.prepend(liquid);

          liquid = '{% unless product == empty %}';

          // no more hidden variant input in version 3.1 or above
          if (version <= 3) {
            liquid += '{% for variant in product.variants %}';
            liquid +=
              '<input type="hidden" id="gf-hidden-variant{{variant.id}}" value="{{variant.id}}" data-compare-price="{{ variant.compare_at_price | money | strip_html }}" data-price="{{ variant.price | money | strip_html }}"/>';
            liquid += '{% endfor %}';
          }

          liquid += '<script type="text/plain" class="product-json" id="product-json{{product.id}}">';
          liquid += '{{ product | json }}';
          liquid += '</script>';
          liquid += '{% endunless %}';

          try {
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            const settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            const fields = jQuery.parseJSON(settings);
            const variantSetting = fields.find((field) => field.id === 'variant');
            liquid +=
            `<input class="selected_option" type="hidden" value="${variantSetting?.selectedOptions}">`;
          } catch(err) {
            console.log(err.message);
          }
          
          $form.append(liquid);
          $form.attr('data-productid', '{{product.id}}');

          // backup product variable
          if (gType == 'template-product') {
            if (
              $parentModule.attr('data-label') != 'Product List' &&
              $parentModule.attr('data-label') != 'Related Products'
            ) {
              liquid = '{% assign currentProduct = product %}';
              $module.prepend(liquid);

              liquid = '{% assign product = currentProduct %}';
              $module.append(liquid);
            }
          }

          // remove attributes
          $module
            .find('.module')
            .removeAttr('data-product')
            .removeAttr('data-phandle')
            .removeAttr('data-pid')
            .removeAttr('data-index');

          // VERSION 3
          if (version >= 3) {
            var tmpHtml = $module.html();
            const formId = $form.attr('id');
            const formClass = $form.attr('class');

            tmpHtml = convertProductFormHtmlToLiquid(tmpHtml, formId, formClass);
            $module.html(tmpHtml);
          }

          break;

        case 'Breadcrumbs':
        case '(P) Title':
        case '(P) Vendor':
        case '(P) SKU':
        case '(P) Description':
        case '(P) Variants':
        case '(P) Swatches':
        case '(P) Price':
        case '(P) Quantity':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case '(P) Meta':

        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
        case '(P) File Upload':
          var templateTmp = '';
          var fields = [];
          var $settings = '';
          var $template = '';
          var $data = '';

          const keySettingsFileUpload = HELPER.getKeyDataSetting(base._settings, moduleId);
          $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettingsFileUpload);
          const keyTemplateFileUpload = HELPER.getKeyDataSetting(base._template, moduleId);
          templateTmp = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateFileUpload);
          const keyDataFileUpload = HELPER.getKeyDataSetting(base._data, moduleId);
          $data = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyDataFileUpload);
          try {
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }
          templateTmp = HELPER.replaceFields(fields, templateTmp);

          switch (moduleName) {
            case '(P) File Upload':
              templateTmp = templateTmp.replace(/{{module-id}}/g, moduleId);
              break;
            case '(P) Vendor':
            case '(P) SKU':
            case '(P) Description':
              var matchedString = new RegExp('product.body_html', 'g');
              templateTmp = templateTmp.replace(matchedString, 'product.description');
              break;
            case '(P) Variants':
            case '(P) Swatches':
              var matchedString = new RegExp('product.options', 'g');
              templateTmp = templateTmp.replace(matchedString, 'product.options_with_values');
              break;
            case '(P) Meta':
              templateTmp = templateTmp.replace('--key--', moduleId);
              break;
            case '(P) Image':
            case '(P) Title':
              var $product = $element.closest('[data-label="Product"]');
              var variant = $product.children('.module').attr('data-variant');
              if (variant && variant != '' && variant != 'auto') {
                var matchedString = new RegExp(`href="/products/{{\\s*product.handle\\s*}}"`, 'i');
                templateTmp = templateTmp.replace(
                  matchedString,
                  `href="/products/{{ product.handle }}?variant=${variant}"`,
                );
              }
              break;
            case '(P) Image List':
              $module.removeClass('gf-carousel-loaded');
              break;
            case '(A) Content':
              var matchedString = new RegExp('article.body_html', 'g');
              templateTmp = templateTmp.replace(matchedString, 'article.content');
              break;
            case '(A) Excerpt':
              var summaryMatchedString = new RegExp('article.summary_html', 'g');
              templateTmp = templateTmp.replace(summaryMatchedString, 'article.excerpt');
              break;
          }

          // img_url always returns the 100x100 variant for avif images
          if (moduleName == '(P) Image' || moduleName == '(P) Image List') {
            templateTmp = convertImgUrlToImageUrl(templateTmp);
          }

          $module.html(templateTmp);
          break;
        case '(P) Dynamic Checkout Button':
          $module.find('.gf_p-dynamic-checkout-button').text('{{ form | payment_button }}');
          break;
        case 'Product List':
        case 'Related Products':
          // remove attributes
          $module.find('.module').removeAttr('data-products').removeAttr('data-product');

          // add liquid after recuring childrens
          break;

        case 'Article':
          var aHandle = $module.find('.module').attr('data-aHandle');
          if (
            $gryffBody
              .find('#m-' + moduleId)
              .parent()
              .closest('.module-wrap')
              .attr('data-label') != 'Article List'
          ) {
            var liquid = '';
            if (exportType != 'block') {
              liquid += "{% assign article =  blog.articles['" + aHandle + "'] %}";
            }
          } else {
            var liquid = '';
          }
          $module.find('.module').prepend(liquid);

          // remove attributes
          $module
            .find('.module')
            .removeAttr('data-article')
            .removeAttr('data-ahandle')
            .removeAttr('data-aid')
            .removeAttr('data-index');

          break;

        case 'Article List':
          $module.find('.m-loading').remove();

          // remove attributes
          $module.find('.module').removeAttr('data-articles').removeAttr('data-article');
          // add liquid after recuring childrens
          break;

        // COLLECTION 2019
        case 'Paginator':
          var templateTmp = '';
          var fields = [];
          var $settings = '';
          var $template = '';
          var $data = '';

          const keySettingsPaging = HELPER.getKeyDataSetting(base._settings, moduleId);
          $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettingsPaging);
          const keyTemplatePaging = HELPER.getKeyDataSetting(base._template, moduleId);
          templateTmp = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplatePaging);
          const keyDataPaing = HELPER.getKeyDataSetting(base._data, moduleId);
          $data = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyDataPaing);
          try {
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }
          templateTmp = HELPER.replaceFields(fields, templateTmp);
          if (templateTmp != undefined) {
            templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);
            var moduleIdSlug = moduleId.toString().replace(/-/g, '');
            templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);
          } else {
            templateTmp = '';
          }
          // Process liquid
          var $templateTmpWrapper = jQuery('<div />').html(templateTmp);
          var $productList = $gryffEditor.find('.module-wrap[data-label="Product List"][data-status="dynamic"]');
          if ($productList.length > 0) {
            var limit = $productList.eq(0).children('.module').attr('data-limit');
          } else {
            var limit = 12; // Since Product List default limit is 12, it's better choice to choose this one for default paginator limit also
          }
          if (exportType != 'block') {
            const previousText = $templateTmpWrapper.find('.module').attr('data-previous');
            const nextText = $templateTmpWrapper.find('.module').attr('data-next');
            $templateTmpWrapper
              .find('.gf_collection-paginator-wrapper')
              .html(
                '{% paginate collection.products by ' +
                  limit +
                  " %}{{ paginate | default_pagination: previous: '" +
                  previousText +
                  "', next: '" +
                  nextText +
                  "' }}{% endpaginate %}",
              );
          }
          $module.html($templateTmpWrapper.html());

          break;
        case 'Collection Banner':
          $module.css('background-image', '');
          // Apply lazyload
          if (lazyload && !checkExcludes($element)) {
            $module
              .addClass('gf_lazyload')
              .children('.module')
              .attr(
                'data-collection-image',
                "{% if collection.image.src %}{{ collection.image.src | img_url: '120x' }}{% endif %}",
              );
          } else {
            const $collectionModule = $module.children('.module');
            let oriSize = $collectionModule.attr('data-ori-size');
            if (!oriSize) {
              oriSize = '1024x1024';
            }
            $collectionModule.attr(
              'data-collection-image',
              "{% if collection.image.src %}{{ collection.image.src | img_url: '" + oriSize + "' }}{% endif %}",
            );
          }

          break;

        case 'Collection Title':
          $module.find('.gf_collection-banner-title').children('h1,h2,h3,h4,h5,h6,p').text('{{ collection.title }}');
          break;
        case 'Collection Desc':
          $module.find('.gf_collection-banner-description').text('{{ collection.description }}');
          break;
        case 'Collection Toolbar':
          var templateTmp = '';
          var fields = [];
          var $settings = '';
          var $template = '';
          var $data = '';

          const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
          $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
          const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
          templateTmp = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate);
          const keyData = HELPER.getKeyDataSetting(base._data, moduleId);
          $data = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyData);
          try {
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }
          templateTmp = HELPER.replaceFields(fields, templateTmp);
          if (templateTmp != undefined) {
            templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);
            var moduleIdSlug = moduleId.toString().replace(/-/g, '');
            templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);
          } else {
            templateTmp = '';
          }

          $module.html(templateTmp);

          break;
        case 'Youtube':
          // Apply lazyload
          const $youtubeModule = $module.find('.module');
          if (lazyload && $youtubeModule.data("autoplay") != 1) {
            const urlYoutube = $youtubeModule.attr('data-url');
            const thumbHtml = HELPER.getYoutubeThumb(urlYoutube);
            $youtubeModule.html(thumbHtml);
            $module.find(".gf_youtube-thumb").addClass('gf_lazyload');
          }
          break;
        case 'Carousel':
          $module.removeClass('gf-carousel-loaded');
          break;
        default:
          if ($module.attr('data-compile') == 'false') {
            var template = '';
            var fields = [];
            var $settings = '';
            var $template = '';
            var $data = '';

            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
            const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
            template = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate);
            const keyData = HELPER.getKeyDataSetting(base._data, moduleId);
            $data = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyData);
            try {
              fields = jQuery.parseJSON($settings);
            } catch (err) {
              console.log(err.message);
            }
            template = HELPER.replaceFields(fields, template);

            if ($module.children('.module').length > 0) {
              var $templateHtml = jQuery('<div />').html(template);
              if ($templateHtml.children('.module').length > 0) {
                template = $templateHtml.children('.module').html();
              }

              $module.children('.module').html(template);
            } else {
              $module.html(template);
            }
          }
          break;
      }

      if (moduleId != undefined) {
        let $bkCloneModule = '';
        $bkCloneModule = HELPER.mergeDataSetting('module', moduleId);
        const $bkModuleHtml = jQuery('<div />').html($bkCloneModule);
        bkHtml += $bkModuleHtml.html();
        style += HELPER.getStyleDataSetting('module', moduleId);
        script += HELPER.getScriptDataSetting('module', moduleId);

        const interactionData = app.$store.getters['editor/GET_ANIMATION_INTERACTION_SETTING_BY_KEY'](
          base._interactions + '_' + 'module-' + moduleId,
        );
        if (interactionData) {
          script += this.parseInteraction2Scripts($module, _this.getModuleId(), interactionData, exportType);
        }
      }

      $module.find('.item-content').each(function () {
        const $that = jQuery(this);
        if ($that.closest('.module-wrap').is($module)) {
          $that.children('.gf_row').each(function () {
            const rowId = jQuery(this).attr('data-id');
            const $thisRow = $gryffBody.find('#r-' + rowId);
            if ($thisRow.length > 0) {
              if ($thisRow.data('gfrow') != undefined) {
                const data = $thisRow.data('gfrow').exportMe();

                jQuery(this).replaceWith(data.html);
                bkHtml += data.bkHtml;

                let itemStyle = data.style;
                if (moduleName == 'Product List') {
                  var childIdRegex = /#(m|r|e)-\d+-child\d+(-\d+)*/gim;
                  var childId;
                  do {
                    const matchChildIds = childIdRegex.exec(itemStyle);

                    if (matchChildIds && matchChildIds.length > 0) {
                      childId = matchChildIds[0];
                    } else {
                      break;
                    }
                    var childIdParts = childId.split('child');
                    if (childIdParts.length >= 2) {
                      var modulePart = childIdParts[0].slice(1); // Remove #
                      var itemPart = childIdParts[1];
                      if (itemPart.indexOf('-') != -1) {
                        const itemParts = itemPart.split('-');
                        itemParts.splice(0, 1);
                        itemStyle = itemStyle.replace(
                          childId,
                          '[id^="' + (modulePart + 'child') + '"][id$="-' + itemParts.join('-') + '"]',
                        );
                      } else {
                        itemStyle = itemStyle.replace(
                          childId,
                          '[data-label="Product"][id^="' + (modulePart + 'child') + '"]',
                        );
                      }
                    }
                  } while (childId);
                }

                if (moduleName == 'Article List') {
                  var childIdRegex = /#(m|r|e)-\d+-child\d+(-\d+)*/gim;
                  var childId;
                  do {
                    const matchChildIds = childIdRegex.exec(itemStyle);

                    if (matchChildIds && matchChildIds.length > 0) {
                      childId = matchChildIds[0];
                    } else {
                      break;
                    }
                    var childIdParts = childId.split('child');
                    if (childIdParts.length >= 2) {
                      var modulePart = childIdParts[0].slice(1); // Remove #
                      var itemPart = childIdParts[1];
                      if (itemPart.indexOf('-') != -1) {
                        const itemParts = itemPart.split('-');
                        itemParts.splice(0, 1);
                        itemStyle = itemStyle.replace(
                          childId,
                          '[id^="' + (modulePart + 'child') + '"][id$="-' + itemParts.join('-') + '"]',
                        );
                      } else {
                        itemStyle = itemStyle.replace(
                          childId,
                          '[data-label="Article"][id^="' + (modulePart + 'child') + '"]',
                        );
                      }
                    }
                  } while (childId);
                }

                style += itemStyle;

                script += data.script;

                if (moduleName && moduleName == 'Related Products') {
                  const moduleId = _this.getModuleId();
                  const $productList = $gryffBody.find('#m-' + moduleId);
                  const numberCurrent = $productList.find('[data-label="Product"]').length;
                  const limit = parseInt($productList.children('.module').attr('data-limit'));

                  if (limit > numberCurrent) {
                    // Style
                    var matchedString = new RegExp('#m-' + moduleId + '-child1(.*?)}', 'g');
                    var arrayLine = style.match(matchedString);
                    if (arrayLine && arrayLine.length > 0) {
                      let newStyle = '';
                      for (var count = numberCurrent + 1; count <= limit; count++) {
                        for (var index = 0; index < arrayLine.length; index++) {
                          var newLine = arrayLine[index].replace('-child1', '-child' + count);
                          newStyle += newLine;
                        }
                      }
                      style += newStyle;
                    }

                    // Script
                    var matchedString =
                      /jQuery\(function\s*([A-z0-9]+)?\s*\((?:[^)(]+|\((?:[^)(]+|\([^)(]*\))*\))*\)\s*\{(?:[^}{]+|\{(?:[^}{]+|\{[^}{]*\})*\})*\}\);/g;
                    var arrayLine = script.match(matchedString);
                    if (arrayLine && arrayLine.length > 0) {
                      let newScript = '';
                      const stringCheck = '#m-' + moduleId + '-child1';
                      for (var count = numberCurrent + 1; count <= limit; count++) {
                        for (var index = 0; index < arrayLine.length; index++) {
                          if (arrayLine[index].indexOf(stringCheck) != -1) {
                            var newLine = arrayLine[index].replace('-child1', '-child' + count);
                            newScript += '\n\n\t\t' + newLine;
                          }
                        }
                      }
                      script += newScript;
                    }
                  }
                }

                libs = libs.concat(data.libs);
                fonts = fonts.concat(data.fonts);
              }
            }
          });
          $that.children('.module-wrap').each(function () {
            const moduleId = jQuery(this).attr('data-id');
            const $thisModule = $gryffBody.find('#m-' + moduleId);
            if ($thisModule.length > 0) {
              if ($thisModule.data('gfmodule') != undefined) {
                const data = $thisModule.data('gfmodule').exportMe();

                jQuery(this).replaceWith(data.html);
                bkHtml += data.bkHtml;
                style += data.style;
                script += data.script;
                libs = libs.concat(data.libs);
                fonts = fonts.concat(data.fonts);
              }
            }
          });

          $that.children('.element-wrap').each(function () {
            const elementId = jQuery(this).attr('data-id');
            const $thisElement = $gryffBody.find('#e-' + elementId);
            if ($thisElement.length > 0) {
              if ($thisElement.data('gfelement') != undefined) {
                const data = $thisElement.data('gfelement').exportMe();

                jQuery(this).replaceWith(data.html);
                bkHtml += data.bkHtml;
                style += data.style;
                script += data.script;
                libs = libs.concat(data.libs);
                fonts = fonts.concat(data.fonts);
              }
            }
          });
        }
      });

      switch (moduleName) {
        case 'Product':
          // Thêm chuỗi properties[d] vào trong các input fiels
          const $allField = $html.find('.gf_textfield,.gf_dropdown,.gf_textarea');
          for (let i = 0; i < $allField.length; i++) {
            const $field = $($allField[i]);
            const textName = $field.attr('name');
            if (textName.indexOf('properties[') == -1) {
              $field.attr('name', 'properties[' + textName + ']');
            }
          }
          // Change name of quantity input before export template
          const $product = $module;
          if ($product && $product.length > 0) {
            _this.updateNameQuantityInput($product);
          }
          // support USB sticker Widget
          const $wSticker = $product.find('[data-widget="sticker"]');
          const $pImages = $product.find('[data-label="(P) Image"]');
          if ($wSticker && $wSticker.length > 0) {
            $pImages.each(function () {
              const $pImage = jQuery(this);
              const $pImageModule = $pImage.children('.module');
              $pImageModule.attr('data-widget', 'sticker');
              $pImageModule.addClass('gf_htusb-container');
            });
          } else {
            $pImages.each(function () {
              const $pImage = jQuery(this);
              const $pImageModule = $pImage.children('.module');
              $pImageModule.removeAttr('data-widget', 'sticker');
              $pImageModule.removeClass('gf_htusb-container');
            });
          }
          break;
        // add liquid for product list after recuring children
        case 'Contact Form':
        case 'Newsletter': {
          // Thêm chuỗi contact[d] vào trong các input fiels
          const $allField = $html.find('.gf_textfield,.gf_dropdown,.gf_textarea');
          for (let i = 0; i < $allField.length; i++) {
            const $field = $($allField[i]);
            const textName = $field.attr('name');
            if (textName.indexOf('contact[') == -1) {
              $field.attr('name', 'contact[' + textName + ']');
            }
          }
          break;
        }
        case 'Mailchimp': {
          var version = $module.attr('data-ver') != undefined ? parseFloat($module.attr('data-ver')) : 0;
          if (version > 2) {
            //convert lowercase to uppercase
            $html.find('input').each(function () {
              const oldName = jQuery(this).attr('name');
              if (oldName) {
                jQuery(this).attr('name', oldName.toUpperCase());
              }
            });
          }
          break;
        }

        case 'Popup':
          $html.children('[data-label="Popup"]').removeAttr('style');
          $html.children('[data-label="Popup"]').removeClass('showPopup');
          break;

        case 'Product List':
        case 'Related Products':
          var templateTmp = '';
          var fields = [];
          var $settings = '';
          var $template = '';
          var $data = '';

          const keySettingsRelated = HELPER.getKeyDataSetting(base._settings, moduleId);
          $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettingsRelated);
          const keyTemplateRelated = HELPER.getKeyDataSetting(base._template, moduleId);
          templateTmp = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateRelated);
          const keyDataRelated = HELPER.getKeyDataSetting(base._data, moduleId);
          $data = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyDataRelated);
          try {
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }
          templateTmp = HELPER.replaceFields(fields, templateTmp);

          if (templateTmp != undefined) {
            templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

            var moduleIdSlug = moduleId.toString().replace(/-/g, '');
            templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);
          } else {
            templateTmp = '';
          }

          var $templateTmpWrapper = jQuery('<div />').html(templateTmp);
          $templateTmpWrapper.find('[data-index]').attr('data-index', 0);

          // Product List only
          if (moduleName == 'Product List') {
            var limit = $templateTmpWrapper.find('.module').attr('data-limit');
            let templateTmpWrapperHtml = $templateTmpWrapper.find('.module').html();

            let cId = $module.find('.module').attr('data-cId');
            if (cId == undefined) {
              cId = $module.find('.module').attr('data-cid');
            }
            var dynamic = $module.attr('data-status');

            if (dynamic == 'dynamic') {
              if (exportType != 'block') {
                templateTmpWrapperHtml = templateTmpWrapperHtml.replace(
                  /{% for product in products limit: \d+ %}/i,
                  '{% paginate collection.products by ' + limit + ' %}{% for product in collection.products %}',
                );
                templateTmpWrapperHtml = templateTmpWrapperHtml.replace(
                  '{% endfor %}',
                  '{% endfor %}{% endpaginate %}',
                );
              }
            } else if (cId == 'auto') {
              // Latest Products
              if (exportType != 'block') {
                templateTmpWrapperHtml = templateTmpWrapperHtml.replace(
                  /{% for product in products limit: \d+ %}/i,
                  '{% paginate collections.all.products by ' +
                    limit +
                    ' %}{% for product in collections.all.products %}',
                );
                templateTmpWrapperHtml = templateTmpWrapperHtml.replace(
                  '{% endfor %}',
                  '{% endfor %}{% endpaginate %}',
                );
              }
            } else {
              // Product List
              const cHandle = $module.find('.module').attr('data-cHandle');
              if (exportType != 'block') {
                templateTmpWrapperHtml = templateTmpWrapperHtml.replace(
                  /{% for product in products limit: \d+ %}/i,
                  '{% paginate collections["' +
                    cHandle +
                    '"].products by ' +
                    limit +
                    ' %}{% for product in collections["' +
                    cHandle +
                    '"].products %}',
                );
                templateTmpWrapperHtml = templateTmpWrapperHtml.replace(
                  '{% endfor %}',
                  '{% endfor %}{% endpaginate %}',
                );
              }
            }

            $templateTmpWrapper.find('.module').html(templateTmpWrapperHtml);

            /* Product Item Loop */
            var $templateChildHtml = '';
            var $templateChildBkHtml = '';
            const keyTemplateChildHtml = HELPER.getKeyDataSetting(base._templateChildHtml, moduleId, 'module');
            const dataTemplateChildHtml = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildHtml);
            $templateChildHtml = jQuery(
              `<script class="template-child-html" type="text/plain">${dataTemplateChildHtml}</script>`,
            );

            const keyTemplateChildBkHtml = HELPER.getKeyDataSetting(base._templateChildBkHtml, moduleId, 'module');
            const dataTemplateChildBkHtml =
              app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildBkHtml);
            $templateChildBkHtml = jQuery(
              `<script class="template-child-bkhtml" type="text/plain">${dataTemplateChildBkHtml}</script>`,
            );
            if ($templateChildHtml.length > 0 && $templateChildBkHtml.length > 0) {
              var childHtml = $templateChildHtml.html();
              childHtml = childHtml.replace(/scri-pt/g, 'script');
              childHtml = HELPER.simpleHTMLEntities(childHtml);
              var childBkHtml = $templateChildBkHtml.html();
              childBkHtml = childBkHtml.replace(/scri-pt/g, 'script');
              childBkHtml = HELPER.simpleHTMLEntities(childBkHtml);
              var newProductId = moduleId + '-child{{forloop.index}}';
              var rData = HELPER.replaceIds(childHtml, childBkHtml, newProductId);
              childHtml = rData.html;
              childBkHtml = rData.bkHtml;
              $templateTmpWrapper.find('.item-loop').replaceWith(childHtml);
              $module.html($templateTmpWrapper.html());
              // append liquid - product variabel
              var gType = $gfFrame.data('gfframe').getPageType();
              if (gType == 'template-product') {
                var liquid = '{% assign currentProduct = product %}';
                $module.prepend(liquid);

                liquid = '{% assign product = currentProduct %}';
                $module.append(liquid);
              }
            }
          } else if (moduleName == 'Related Products') {
            var pHandle = $module.find('.module').attr('data-pHandle');
            var liquid1 = '';
            var gType = $gfFrame.data('gfframe').getPageType();
            var dynamic = $module.attr('data-status');
            // PRODUCT DESIGN
            if (gType != 'template-product' || dynamic != 'dynamic') {
              if (exportType != 'block') {
                liquid1 +=
                  "{% assign productCachedRelated = product %}{% assign product = all_products['" + pHandle + "'] %}";
              } else {
                liquid1 += "{% assign productCachedRelated = product %}{% assign product = all_products['auto'] %}";
              }
            }
            $templateTmpWrapper.find('.item-content-no-placeholder').closest('.module').prepend(liquid1);

            /* Product Item Loop */
            var $templateChildHtml = '';
            var $templateChildBkHtml = '';
            const keyTemplateChildHtml = HELPER.getKeyDataSetting(base._templateChildHtml, moduleId, 'module');
            const dataTemplateChildHtml = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildHtml);
            $templateChildHtml = jQuery(
              `<script class="template-child-html" type="text/plain">${dataTemplateChildHtml}</script>`,
            );

            const keyTemplateChildBkHtml = HELPER.getKeyDataSetting(base._templateChildBkHtml, moduleId, 'module');
            const dataTemplateChildBkHtml =
              app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildBkHtml);
            $templateChildBkHtml = jQuery(
              `<script class="template-child-bkhtml" type="text/plain">${dataTemplateChildBkHtml}</script>`,
            );

            if ($templateChildHtml.length > 0 && $templateChildBkHtml.length > 0) {
              var childHtml = $templateChildHtml.html();
              childHtml = childHtml.replace(/scri-pt/g, 'script');
              childHtml = HELPER.simpleHTMLEntities(childHtml);

              var childBkHtml = $templateChildBkHtml.html();
              childBkHtml = childBkHtml.replace(/scri-pt/g, 'script');
              childBkHtml = HELPER.simpleHTMLEntities(childBkHtml);

              const moduleVersion = $module.attr('data-ver') || 0;

              var newProductId;

              if (moduleVersion) {
                const version = parseFloat(moduleVersion);
                if (version > 1) {
                  newProductId = moduleId + '-child{{gRPCount}}';
                } else {
                  newProductId = moduleId + '-child{{count}}';
                }
              } else {
                newProductId = moduleId + '-child{{count}}';
              }

              var rData = HELPER.replaceIds(childHtml, childBkHtml, newProductId);
              childHtml = rData.html;
              childBkHtml = rData.bkHtml;

              $templateTmpWrapper.find('.item-loop').replaceWith(childHtml);
              $module.html($templateTmpWrapper.html());

              // append liquid - product variabel
              var gType = $gfFrame.data('gfframe').getPageType();
              if (gType == 'template-product') {
                if (dynamic != 'dynamic') {
                  var liquid = '{% if productCachedRelated %}{% assign product = productCachedRelated %}{% endif %}';
                  $module.append(liquid);
                }
                if (checkKeyValid('setCurrentProductRelatedProducts')) {
                  var liquid = '{% assign currentProduct = product %}';
                  $module.prepend(liquid);

                  liquid = '{% assign product = currentProduct %}';
                  $module.append(liquid);
                }
              }
            }
          }

          // Change name of quantity input before export template
          const $products = $module.find('[data-label="Product"]');
          if ($products && $products.length > 0) {
            $products.each(function () {
              const $product = jQuery(this);
              if ($product && $product.length > 0) {
                _this.updateNameQuantityInput($product);
              }
            });
          }

          //replace <form></form> to liquid form {% form %}{% endform %}
          var tmpHtml = $module.html();

          tmpHtml = convertProductFormHtmlToLiquid(tmpHtml, '', 'AddToCartForm');
          $module.html(tmpHtml);
          break;

        case 'Article List':
          var templateTmp = '';
          var fields = [];
          var $settings = '';
          var $template = '';
          var $data = '';

          const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
          $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
          const keyTemplate = HELPER.getKeyDataSetting(base._template, moduleId);
          templateTmp = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplate);
          const keyData = HELPER.getKeyDataSetting(base._data, moduleId);
          $data = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyData);
          try {
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }
          templateTmp = HELPER.replaceFields(fields, templateTmp);
          templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

          var moduleIdSlug = moduleId.toString().replace(/-/g, '');
          templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);

          var $templateTmpWrapper = jQuery('<div />').html(templateTmp);

          var bId = $module.find('.module').attr('data-bId');

          if (bId == '') {
            var liquid1 = '';
            if (exportType != 'block') {
              liquid1 += '{% assign articles =  "" | split: "" %}';
            }
          } else if (bId == 'auto') {
            // Latest Blogs
            var liquid1 = '';
            if (exportType != 'block') {
              liquid1 += '{% if blogs.news.articles.size > 0 %}{% assign articles = blogs.news.articles %}{% endif %}';
            }
          } else {
            // Blog List
            const bHandle = $module.find('.module').attr('data-bHandle');
            var liquid1 = '';
            if (exportType != 'block') {
              liquid1 +=
                '{% if blogs["' +
                bHandle +
                '"].articles.size > 0 %}{% assign articles = blogs["' +
                bHandle +
                '"].articles %}{% endif %}';
            }
          }
          $templateTmpWrapper.find('.module').prepend(liquid1);

          /* Article Item Loop */
          var $templateChildHtml = '';
          var $templateChildBkHtml = '';
          const keyTemplateChildHtml = HELPER.getKeyDataSetting(base._templateChildHtml, moduleId, 'module');
          const dataTemplateChildHtml = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildHtml);
          $templateChildHtml = jQuery(
            `<script class="template-child-html" type="text/plain">${dataTemplateChildHtml}</script>`,
          );

          const keyTemplateChildBkHtml = HELPER.getKeyDataSetting(base._templateChildBkHtml, moduleId, 'module');
          const dataTemplateChildBkHtml = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildBkHtml);
          $templateChildBkHtml = jQuery(
            `<script class="template-child-bkhtml" type="text/plain">${dataTemplateChildBkHtml}</script>`,
          );

          if ($templateChildHtml.length > 0 && $templateChildBkHtml.length > 0) {
            var childHtml = $templateChildHtml.html();
            childHtml = childHtml.replace(/scri-pt/g, 'script');
            childHtml = HELPER.simpleHTMLEntities(childHtml);

            var childBkHtml = $templateChildBkHtml.html();
            childBkHtml = childBkHtml.replace(/scri-pt/g, 'script');
            childBkHtml = HELPER.simpleHTMLEntities(childBkHtml);

            const newArticleId = moduleId + '-child{{forloop.index}}';

            var rData = HELPER.replaceIds(childHtml, childBkHtml, newArticleId);
            childHtml = rData.html;
            childBkHtml = rData.bkHtml;

            $templateTmpWrapper.find('.item-loop').replaceWith(childHtml);
            $module.html($templateTmpWrapper.html());
          }

          break;

        default:
          break;
      }

      // REPLACE IDS
      if (exportType != undefined && (exportType == 'clone' || exportType == 'block')) {
      }

      // REMOVE PRODUCT MODULE MESSAGE
      if (moduleName == 'Product') {
        HELPER.removeProductModuleMessage($html);
      }

      if (moduleKey == 'loox-reviews-carousel') {
        this.revampLooxCarouseWhenExport($html)
      }
      // --------------------------------------------------------------------
      var html = $html.html();
      html = HELPER.clearExportedData(html);
      html = HELPER.compressHTML(html);
      html = HELPER.simpleHTMLEntities(html);

      style = HELPER.compressHTML(style);

      // check defineds
      script = script == 'undefined' ? '' : script;
      script += carouselScript;
      style = style == 'undefined' ? '' : style;

      // LAZYLOADING2019
      var lazyload = getGlobalVariable('gfFrame').data('gfframe').getPageLazyload();
      var excludes = ['Popup'];
      var checkExcludes = function ($el) {
        let excludeCount = 0;
        for (let i = 0; i < excludes.length; i++) {
          if ($el.parents('[data-label="' + excludes[i] + '"], .gf_nolazyload').length != 0) {
            excludeCount++;
          }
        }
        return excludeCount > 0;
      };
      // Apply lazyload for Hero Banner
      switch (moduleName) {
        case 'Hero Banner':
          if (lazyload && !checkExcludes($element)) {
            const ptrn = /background-image: *url\([^;}]+\)/gim;
            let match;
            let newStyle = style;
            let src;
            while ((match = ptrn.exec(style)) != null) {
              src = /url\([^;}]+\)/gim.exec(match[0])[0];
              if (
                src.indexOf('ucarecdn.com/') != -1 ||
                src.indexOf('cdn.shopify.com/s/files/') != -1 ||
                src.indexOf('apps.shopifycdn.com/') != -1
              ) {
                src = HELPER.replaceImageSource(src).src;
                newStyle = newStyle.replace(match[0], 'background-image: ' + src);
              }
            }
            style = newStyle;
          }
          break;
      }

      // Apply global style for Product inside a dynamic Product List
      if (
        moduleName == 'Product' &&
        $element.closest('.module-wrap[data-label="Product List"][data-status="dynamic"]').length > 0
      ) {
        const parentId = $element.closest('.module-wrap[data-label="Product List"][data-status="dynamic"]').attr('id');
        var regex = new RegExp('#' + parentId + '-child\\d+(-\\d+)?', 'img');
        const childRegex = new RegExp('#' + parentId + '-child\\d+-\\d+', 'img');

        while (true) {
          var id = childRegex.exec(style);
          if (id == null || id[0] == undefined) {
            break;
          } else {
            id = id[0];
          }
          var firstSelector = id.slice(0, id.lastIndexOf('-'));
          var secondSelector = id.slice(id.lastIndexOf('-'));
          style = style.replace(
            id,
            '[id^="' +
              firstSelector.slice(1, firstSelector.lastIndexOf('-')) +
              '-child"][id$="' +
              secondSelector +
              '"]',
          );
        }

        while (true) {
          var id = regex.exec(style);
          if (id == null || id[0] == undefined) {
            break;
          } else {
            id = id[0];
          }
          var firstSelector = id.slice(0, id.lastIndexOf('-'));
          var secondSelector = id.slice(id.lastIndexOf('-'));
          style = style.replace(id, '[data-label="Product"][id^="' + firstSelector.slice(1) + '-child"]');
        }
      }

      // Check include youtube API
      libs = this.shouldIncludesYoutubeAPI($element, libs);

      if (checkKeyValid('trackingError')) {
        if (!html || !bkHtml) {
          const moduleId = _this.getModuleId();
          window.trackingError.push(moduleId);
        }
      }
      const data = {
        html: html,
        bkHtml: bkHtml,
        style: style,
        script: script,
        libs: libs,
        fonts: fonts,
      };
      return data;
    };

    this.parseInteraction2Scripts = function ($module, moduleId, interaction, exportType) {
      let script = '';
      let interactionJSON = {};
      try {
        interactionJSON = JSON.parse(interaction);
      } catch {
        interactionJSON = {};
      }
      if (interactionJSON && interactionJSON.animations) {
        interactionJSON.animations.forEach((e) => {
          try {
            const animationName = e.animation.name;
            const interaction = e.interaction;
            
            if (exportType != 'clone') {
              if (animationName.includes('_in') && SCROLL_VIEW_KEY.includes(interaction.key)) {
                $module.css('opacity', 0);
              }
              if (animationName.includes('_out')) {
                // Do nothing
              }
            }
            if (interaction) {
              switch (interaction.key) {
                case 'mouse-click':
                  script += `window.__gfAnimate.registerClick(jQuery("#m-${moduleId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'mouse-hover':
                  script += `window.__gfAnimate.registerHover(jQuery("#m-${moduleId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'mouse-leave':
                  script += `window.__gfAnimate.registerMouseLeave(jQuery("#m-${moduleId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'after-page-loaded':
                  script += `window.__gfAnimate.registerPageLoaded(jQuery("#m-${moduleId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'scroll-into-view':
                  script += `window.__gfAnimate.registerScroll(jQuery("#m-${moduleId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'scrolling-in-view':
                  script += `window.__gfAnimate.registerScrolling(jQuery("#m-${moduleId}"), '${JSON.stringify(e)}');`;
                  break;
              }
            }
          } catch {}
        });
      }
      return script;
    };

    // gfModule.exportMe
    this.exportMe = function (exportType) {
      // Detect if its tabs module then show all detached tabs
      // before export
      // see in the end of this function as well
      const moduleName = _this.getModuleName();
      if (moduleName == 'Tabs') {
        const moduleId = _this.getModuleId();

        const moduleIdSlug = moduleId.toString().replace(/-/g, '');
        const func = 'getTab' + moduleIdSlug;
        if (document.getElementById('gfFrame').contentWindow[func]) {
          document.getElementById('gfFrame').contentWindow[func]().showAllDetaches();
        }
        var data = _this.doExportMe(exportType);

        setTimeout(function () {
          if (document.getElementById('gfFrame').contentWindow[func]) {
            document.getElementById('gfFrame').contentWindow[func]().showActiveDetache();
          }
        }, 2000);
      } else {
        var data = _this.doExportMe(exportType);
      }

      return data;
    };

    this.export = function (exportType) {
      const data = _this.exportMe(exportType);
      return data;
    };

    this.revampLooxCarouseWhenExport = function ($looxCarousel) {
      const dataColor = [
        "data-reviewer-name-color",
        "data-text-color",
        "data-item-background-color",
        "data-stars-color",
        "data-stars-background-color",
        "data-arrows_background-color",
        "data-arrows_icon-color",
        "data-border_color",
      ];
      const $looxCard = $looxCarousel.find("#LOOX-V2_CAROUSEL-card").clone();
      const $looxGallery = $looxCarousel.find("#LOOX-V2_CAROUSEL-gallery").clone();
      dataColor.map((item) => {
        const cardColor = $looxCard.attr(item);
        const galleryColor = $looxGallery.attr(item);
        const newCardColor = tinycolor(cardColor).toHexString().replace('#', "");
        const newGalleryColor = tinycolor(galleryColor).toHexString().replace('#', "");
        if (newCardColor) {
          $looxCarousel.find("#LOOX-V2_CAROUSEL-card").attr(item, newCardColor);
        }
        if (newGalleryColor) {
          $looxCarousel.find("#LOOX-V2_CAROUSEL-gallery").attr(item, newGalleryColor);
        }
      })
      return $looxCarousel;
    }
    // =============================== Export Module ===============================
    this.atTheBottom = function () {
      const $nextBlocks = $element.nextAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]');
      if ($nextBlocks.length > 0) {
        return false;
      }
      return true;
    };

    this.moveDown = function (scrollToMe) {
      if (!_this.atTheBottom()) {
        if (scrollToMe == undefined) {
          var scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $nextBlock = $element
          .nextAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]')
          .eq(0);
        let $newPlace = $nextBlock.next('.block-placeholder');
        if ($newPlace.length == 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $nextBlock.after($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };
        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $mHandle = $element.children('.gf-tool-wrap').find('.m-handle');
        $mHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    this.atTheTop = function () {
      const $prevBlocks = $element.prevAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]');
      if ($prevBlocks.length > 0) {
        return false;
      }
      return true;
    };

    this.moveUp = function (scrollToMe) {
      if (!_this.atTheTop()) {
        if (scrollToMe == undefined) {
          var scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $prevBlock = $element
          .prevAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]')
          .eq(0);
        let $newPlace = $prevBlock.prev('.block-placeholder');
        if ($newPlace.length == 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $prevBlock.before($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };
        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $mHandle = $element.children('.gf-tool-wrap').find('.m-handle');
        $mHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    this.hasParent = function () {
      const $parent = $element.parent().closest('.module-wrap[data-label], .gf_row[data-label]');
      if ($parent.length > 0) {
        const parentName = $parent.attr('data-label');

        if (parentName == 'Product') {
          var limitArr = [
            '(P) Title',
            '(P) Vendor',
            '(P) SKU',
            'Ultimate Sales Boost',
            'WideBundle',
            '(P) Price',
            '(P) Quantity',
            '(P) Image',
            '(P) Image List',
            '(P) Stock Counter',
            '(P) Cart Button',
            '(P) Dynamic Checkout Button',
            '(P) View More',
            '(P) Description',
            '(P) Variants',
            '(P) Swatches',
            '(P) Meta',
            'Infinite Options',
            'Recharge Subscription',
            'Bold Subscriptions',
            'Bold Product Options',
            'Breadcrumbs',
          ];
        } else if (parentName == 'Article List') {
          var limitArr = ['(A) Title', '(A) Content', '(A) Image', '(A) Date'];
        } else {
          var limitArr = [];
        }

        if (limitArr.length > 0) {
          const moduleName = _this.getModuleName();
          for (let i = 0; i < limitArr.length; i++) {
            if (
              moduleName == limitArr[i] ||
              $element.find('.module-wrap[data-label="' + limitArr[i] + '"]').length > 0
            ) {
              return false;
            }
          }
        }

        return true;
      }
      return false;
    };

    this.toParent = function (scrollToMe) {
      if (_this.hasParent()) {
        if (scrollToMe == undefined) {
          var scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $parent = $element.parent().closest('.module-wrap[data-label], .gf_row[data-label]');
        let $newPlace = $parent.next('.block-placeholder');
        if ($newPlace.length == 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $parent.after($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };
        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $mHandle = $element.children('.gf-tool-wrap').find('.m-handle');
        $mHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    // gfModule.doRemoveMe
    this.doRemoveMe = function (isGotoTab0, historyFlag) {
      HELPER.handleBlankPage();

      if (isGotoTab0 == undefined) {
        isGotoTab0 = true;
      }

      // update place holder
      const $placeholder = $element.next('.block-placeholder');
      if ($placeholder.length > 0) {
        $placeholder.remove();
      }

      const $itemContent = $element.closest('.item-content');
      const moduleId = _this.getModuleId();

      if (historyFlag == undefined) {
        historyFlag = true;
      }
      if (historyFlag) {
        const $currentTargetElement = $element;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }

        const data = _this.export('clone');
        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'delete',
          position: position,
          data: {
            html: data.html,
            bkHtml: data.bkHtml,
          },
        };
        $gryffEditor.trigger('history', history);
      }

      let flag = false;
      if (!HELPER.isInsideTheList($element)) {
        _this.removeAllChilds();
      } else {
        HELPER.flagListItemChange($element, 'delete');
        flag = true;
      }

      // detect element or module change
      HELPER.detectContentChange($itemContent);
      HELPER.refreshFrame();

      if (!flag) {
        while ($gryffBody.find('#m-' + moduleId).length > 0) {
          $gryffBody
            .find('#m-' + moduleId)
            .data('gfmodule')
            .doRemoveMe();
        }
      }
      // go back to tab 0
      if (isGotoTab0) {
        $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
      }

      // PRODUCT META
      const moduleName = _this.getModuleName();
      switch (moduleName) {
        case '(P) Meta':
          var $product = $itemContent.closest('[data-label="Product"]');
          var productId = $product.children('.module').attr('data-pid');

          var productData = HELPER.searchProductInList(productId);
          if (!jQuery.isEmptyObject(productData)) {
            if (
              productData.metafields.gempages[moduleId] != undefined &&
              productData.metafields.gempages[moduleId + '_bk'] != undefined
            ) {
              delete productData.metafields.gempages[moduleId];
              delete productData.metafields.gempages[moduleId + '_bk'];
              HELPER.updateProductInList(productData);
            }
          }
          break;

        case 'Popup':
          var $popupAnchorList = $gryffBody.find('.gf-popupAnchorList');
          $popupAnchorList.find('[data-id="' + moduleId + '"]').remove();
          $gryffBody.find('#gf-popupOverlay' + moduleId).remove();
          break;
      }

      return false;
    };

    this.removeAllChilds = function () {
      return _this.removeAllChildsInStore();
    };

    this.removeAllChildsInDom = function () {
      const $rowEqualHeight = $element.closest('.gf_equal-height');

      const $rows = $element.find('.gf_row');
      for (var k = 0; k < $rows.length; k++) {
        const rowId = $rows.eq(k).attr('data-id');
        const $bkActiveRow = $divContentBk.find('#row-' + rowId);
        $bkActiveRow.remove();
      }
      const $cols = $element.find('.gf_column');
      for (var k = 0; k < $cols.length; k++) {
        const colId = $cols.eq(k).attr('data-id');
        const $bkActiveColumn = $divContentBk.find('#column-' + colId);
        $bkActiveColumn.remove();
      }
      const $modules = $element.find('.module-wrap');
      for (var k = 0; k < $modules.length; k++) {
        var moduleId = $modules.eq(k).attr('data-id');
        var $bkActiveModule = $divContentBk.find('#module-' + moduleId);
        $bkActiveModule.remove();
      }
      const $elems = $element.find('.element-wrap');
      for (var k = 0; k < $elems.length; k++) {
        const elementId = $elems.eq(k).attr('data-id');
        const $bkActiveElement = $divContentBk.find('#element-' + elementId);
        $bkActiveElement.remove();
      }
      // remove
      var moduleId = _this.getModuleId();
      var $bkActiveModule = $divContentBk.find('#module-' + moduleId);
      $bkActiveModule.remove();

      $element.remove();

      if ($rowEqualHeight.length > 0) {
        HELPER.refreshEqualHeight();
        HELPER.refreshFrame();
      }
      return false;
    };

    this.removeAllChildsInStore = function () {
      const $rowEqualHeight = $element.closest('.gf_equal-height');

      const $rows = $element.find('.gf_row');
      for (var k = 0; k < $rows.length; k++) {
        const rowId = $rows.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(rowId, 'row');
        const $style = $moduleStyleContainer.find('#' + base._style + '-' + rowId);
        $style.remove();
        const $script = $moduleScriptContainer.find('#' + base._script + '-' + rowId);
        $script.remove();
      }
      const $cols = $element.find('.gf_column');
      for (var k = 0; k < $cols.length; k++) {
        const colId = $cols.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(colId, 'column');
        const $style = $moduleStyleContainer.find('#' + base._style + '-' + colId);
        $style.remove();
        const $script = $moduleScriptContainer.find('#' + base._script + '-' + colId);
        $script.remove();
      }
      const $modules = $element.find('.module-wrap');
      for (var k = 0; k < $modules.length; k++) {
        const moduleId = $modules.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(moduleId, 'module');
        const $style = $moduleStyleContainer.find('#' + base._style + '-' + moduleId);
        $style.remove();
        const $script = $moduleScriptContainer.find('#' + base._script + '-' + moduleId);
        $script.remove();
      }
      const $elems = $element.find('.element-wrap');
      for (var k = 0; k < $elems.length; k++) {
        const elementId = $elems.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(elementId, 'element');
        const $style = $moduleStyleContainer.find('#' + base._style + '-' + elementId);
        $style.remove();
        const $script = $moduleScriptContainer.find('#' + base._script + '-' + elementId);
        $script.remove();
      }
      // remove
      const moduleId = _this.getModuleId();
      _this.deleteDataSettingByKey(moduleId);
      const $style = $moduleStyleContainer.find('#' + base._style + '-' + moduleId);
      $style.remove();
      const $script = $moduleScriptContainer.find('#' + base._script + '-' + moduleId);
      $script.remove();

      $element.remove();
      if ($rowEqualHeight.length > 0) {
        HELPER.refreshEqualHeight();
        HELPER.refreshFrame();
      }
      return false;
    };

    this.deleteDataSettingByKey = function (moduleId, keyType = 'module', payload = {}) {
      // payload không truyền gì là xóa all
      removeElement(moduleId);
      app.$store.commit('editor/DELETE_DATA_SETTING_BY_KEY', {
        keyType: keyType,
        attrId: moduleId,
        data: {
          [base._style]: payload.style ? payload.style : true,
          [base._template]: payload.template ? payload.template : true,
          [base._snippet]: payload.snippet ? payload.snippet : true,
          [base._libs]: payload.libs ? payload.libs : true,
          [base._data]: payload.data ? payload.data : true,
          [base._script]: payload.script ? payload.script : true,
          [base._settings]: payload.settings ? payload.settings : true,
          [base._interactions]: payload.interactions ? payload.interactions : true,
          [base._actions]: payload.actions ? payload.actions : true,
          [base._actionsStyle]: payload.actionsStyle ? payload.actionsStyle : true,
          [base._templateChildHtml]: payload.templateChildHtml ? payload.templateChildHtml : true,
          [base._templateChildBkHtml]: payload.templateChildBkHtml ? payload.templateChildBkHtml : true,
        },
      });
      return false;
    };

    this.copyCSS = function () {
      const style = _this.getModuleCSS();
      const id = this.getModuleId();
      const label = this.getModuleName();
      const dataClipBoardCSS = {
        id: id,
        label: label,
        style: style,
      };
      store.setValue('__clipBoardCSS', dataClipBoardCSS);
    };
    this.pasteCSS = function () {
      const clipBoardCSS = store.getValue('__clipBoardCSS') || {};
      const id = this.getModuleId();
      const label = this.getModuleName();
      if (!jQuery.isEmptyObject(clipBoardCSS) && label == clipBoardCSS.label) {
        const oldStyle = this.getModuleCSS();
        let style = clipBoardCSS.style;
        if (id != clipBoardCSS.id) {
          const oldId = new RegExp(clipBoardCSS.id, 'g');
          style = style.replace(oldId, id);
        }
        this.setModuleCSS(style);

        HELPER.flagListItemChange($element, 'replace');
        HELPER.detectContentChange($element);
        //add history
        const extra = {
          edit: 'css',
          style: oldStyle,
        };
        if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
          $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
        }
        this.openModuleSettings();
      }
    };

    this.moduleCSS = function () {
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);

      const style = _this.getModuleCSS();
      const oldStyle = style;

      const $activeModal = jQuery('#md-editor');
      $activeModal.find('#styleCode').val(HELPER.formatCSS(style));

      const $cEditor = ace.edit('styleCode');
      $cEditor.setTheme('ace/theme/monokai');
      $cEditor.setAutoScrollEditorIntoView(true);
      $cEditor.getSession().setTabSize(2);
      $cEditor.getSession().setUseWrapMode(true);

      $cEditor.setHighlightActiveLine(false);
      $cEditor.setOption('maxLines', 27);
      $cEditor.setOption('minLines', 27);
      $cEditor.session.setMode('ace/mode/css');

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;

      // console.log($element)
      $activeModal
        .data('gfmodal')
        .setTitle('CSS')
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const style = $cEditor.getValue();
          _this.runStyle(style);

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'css',
            style: oldStyle,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }

          return false;
        });

      return false;
    };

    this.moduleTemplate = function () {
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);

      let template = _this.getModuleTemplate();
      const oldTemplate = template;

      const $activeModal = $divContentHidden.find('#md-editor');

      // liquid new version
      const moduleName = _this.getModuleName();
      if (moduleName == 'Liquid') {
        const $templateHtml = jQuery('<div />').html(template);
        if ($templateHtml.children('.module').length > 0) {
          template = $templateHtml.children('.module').html();
        }
      }

      $activeModal.find('#templateCode').val(template);

      const $cEditor = ace.edit('templateCode');
      $cEditor.setTheme('ace/theme/monokai');
      $cEditor.setAutoScrollEditorIntoView(true);
      $cEditor.getSession().setTabSize(2);
      $cEditor.getSession().setUseWrapMode(true);

      $cEditor.setHighlightActiveLine(false);
      $cEditor.setOption('maxLines', 27);
      $cEditor.setOption('minLines', 27);
      $cEditor.session.setMode('ace/mode/html');

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;

      // console.log($element)
      $activeModal
        .data('gfmodal')
        .setTitle('Template')
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const template = $cEditor.getValue();
          _this.setModuleTemplate(template);

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'html',
            template: oldTemplate,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }

          return false;
        });

      return false;
    };

    this.moduleScript = function () {
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);

      const script = _this.getModuleScript();
      const oldScript = script;

      const $activeModal = jQuery('#md-editor');
      $activeModal.find('#scriptCode').val(script);

      const $cEditor = ace.edit('scriptCode');
      const scriptContent = $cEditor.getValue();
      // Ignore undifined case when missing <script></script> tag
      if (!scriptContent || scriptContent == 'undefined') {
        const scriptPlaceholder = '/* add your custom script here */';
        $cEditor.setValue(scriptPlaceholder);
      }
      $cEditor.setTheme('ace/theme/monokai');
      $cEditor.setAutoScrollEditorIntoView(true);
      $cEditor.getSession().setTabSize(2);
      $cEditor.getSession().setUseWrapMode(true);

      $cEditor.setHighlightActiveLine(false);
      $cEditor.setOption('maxLines', 27);
      $cEditor.setOption('minLines', 27);
      $cEditor.session.setMode('ace/mode/javascript');

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;

      // console.log($element)
      $activeModal
        .data('gfmodal')
        .setTitle('Script')
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const script = $cEditor.getValue();
          _this.setModuleScript(script);

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'script',
            script: oldScript,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }

          return false;
        });

      return false;
    };

    this.moduleData = function () {
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);

      const data = _this.getModuleData();
      const oldData = data;

      const $activeModal = jQuery('#md-editor');
      $activeModal.find('#dataCode').val(data);

      const $cEditor = ace.edit('dataCode');
      $cEditor.setTheme('ace/theme/monokai');
      $cEditor.session.setMode('ace/mode/json');
      $cEditor.setAutoScrollEditorIntoView(true);
      $cEditor.getSession().setTabSize(2);
      $cEditor.getSession().setUseWrapMode(true);

      $cEditor.setHighlightActiveLine(false);
      $cEditor.setOption('maxLines', 27);
      $cEditor.setOption('minLines', 27);
      // $cEditor.session.setMode("ace/mode/javascript");

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;

      // console.log($element)
      $activeModal
        .data('gfmodal')
        .setTitle('Data')
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const data = $cEditor.getValue();
          _this.setModuleData(data);

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'data',
            data: oldData,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }
        });

      return false;
    };

    this.editCode = function (enableSections = []) {
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);

      const style = _this.getModuleCSS();
      const oldStyle = style;

      let template = _this.getModuleTemplate();
      const oldTemplate = template;

      const script = _this.getModuleScript();
      const oldScript = script;

      const data = _this.getModuleData();
      const oldData = data;

      // liquid new version
      const moduleName = _this.getModuleName();
      if (moduleName == 'Liquid') {
        const $templateHtml = jQuery('<div />').html(template);
        if ($templateHtml.children('.module').length > 0) {
          template = $templateHtml.children('.module').html();
        }
      }

      const $activeModal = $divContentHidden.find('#md-editor');
      $activeModal.find('#templateCode').hide().val(template);
      $activeModal.find('#styleCode').hide().val(HELPER.formatCSS(style));
      $activeModal.find('#scriptCode').hide().val(script);
      $activeModal.find('#dataCode').hide().val(data);

      const $codeEditor = {
        template: null,
        style: null,
        script: null,
        data: null,
      };
      var templateTrackingTime = 0
      var styleTrackingTime = 0
      var scriptTrackingTime = 0
      // Đánh active cho tab đầu tiên không bị disable
      {
        const tab = enableSections[0];
        var startTrackingTime = Date.now();
        $activeModal.find(`[gf-tabs]>[gf-tab="${tab}"]`).addClass('active is-selected');
        $codeEditor[tab] = initAce(tab + 'Code', tab);
        if (tab == 'script') {
          const scriptContent = $codeEditor[tab].getValue();
          // Ignore undifined case when missing <script></script> tag
          if (!scriptContent || scriptContent == 'undefined') {
            const scriptPlaceholder = '/* add your custom script here */';
            $codeEditor[tab].setValue(scriptPlaceholder);
          }
        }
      }

      // huỷ trạng thái disable của những tab được active
      $activeModal.find('[gf-tabs]>[gf-tab]').each(function () {
        const $item = jQuery(this);
        const tab = ($item.attr('gf-tab') || '').toLowerCase();
        if (enableSections.includes(tab)) {
          $item.removeClass('disabled');
        }
      });

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      let __timeout = null;
      // xử lý click vào tag để copy id
      $activeModal
        .find('[gf-action="click:copyToClipboard"]')
        .off('click.clipboard')
        .on('click.clipboard', function () {
          const copied = copyToClipboard('#m-' + $element.attr('data-id'));
          if (copied) {
            const $thisSpan = jQuery(this);
            $thisSpan.parent().find('[gf-span="msg"]').remove();
            clearTimeout(__timeout);
            const $msg = jQuery(`<span gf-span="msg">Copied!</span>`);
            $msg.css({
              color: '#42C184',
              'font-size': '12px',
              'margin-left': '4px',
            });
            $thisSpan.after($msg);
            __timeout = setTimeout(() => {
              $thisSpan.next('span').remove();
            }, 1500);
          }
        });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;

      $activeModal
        .data('gfmodal')
        .setTitle('#m-' + $element.attr('data-id') + utils.svgIcon('copy'))
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      // xử lý chuyển tab
      $activeModal
        .find('[gf-tabs]>[gf-tab]:not(.disabled)')
        .off('click.changeTab')
        .on('click.changeTab', function (e) {
          const $selectedTab = jQuery(this);
          const tab = $selectedTab.attr('gf-tab');
          if (!enableSections.includes(tab)) {
            console.log(`The "${tab}" tab is disabled`);
            return;
          }
          const tabAtrr = $activeModal.find('.active').attr('gf-tab');
          const activeTime = Date.now() - startTrackingTime
          if(tabAtrr === 'template'){
            templateTrackingTime += activeTime;
          }
          if(tabAtrr === 'style'){
            styleTrackingTime += activeTime
          }
          if(tabAtrr === 'script'){
            scriptTrackingTime += activeTime
          }
          startTrackingTime = Date.now()

          $activeModal.find('[gf-tabs]>[gf-tab]').removeClass('active');
          $selectedTab.addClass('active is-selected');
          Object.keys($codeEditor).forEach((key) => {
            if ($codeEditor[key]) {
              jQuery($codeEditor[key].container).hide();
            }
          });
          // nếu đã được khởi tạo thì show, nếu chưa thì khởi tạo
          if ($codeEditor[tab]) {
            jQuery($codeEditor[tab].container).show();
          } else {
            $codeEditor[tab] = initAce(tab + 'Code', tab);
            if (tab == 'script') {
              const scriptContent = $codeEditor[tab].getValue();
              // Ignore undifined case when missing <script></script> tag
              if (!scriptContent || scriptContent == 'undefined') {
                const scriptPlaceholder = '/* add your custom script here */';
                $codeEditor[tab].setValue(scriptPlaceholder);
              }
            }
          }
        });

      // xử lý khi click lưu
      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const tabAtrr = $activeModal.find('.active').attr('gf-tab');
          const activeTime = Date.now() - startTrackingTime
          if(tabAtrr === 'template'){
            templateTrackingTime += activeTime;
          }
          if(tabAtrr === 'style'){
            styleTrackingTime += activeTime
          }
          if(tabAtrr === 'script'){
            scriptTrackingTime += activeTime
          }
          const labelElement = $element.attr('data-label') || 'Row';
          $activeModal.find('.is-selected').each(function(){
            const tabAtrrItem = jQuery(this).attr('gf-tab');
            let trackingTimeItem = 0
            if(tabAtrrItem === 'template'){
              trackingTimeItem = templateTrackingTime
              templateTrackingTime = 0
            }
            if(tabAtrrItem === 'style'){
              trackingTimeItem = styleTrackingTime
              styleTrackingTime = 0
            }
            if(tabAtrrItem === 'script'){
              trackingTimeItem = scriptTrackingTime
              scriptTrackingTime = 0
            }
            const tabNameItem = jQuery(this).text()
            const gfFrameData = $gfFrame.data('gfframe');

            app.$store.dispatch('common/trackEvent', {
              eventId: EDITOR_EVENT.GS_CUSTOM_CODE_SAVED,
              properties: {
                shop_domain: gfFrameData.getShopDomain(),
                template_page_id: gfFrameData.getPageId(),
                product_element_type: labelElement,
                tab_custom: tabNameItem,
                tab_tracking_time: trackingTimeItem,
              },
          })
          });
          const hasData = enableSections.includes('data') && $codeEditor['data'];
          const hasStyle = enableSections.includes('style') && $codeEditor['style'];
          const hasScript = enableSections.includes('script') && $codeEditor['script'];
          const hasTemplate = enableSections.includes('template') && $codeEditor['template'];

          if (hasData) {
            const val = $codeEditor['data'].getValue();
            _this.setModuleData(val);
          }

          if (hasStyle) {
            const val = $codeEditor['style'].getValue();
            _this.runStyle(val);
          }

          if (hasScript) {
            const val = $codeEditor['script'].getValue();
            if (!hasTemplate) {
              _this.setModuleScript(val);
            } else {
              _this.setModuleScript(val, true);
            }
          }

          if (hasTemplate) {
            const val = $codeEditor['template'].getValue();
            _this.setModuleTemplate(val);
          }

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'code',
            template: oldTemplate,
            style: oldStyle,
            script: oldScript,
            data: oldData,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }

          return false;
        });
    };

    // gfModule.applyDrag
    this.applyDrag = function () {
      const $mHandle = $element.children('.gf-tool-wrap').find('.m-handle');

      if ($element.attr('data-label') == 'Popup') {
      } else {
        $mHandle.gfDraggable({
          targetElement: $element,
          type: 'module',
          start: function () {
            $mHandle.closest('.gf-tool').removeClass('gf-expand');
            return false;
          },
          stop: function (nearY, $from, $to, $stElement, $dragHidden, notDragging) {
            // notDragging is usually undefinded
            // Xử lý cho trường hợp click event
            if (notDragging) {
              _this.openModuleSettings(undefined, true);
              return;
            }

            // Xử lý cho drag event
            if (nearY != undefined) {
              let index = nearY.id;
              if (index < 0) {
                index = 0;
              }
              const $newPlace = window.$gfPlaceHolders.eq(index);
              if ($newPlace.length === 1) {
                $to = $newPlace.closest('.item-content');

                let flag = true;
                const moduleName = _this.getModuleName();

                /*

                                    CÁC TRƯỜNG HỢP KHÔNG ĐƯỢC DI CHUYỂN

                                    1, Module (P) không được kéo ra ngoài Product
                                    2, Module (A) không được kéo ra ngoài Article
                                    3, Product không được kéo vào Product, Product List, Related Products, Article List
                                    4, Article không được kéo vào Article, Product List, Related Products, Article List

                                    5, Product List, Related Products, Article List không được kéo vào Product, Article, Product List, Related Products, Article List

                                    6, Element chứa (P) không được kéo ra ngoài Product
                                    7, Element chứa (A) không được kéo ra ngoài Article

                                    8, Form không được kéo vào form (Product, Product List, Related Products, Mailchimp, Contact Form, Newsletter, Firepush SMS Subscribers )

                                */

                //block FORM to FORM
                if (listForms.indexOf(moduleName) != -1) {
                  for (let i = 0; i < listForms.length; i++) {
                    if ($to.closest('[data-label="' + listForms[i] + '"]').length) {
                      flag = false;
                      HELPER.showNotify('Cannot put a ' + moduleName + ' inside a ' + listForms[i] + '.', 'error');
                      break;
                    }
                  }
                }

                // cannot drag to list after drag from leftsidebar
                if (
                  HELPER.isInsideTheList($to) &&
                  (moduleName == 'WideBundle' || moduleName == 'Product Filter Search')
                ) {
                  flag = false;
                  HELPER.showNotify('Cannot put a ' + moduleName + ' inside a Product List.', 'error', 5000);
                }
                if (HELPER.isInsideTheList($to) && moduleName == 'PickyStory') {
                  flag = false;
                  HELPER.showNotify('Cannot put a ' + moduleName + ' inside a Product List.', 'error', 5000);
                }
                if (
                  moduleName == 'Ultimate Sales Boost' &&
                  HELPER.isInsideTheList($to) &&
                  $to.closest('[data-label="Product List"]').length > 0
                ) {
                  if ($gfFrame.data('gfframe').getPageType() == 'template-product') {
                    flag = false;
                    HELPER.showNotify(
                      'Cannot put a ' + moduleName + ' into a Product List of Product Page',
                      'error',
                      5000,
                    );
                  }
                }
                if (flag) {
                  switch (moduleName) {
                    // 1, Module (P) không được kéo ra ngoài Product
                    case '(P) Title':
                    case '(P) Vendor':
                    case '(P) SKU':
                    case 'Ultimate Sales Boost':
                    case 'WideBundle':
                    case '(P) File Upload':
                    case '(P) Description':
                    case '(P) Price':
                    case '(P) Quantity':
                    case '(P) Stock Counter':
                    case '(P) Cart Button':
                    case '(P) View More':
                    case '(P) Image':
                    case '(P) Image List':
                    case '(P) Variants':
                    case '(P) Swatches':
                    case '(P) Meta':
                    case 'Bold Product Options':
                    case 'Bold Subscriptions':
                    case 'Recharge Subscription':
                    case 'Infinite Options':
                      if (
                        $from.closest('[data-label="Product"]').length > 0 &&
                        $to.closest('[data-label="Product"]').length == 0
                      ) {
                        flag = false;
                        HELPER.showNotify('This field is dropped to Product only.', 'error');
                      }
                      break;

                    // 2, Module (A) không được kéo ra ngoài Article
                    case '(A) Title':
                    case '(A) Image':
                    case '(A) Content':
                    case '(A) Excerpt':
                    case '(A) Date':
                      if (
                        $from.closest('[data-label="Article"]').length > 0 &&
                        $to.closest('[data-label="Article"]').length == 0
                      ) {
                        flag = false;
                        HELPER.showNotify('This field is dropped to Article Module only.', 'error');
                      }
                      break;

                    // 3, Product không được kéo vào Product, Product List, Related Products, Article List
                    case 'Product':
                      if ($to.closest('[data-label="Product"]').length > 0) {
                        flag = false;
                        HELPER.showNotify('Cannot put a product inside a product.', 'error');
                      } else if (HELPER.isInsideTheList($to)) {
                        flag = false;
                        HELPER.showNotify('Cannot put a product inside a list.', 'error');
                      }
                      break;

                    // 4, Article không được kéo và Article khác
                    case 'Article':
                      if ($to.closest('[data-label="Article"]').length > 0) {
                        flag = false;
                        HELPER.showNotify('Cannot put a article inside a article.', 'error');
                      } else if (HELPER.isInsideTheList($to)) {
                        flag = false;
                        HELPER.showNotify('Cannot put a list inside another list.', 'error');
                      }
                      break;

                    // 5, Product List, Related Products, Article List không được kéo vào Product, Article, Product List, Related Products, Article List
                    case 'PickyStory':
                    case 'Product List':
                    case 'Related Products':
                    case 'Article List':
                      if ($to.closest('[data-label="Product"]').length > 0) {
                        flag = false;
                        HELPER.showNotify('Cannot put a ' + moduleName + ' inside a Product.', 'error');
                      } else if ($to.closest('[data-label="Article"]').length > 0) {
                        flag = false;
                        HELPER.showNotify('Cannot put a list inside a article.', 'error');
                      } else if (HELPER.isInsideTheList($to)) {
                        flag = false;
                        HELPER.showNotify('Cannot put a list inside another list.', 'error');
                      }
                      break;

                    // 8
                    case 'Collection Toolbar':
                    case 'Paginator':
                    case 'Collection Banner':
                    case 'Collection Title':
                    case 'Collection Desc':
                      if (HELPER.isInsideTheList($to)) {
                        flag = false;
                        HELPER.showNotify('Cannot put a ' + moduleName + ' inside a Product List.', 'error');
                      }
                      break;
                    // 9. Third parties:
                    case 'Judge.me Reviews':
                    case 'Product Reviews':
                    case 'Yotpo - Product & Collection Page':
                    case 'Rivyo Reviews':
                    case 'Stamped.io - Product & Collection Page':
                    case 'Ryviu':
                    case 'Ultimate Sales Boost':
                    case 'WideBundle':
                    case 'Opinew - Product & Collection Pages':
                    case 'Ryviu: Product Review App':
                    case 'Wiser - Product & Collection Page':
                      if (
                        $gfFrame.data('gfframe').getPageType() != 'template-product' &&
                        $from.closest('[data-label="Product"]').length > 0 &&
                        $to.closest('[data-label="Product"]').length == 0
                      ) {
                        flag = false;
                        HELPER.showNotify('This module is not linked to any product.', 'error');
                      }
                      break;
                    case 'Ali Reviews': {
                      const $moduleParent = $element.parent().closest('.module-wrap');
                      const isInsideTheList = HELPER.isInsideTheList($moduleParent);
                      if (!isInsideTheList) {
                        const aliName = $element.children('.module').attr('data-aliname');
                        _this.openModuleSettings('Settings', false, undefined, true);
                        const $labelName = $element.find('.gf_uncompile-module-name').find('span.widget');
                        if (aliName) {
                          $labelName.text(' - ' + aliName);
                        }
                      }
                      break;
                    }
                    case 'LAI AliExpress Reviews': {
                      if (!window.gemDragging) {
                        window.gemDragging = {};
                        window.gemDragging.newLAI = [];
                      }
                      if (window.gemDragging && window.gemDragging.newLAI && window.gemDragging.newLAI.length >= 0) {
                        const newLocal = window.gemDragging.newLAI || [];
                        const moduleId = $element.attr('id');
                        if (newLocal && newLocal.length > 0) {
                          if (index == -1) {
                            window.gemDragging.newLAI.push({ id: moduleId, status: 'new' });
                          } else if (index > -1) {
                            try {
                              newLocal[index].status = 'update';
                              window.gemDragging.newLAI = JSON.parse(JSON.stringify(newLocal));
                            } catch (err) {}
                          }
                        }
                      }
                      _this.openModuleSettings('Settings', false, undefined, true);
                    }

                    default:
                      // 6, Element chứa (P) không được kéo ra ngoài Product
                      if ($stElement && $from.closest('[data-label="Product"]').length > 0) {
                        const $moduleElmProduct = $stElement.find(
                          '[data-label="(P) Title"],[data-label="File Upload"], [data-label="(P) Vendor"], [data-label="(P) SKU"],[data-label="Ultimate Sales Boost"], [data-label="WideBundle"], [data-label="(P) Description"], [data-label="(P) Price"], [data-label="(P) Quantity"], [data-label="(P) Cart Button"], [data-label="(P) Image"], [data-label="(P) Image List"], [data-label="(P) Variants"], [data-label="(P) Swatches"], [data-label="(P) Meta"], [data-label="Infinite Options"]',
                        );
                        if ($moduleElmProduct.length > 0) {
                          if ($to.closest('[data-label="Product"]').length == 0) {
                            flag = false;
                            HELPER.showNotify('You cannot move product child elements out of Product.', 'error');
                          } else if (HELPER.isInsideTheList($to)) {
                            flag = false;
                            HELPER.showNotify('You cannot move product child elements out of Product.', 'error');
                          }
                        }
                      }

                      // 7, Element chứa (A) không được kéo ra ngoài Article
                      if ($stElement && $from.closest('[data-label="Article"]').length > 0) {
                        const $moduleElmArticle = $stElement.find(
                          '[data-label="(A) Title"], [data-label="(A) Image"], [data-label="(A) Content"],[data-label="(A) Excerpt"], [data-label="(A) Date"]',
                        );

                        if ($moduleElmArticle.length > 0) {
                          if ($to.closest('[data-label="Article"]').length == 0) {
                            flag = false;
                            HELPER.showNotify('This module contains only fields that exist in the article', 'error');
                          } else if (HELPER.isInsideTheList($to)) {
                            flag = false;
                            HELPER.showNotify('This module contains only fields that exist in the article', 'error');
                          }
                        }
                      }
                      break;
                  }
                }

                if (flag) {
                  // related products
                  if (
                    $stElement.attr('data-label') == 'Related Products' ||
                    $stElement.find('[data-label="Related Products"]').length > 0
                  ) {
                    if ($to.closest('[data-label="Product"]').length > 0) {
                      flag = false;
                      HELPER.showNotify('Related Products cannot be dropped inside Product.', 'error');
                    }
                  }
                }

                if (flag) {
                  $mHandle.data('gfdraggable').manageStop($newPlace, $stElement, $from, $to);
                  // RefreshDrag Parallax in Row full width
                  if ($stElement && $stElement.attr('data-label') == 'Parallax') {
                    const moduleId = $stElement.data('gfmodule').getModuleId();
                    const moduleIdSlug = moduleId.toString().replace(/-/g, '');
                    const func = 'getParallax' + moduleId;

                    if (document.getElementById('gfFrame').contentWindow[func]) {
                      document.getElementById('gfFrame').contentWindow[func]().refreshDrag();
                    }
                  }
                } else {
                  if ($dragHidden) {
                    $dragHidden.after($stElement);
                    window._isDetached = false;
                  }
                }
              } else {
                if ($dragHidden) {
                  $dragHidden.after($stElement);
                  window._isDetached = false;
                }
              }
            } else {
              if ($dragHidden) {
                $dragHidden.after($stElement);
                window._isDetached = false;
              }
            }
            if ($dragHidden) {
              $dragHidden.remove();
            }

            if ($element.attr('data-compile') == 'false') {
              _this.refresh();
            }

            _this.openModuleSettings(undefined, true);
          },
        });
      }

      return false;
    };

    // gfModule.applyButtonActions
    this.applyButtonActions = function () {
      const $mToolWrap = $element.children('.gf-tool-wrap');
      // for LIQUID module only
      var moduleName = _this.getModuleName();
      if (moduleName == 'Liquid') {
        $mToolWrap.find('.m-data').remove();
      }

      $mToolWrap
        .find('.t-handle .gf-tool-label')
        .off('mousedown.scale')
        .on('mousedown.scale', function () {
          $mToolWrap.addClass('gf-tool-active');
          setTimeout(function () {
            $mToolWrap.removeClass('gf-tool-active');
          }, 100);
        });

      $mToolWrap
        .find('.m-edit')
        .off('mousedown.edit')
        .on('mousedown.edit', function (e) {
          e.preventDefault();
          if (moduleName == 'Liquid') {
            if ($element.data('gfmodule') != undefined) {
              _this.hideTool();
              $element.data('gfmodule').editCode(['template', 'style', 'script']);
            }
          }
          return false;
        });

      // action buttons
      $mToolWrap
        .find('.t-collapse')
        .off('click')
        .on('click', function () {
          const $tool = jQuery(this).closest('.gf-tool');

          if ($tool.hasClass('gf-expand')) {
            $tool.removeClass('gf-expand');
          } else {
            $tool.addClass('gf-expand');
          }
          return false;
        });

      $mToolWrap
        .find('.m-export')
        .off('click')
        .on('click', async function () {
          // app.$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type: 'block', target: $element });
          await handleAddToLibrary($element);
          return false;
        });

      $mToolWrap
        .find('.m-clone')
        .off('click')
        .on('click', function () {
          _this.cloneMe();
          return false;
        });

      $mToolWrap
        .find('.m-remove')
        .off('click')
        .on('click', function () {
          //Close all setting left sidebar
          if ($gfLeftSideBar.find('#md-settings').parent().hasClass('vhr')) {
            $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
          }
          $element.fadeOut(300, function () {
            _this.doRemoveMe();
          });

          return false;
        });

      $mToolWrap
        .find('.m-handle.gf-icon')
        .off('click')
        .on('click', function () {
          $(this).parent().toggleClass('show-m-extra-tools');
        });
      $mToolWrap
        .find('.m-settings,.m-handle:not(".gf-icon")')
        .off()
        .on('click', function () {
          _this.openModuleSettings();
          return false;
        });

      $element.find('.item-content').each(function () {
        if (jQuery(this).children('.gf_add-content').length == 0) {
          jQuery(this).append(window._addContentBtn);
        }
      });

      //Disable mailchimp/contactform/addtocart submit form
      var moduleName = _this.getModuleName();
      if (
        moduleName === 'Mailchimp' ||
        moduleName === 'Contact Form' ||
        moduleName === 'Newsletter' ||
        moduleName === 'Product'
      ) {
        $element
          .find('form')
          .off('submit')
          .on('submit', function () {
            return false;
          });
      }
      //Demo product events
      if (moduleName === 'Product') {
        assignProduct.demoProductEvents();
      }
      // Disable click link
      $element.find('a').on('click', function (e) {
        e.preventDefault();
      });

      return false;
    };

    //TRUONGNC-NEW
    this.initElementErrorHighlight = function (errors) {
      const $toolHighlightWrapper = $element.children('.gf-error-wrapper');
      console.log('TRUONGNC-errors', errors);
      if ($toolHighlightWrapper.length == 0) {
        let wrapper = '<div class="gf-error-wrapper gf-m-tool">';
        errors.forEach((error, index) => {
          const _eTool = `<div id=${error.id} class="gf-error-highlight gf-error-tool ${
            index === 0 ? 'gf-highlight-display' : ''
          }"><li class="t-handle"><a class="e-handle"><span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.86037 2.25123C8.47798 1.58293 7.52202 1.58292 7.13963 2.25122L1.13458 12.7463C0.752196 13.4146 1.23018 14.25 1.99495 14.25H14.0051C14.7698 14.25 15.2478 13.4146 14.8654 12.7463L8.86037 2.25123ZM7.99978 4.25613C8.27411 4.25613 8.49651 4.48053 8.49651 4.75735V9.26837C8.49651 9.54519 8.27411 9.7696 7.99978 9.7696C7.72544 9.7696 7.50304 9.54519 7.50304 9.26837V4.75735C7.50304 4.48053 7.72544 4.25613 7.99978 4.25613ZM7.99978 10.772C7.58827 10.772 7.25468 11.1087 7.25468 11.5239C7.25468 11.9391 7.58827 12.2757 7.99978 12.2757C8.41128 12.2757 8.74488 11.9391 8.74488 11.5239C8.74488 11.1087 8.41128 10.772 7.99978 10.772Z" fill="white"/></svg></span><span class="gf-tool-label">${
            error.name
          }</span></a></li></div>`;
          wrapper = wrapper + _eTool;
        });
        wrapper = wrapper + '</div>';
        $element.append(wrapper);
      } else {
        errors.forEach((error, index) => {
          if ($toolHighlightWrapper.children(`#${error.id}`).length === 0) {
            const _eTool = `<div id=${error.id} class="gf-error-highlight gf-error-tool ${
              index === 0 ? 'gf-highlight-display' : ''
            }"><li class="t-handle"><a class="e-handle"><span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.86037 2.25123C8.47798 1.58293 7.52202 1.58292 7.13963 2.25122L1.13458 12.7463C0.752196 13.4146 1.23018 14.25 1.99495 14.25H14.0051C14.7698 14.25 15.2478 13.4146 14.8654 12.7463L8.86037 2.25123ZM7.99978 4.25613C8.27411 4.25613 8.49651 4.48053 8.49651 4.75735V9.26837C8.49651 9.54519 8.27411 9.7696 7.99978 9.7696C7.72544 9.7696 7.50304 9.54519 7.50304 9.26837V4.75735C7.50304 4.48053 7.72544 4.25613 7.99978 4.25613ZM7.99978 10.772C7.58827 10.772 7.25468 11.1087 7.25468 11.5239C7.25468 11.9391 7.58827 12.2757 7.99978 12.2757C8.41128 12.2757 8.74488 11.9391 8.74488 11.5239C8.74488 11.1087 8.41128 10.772 7.99978 10.772Z" fill="white"/></svg></span><span class="gf-tool-label">${
              error.name
            }</span></a></li></div>`;
            $toolHighlightWrapper.append(_eTool);
          } else {
            index === 0 && $toolHighlightWrapper.children(`#${error.id}`).addClass('gf-highlight-display');
          }
        });
      }
    };

    this.removeHighlightTool = function (errorId) {
      const $outline = $element.children('.gf-error-outline');
      const $eToolWrapAfter = $element.children('.gf-error-wrapper');

      if (!errorId && $eToolWrapAfter) {
        $eToolWrapAfter.remove();
        $outline.remove();
        return;
      }
      const $errorElement = $eToolWrapAfter.find(`#${errorId}`);
      if ($errorElement) {
        $errorElement.remove();
      }
      const children = $eToolWrapAfter.children(`.gf-error-highlight`);
      if (children.length === 0) {
        $outline.remove();
      } else {
        this.setOffsetForHighlightTool();
      }
    };

    this.inactiveHighlightTool = function (errors, errorId) {
      console.log('TRUONGNC-RUNNING');
      const $eToolWrap = $element.children('.gf-error-wrapper');
      if (!$eToolWrap) {
        this.highLightTool(errors);
      }
      //gf-error-outline
      const $outline = $element.children('.gf-error-outline');

      const $eToolAfter = $element.find(`#${errorId}`);
      console.log('$eToolAfter:', $eToolAfter);
      $eToolAfter.addClass('inactive');
      $outline.addClass('inactive');
    };

    this.removeInactiveHighlightTool = function (errors, errorId) {
      const $eToolWrap = $element.children('.gf-error-wrapper');
      if (!$eToolWrap) {
        this.highLightTool(errors);
      }
      //gf-error-outline
      const $outline = $element.children('.gf-error-outline');
      const $eToolAfter = $element.find(`#${errorId}`);
      $eToolAfter.removeClass('inactive');
      $outline.removeClass('inactive');
    };

    this.setOffsetForHighlightTool = function () {
      const showOutline = true;
      const $mToolWrap = $element.children('.gf-error-wrapper');
      // $mToolWrap.css('top', '1px');
      // item-content
      if ($element.parent().hasClass('item-content')) {
        const $moduleParent = $element.parent().closest('.module-wrap');
        if ($moduleParent) {
          var paddingTop = parseInt($moduleParent.css('paddingTop'));
          if (paddingTop == 0 && showOutline == true) {
            $mToolWrap.css('top', '30px');
          }
        }
      }

      // Module Popup fix tools
      if ($element.attr('data-label') == 'Popup') {
        $mToolWrap.css('top', '0px');
        if ($mToolWrap.offset().top >= 40) {
          $mToolWrap.css('top', '-30px');
        }
      }
    };

    //TRUONGNC-NEW
    this.highLightTool = function (errors) {
      let showTool = true;
      // handle disable here
      // if it is hoving ==> disable
      this.initElementErrorHighlight(errors);
      const showOutline = true;

      if (showTool) {
        const $mToolWrap = $element.children('.gf-error-wrapper');

        $mToolWrap.addClass('gf-tool-show');
        const mWrapClass = _this.getTargetWrap();
        if (mWrapClass != '') {
          const $self = $element.find(mWrapClass);
          let diff = 0;
          if ($self && $self.offset()) {
            diff = $self.offset().left - $element.offset().left;
          }
          var left = diff + $self.outerWidth() / 2;
          $mToolWrap.css('left', left);
        } else {
          var left = $element.outerWidth() / 2;
          $mToolWrap.css('left', left);
        }
        // $mToolWrap.css('top', '1px');
        // item-content
        if ($element.parent().hasClass('item-content')) {
          const $moduleParent = $element.parent().closest('.module-wrap');
          if ($moduleParent) {
            var paddingTop = parseInt($moduleParent.css('paddingTop'));
            if (paddingTop == 0 && showOutline == true) {
              $mToolWrap.css('top', '30px');
            }
          }
        }

        // Module Popup fix tools
        if ($element.attr('data-label') == 'Popup') {
          $mToolWrap.css('top', '0px');
          if ($mToolWrap.offset().top >= 40) {
            $mToolWrap.css('top', '-30px');
          }
          if ($mToolWrap.next('.gf-popupBgTool').length == 0) {
            $mToolWrap.after(
              '<div class="gf-popupBgTool" style="position:absolute;top:-30px;width:100%;height:30px;z-index:-1;"></div>',
            );
          }
        }
        if ($element.data('gfoutline') != undefined && showOutline) {
          $element.data('gfoutline').showErrorOutline();
        }
        return false;
      }
    };

    this.handleHiddenErrorHighlight = function (isHidden) {
      const $eToolWrap = $element.children('.gf-error-wrapper');
      const $outline = $element.children('.gf-error-outline');
      if ($eToolWrap) {
        isHidden ? $eToolWrap.addClass('gf-tool-hidden') : $eToolWrap.removeClass('gf-tool-hidden');
      }
      if ($outline) {
        isHidden ? $outline.addClass('hidden') : $outline.removeClass('hidden');
      }
    };

    // gfModule.showTool
    this.showTool = function (force) {
      let showTool = true;
      if (!force) {
        if ($gryffEditor.data('gryffeditor').isDragging() || $gryffEditor.data('gftexteditor').isEditing($element)) {
          showTool = false;
        }
      } else {
        showTool = true;
      }
      if (showTool) {
        var paddingTop = parseInt($element.css('paddingTop'));
        const $mToolWrap = $element.children('.gf-tool-wrap');
        $mToolWrap.addClass('gf-tool-show');

        const moduleName = _this.getModuleName();
        let showOutline = true;

        switch (moduleName) {
          case '(P) Title':
          case '(P) Vendor':
          case '(P) SKU':
          case '(P) Description':
          case '(P) Price':
          case '(P) Stock Counter':
          case '(P) Cart Button':
          case '(P) View More':
          case '(P) Image':
          case '(P) Image List':
          case '(P) Quantity':
          case '(P) Variants':
          case '(P) Swatches':
          case '(A) Title':
          case '(A) Image':
          case '(A) Content':
          case '(A) Excerpt':
          case '(A) Date':
            showOutline = false;
            break;

          default:
            break;
        }

        const mWrapClass = _this.getTargetWrap();
        if (mWrapClass != '') {
          const $self = $element.find(mWrapClass);
          let diff = 0;
          if ($self && $self.offset()) {
            diff = $self.offset().left - $element.offset().left;
          }
          var left = diff + $self.outerWidth() / 2;
          $mToolWrap.css('left', left);
        } else {
          var left = $element.outerWidth() / 2;
          $mToolWrap.css('left', left);
        }
        // $mToolWrap.css('top', '1px');
        // item-content
        if ($element.parent().hasClass('item-content')) {
          const $moduleParent = $element.parent().closest('.module-wrap');
          if ($moduleParent) {
            var paddingTop = parseInt($moduleParent.css('paddingTop'));
            if (paddingTop == 0 && showOutline == true) {
              $mToolWrap.css('top', '30px');
            }
          }
        }

        // Module Popup fix tools
        if ($element.attr('data-label') == 'Popup') {
          $mToolWrap.css('top', '0px');
          if ($mToolWrap.offset().top >= 40) {
            $mToolWrap.css('top', '-30px');
          }
          if ($mToolWrap.next('.gf-popupBgTool').length == 0) {
            $mToolWrap.after(
              '<div class="gf-popupBgTool" style="position:absolute;top:-30px;width:100%;height:30px;z-index:-1;"></div>',
            );
          }
        }

        if ($element.data('gfoutline') != undefined && showOutline) {
          $element.data('gfoutline').showOutline();
        }
      }
      this.handleHiddenErrorHighlight(true);
      return false;
    };
    // gfModule.showToolAndOutlineForDragdrop
    this.showToolAndOutlineForDragdrop = function () {
      const moduleName = _this.getModuleName();
      let showOutline = true;

      switch (moduleName) {
        case '(P) Title':
        case '(P) Vendor':
        case '(P) SKU':
        case '(P) Description':
        case '(P) Price':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case 'Breadcrumbs':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Quantity':
        case '(P) Variants':
        case '(P) Swatches':
        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
          showOutline = false;
          break;

        default:
          break;
      }
      const $rToolWrap = $element.children('.gf-tool-wrap');
      $rToolWrap.addClass('gf-tool-show');
      if ($element.data('gfoutline') != undefined && showOutline) {
        $element.data('gfoutline').showOutline();
      }
    };
    // gfModule.hideTool
    this.hideTool = function (force) {
      if (
        !window._isContextOpenned ||
        ($gryffBody.data('gfcontextmenu') &&
          $gryffBody.data('gfcontextmenu').getTargetMERId() != $element.attr('id')) ||
        force == true
      ) {
        if (!$gryffEditor.data('gryffeditor')?.isDragging() || force == true) {
          const $mToolWrap = $element.children('.gf-tool-wrap');
          $mToolWrap.removeClass('gf-tool-show');

          if ($element.data('gfoutline') != undefined) {
            $element.data('gfoutline').hideOutine();
          }
        }
      }
      $element.removeClass('gf_primary-tool');
      this.handleHiddenErrorHighlight(false);
      return false;
    };

    // gfModule.initModuleTool
    this.initModuleTool = function () {
      if ($element.children('.gf-tool-wrap').length == 0) {
        const _mTool =
          '<ul class="gf-tool gf-m-tool gf-tool-wrap gf-m-tool-wrap"><li class="t-handle"><a class="m-handle"><span><svg class="editor move" width="14" viewBox="0 0 14 14"><path d="M11,10V8H8v3h2l-3,3l-3-3h2V8H3v2L0,7l3-3v2h3V3H4l3-3l3,3H8v3h3V4l3,3L11,10z"/></svg></span><span class="gf-tool-label">Module</span></a></li><li class="m-edit"><a class="m-edit"><svg class="need_a_name" height="14px" viewbox="0 0 14 14"><path d="M12.81,3.69c0.26-0.26,0.26-0.68,0-0.94l-1.56-1.56c-0.26-0.26-0.68-0.26-0.94,0L9.09,2.41l2.5,2.5L12.81,3.69zM1,10.5V13h2.5l7.37-7.37l-2.5-2.5L1,10.5z" /></svg></a></li><li class="t-wrap m-wrap"><a class="m-export" title="Save module"><svg class="editor save" width="14" height="14" viewBox="0 0 14 14"><path d="M12.2499 9.78559V12.4106H1.74999V9.78559H0V12.4106C0 13.3731 0.787495 14.1606 1.74999 14.1606H12.2499C13.2124 14.1606 13.9999 13.3731 13.9999 12.4106V9.78559H12.2499ZM11.3749 6.28561L10.1412 5.05187L7.87495 7.30935V0.160645H6.12496V7.30935L3.85873 5.05187L2.62498 6.28561L6.99996 10.6606L11.3749 6.28561Z"/></svg></a><a class="m-clone" title="Clone Module"><svg class="editor duplicate" width="14" viewBox="0 0 14 14"><path d="M10,10H0V0h10V10z M12,4v8H4v2h10V4H12z"/></svg></a><a class="m-remove" title="Delete Module"><svg class="editor delete" width="14" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7c0,3.9,3.1,7,7,7s7-3.1,7-7C14,3.1,10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4 L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z"/></svg></a></li><li class="t-collapse"><a title="Expand / Collapse"><svg class="editor expand" width="8" viewBox="0 0 8 14"><path d="M1,3l4,4l-4,4V3z"/></svg></a></li></ul>';
        $element.append(_mTool);
      }
      // set handle name
      const moduleName = $element.attr('data-label');
      const $mToolWrap = $element.children('.gf-tool-wrap');

      $mToolWrap.find('.m-handle span.gf-tool-label').text(moduleName);

      $element.off('mouseleave.tool').on('mouseleave.tool', function (e) {
        if ($element.hasClass('module-wrap') && $element.data('gfmodule') != undefined) {
          $element.data('gfmodule').hideTool();
        }
      });
      return false;
    };

    // gfModule.applyEvents
    this.applyEvents = function () {
      _this.initModuleTool();
      _this.applyButtonActions();

      _this.applyDrag();
      // apply functions
      if ($element.data('gfoutline') != undefined) {
        $element.data('gfoutline').initOutline();
        $element.data('gfoutline').applyOutline();
      } else {
        $element.gfOutline();
      }

      // OPTIMIZE FOR TAB ONLY Tabs
      // REFRESH CHILD MODULES WHEN TAB IS CLICKED
      $element
        .find('.gf_tab span')
        .off('mousedown')
        .on('mousedown', function () {
          const $li = jQuery(this).closest('li');
          const index = $li.attr('data-index');

          const moduleId = _this.getModuleId();
          const moduleIdSlug = moduleId.toString().replace(/-/g, '');

          const func = 'getTab' + moduleIdSlug;
          if (document.getElementById('gfFrame').contentWindow[func]) {
            document.getElementById('gfFrame').contentWindow[func]().showAllDetaches();
          }

          HELPER.generatePlaceholderForm($element);

          setTimeout(function () {
            $element
              .children('.module')
              .find('.gf_tab-panel[data-index="' + index + '"]')
              .each(function () {
                jQuery(this)
                  .children('.gf_row, .module-wrap, .element-wrap')
                  .each(function () {
                    const $mer = jQuery(this);
                    if ($mer.hasClass('gf_row')) {
                      if ($mer.data('gfrow') != undefined) {
                        $mer.data('gfrow').refresh();
                      } else {
                        // $mer.gfRow();
                        atom.Init($mer);
                      }
                    } else if ($mer.hasClass('module-wrap')) {
                      if ($mer.data('gfmodule') != undefined) {
                        $mer.data('gfmodule').refresh();
                      } else {
                        // $mer.gfModule();
                        atom.Init($mer);
                      }
                    } else if ($mer.hasClass('element-wrap')) {
                      if ($mer.data('gfelement') != undefined) {
                        $mer.data('gfelement').refresh();
                      } else {
                        // $mer.gfElement();
                        atom.Init($mer);
                      }
                    }
                  });
              });
          }, 300);
        });

      // Bắt sự kiện click trong iframe -> triggle click button editor
      // ==> Để show popup cookieyes
      $element
        .find('.gf_cookie-preferences')
        .off('click')
        .on('click', function () {
          window.parent.jQuery('.cky-banner-element').trigger('click');
        });
      return false;
    };

    this.highlightCounter = function (moduleId) {
      app.$store.commit('sidebar/SET_SIDE_BAR_SETTING_ELEMENT_ID', {
        merId: this.getModuleTargetId(),
        type: 'module',
      });
      const $mdSettings = $gfLeftSideBar.find('#md-settings');
      let _counter = $mdSettings.attr('hightlight-counter');
      if (!_counter) {
        _counter = 'id,number';
      }
      const $arrayCounter = _counter.split(',');
      const _id = $arrayCounter[0];
      let _number = $arrayCounter[1];

      if (moduleId != _id) {
        _number = 1;
      } else {
        _number = parseInt(_number) + 1;
      }
      $mdSettings.attr('hightlight-counter', moduleId + ',' + _number);
      return _number;
    };

    this.getProductValueSelected = function() {
      const settingProduct = _this.getModuleSettings("product");
      const productItems = settingProduct.items;
      return productItems[0].default_value;
    }

    this.openModuleSettings = function (tab, drag, capture, forceOpen) {
      const $toolHighlightWrapper = $element.children('.gf-error-wrapper');
      let errorId = null;
      if ($toolHighlightWrapper.length > 0) {
        const errorActive = $toolHighlightWrapper.find('.gf-error-highlight.gf-highlight-display');
        if (errorActive) {
          errorId = errorActive.attr('id');
          emitter.emit('gemmeter:click-event', {
            merId: $element.attr('id'),
            errorId,
          });
        }
      }

      //đang ở chế độ select targetx
      if (store.getValue('__selectingTarget') == 1) {
        return;
      }

      const doOpenModuleSettings = function () {
        if (tab) {
          const arrayTab = tab.split(':');
          tab = arrayTab[0];
          var columnOpen = arrayTab[1];
        }

        $gfLeftSideBar.data('gfleftsidebar').showHighlighter('module-panel');
        const moduleId = _this.getModuleId();

        // Đếm số lượt mở open setting để cảnh báo đến người dùng.
        if (drag == undefined) {
          drag = false;
        }
        if (!drag) {
          const _countHighlight = _this.highlightCounter(moduleId);
          if (_countHighlight >= 3 && _countHighlight < 5) {
            const $hightlight = jQuery('<div class="gf_panel-hightlight-all module-panel"></div>');
            $gfLeftSideBar.find('.side-panels').append($hightlight);
            setTimeout(function () {
              $hightlight.remove();
            }, 1000);
          }
        }

        // avoid 3 times open
        const $mdSettings = $gfLeftSideBar.find('#md-settings');
        const currentTab = $mdSettings.find('.simple-tabs ul.simple-tabs-item li.active').text().trim();
        const newTab = tab ? tab : 'Settings';
        const merId = $mdSettings.data('edittingID');

        if (!forceOpen) {
          if ($mdSettings.hasClass('active') && merId == $element.attr('id') && currentTab == newTab) {
            app.$store.commit('sidebar/CHANGE_ACTIVE_TAB', {
              key: 'elements',
            });
            return false;
          }
        }

        const moduleName = _this.getModuleName();
        const moduleKey = _this.getModuleKey();

        let $settings = '';
        const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
        $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);

        let $gfTabs;
        let $activePanel;

        if ($element.attr('data-status') == 'default' || $element.attr('data-status') == 'dynamic') {
          $activePanel = $gfLeftSideBar
            .data('gfleftsidebar')
            .showMDSettingsPanel('module', _mdModule, $element.attr('id'), 'md-module', 'dynamic');
        } else {
          $activePanel = $gfLeftSideBar
            .data('gfleftsidebar')
            .showMDSettingsPanel('module', _mdModule, $element.attr('id'), 'md-module', '');
        }

        let $self;
        try {
          dataHolder = _this.getModuleData();
        } catch (err) {
          console.log(err.message);
        }

        let fields = [];
        let settingData = '';
        settingData = $settings;
        if (!settingData || !settingData.length) {
          settingData = `[]`;
          HELPER.showNotify('Error in Element Settings', 'error');
        }

        fields = jQuery.parseJSON(settingData);
        if (moduleName == 'Ultimate Sales Boost') {
          const $moduleParent = $element.parent().closest('.module-wrap');
          const isInsideTheList = HELPER.isInsideTheList($moduleParent);
          const gType = $gfFrame.data('gfframe').getPageType();
          try {
            fields = JSON.parse(settingData);
            const allWIdget = {
              sticker: 'Sticker',
              message: 'Message',
              'get-it-by-timer': 'Get-it-by Timer',
              'buy-x-get-y': 'Buy X Get Y (BOGO)',
              'countdown-timer': 'Countdown Timer',
              'stock-inventory-number': 'Stock Inventory Number',
              'trust-badge': 'Trust Badge',
              'advanced-trust-badge': 'Advanced Trust Badge',
            };
            const widgetSticker = {
              sticker: 'Sticker',
            };
            if (fields && fields.length > 0) {
              const widgetIndex = fields.findIndex((x) => x.name == 'widget');
              if (widgetIndex && widgetIndex >= 0) {
                if (gType == 'template-collection') {
                  // (Product List or Product Single) + Collection Page => 1 widget: Sticker
                  fields[widgetIndex].options = widgetSticker;
                } else if (gType == 'template-product') {
                  if (!isInsideTheList) {
                    // Product Sigle + Product Page => 8 widgets
                    fields[widgetIndex].options = allWIdget;
                  } else {
                    // Product List + Product Page không cho kéo usb vào (Product List + Product Page)
                    HELPER.showNotify(
                      'Cannot put a ' + moduleName + ' into a Product List of Product Page*',
                      'error',
                      5000,
                    );
                    fields[widgetIndex].options = {};
                  }
                } else {
                  // (Product List or Product Single) + Home Page => 1 widget: Sticker
                  fields[widgetIndex].options = widgetSticker;
                }
              }
            }
          } catch (err) {
            console.log(err);
          }
        }
        if (moduleName == 'Ali Reviews') {
          const aliVersion = $element.children('.module').attr('data-aliver');
          if (aliVersion == 'v6') {
            const $moduleParent = $element.parent().closest('.module-wrap');
            const isInsideTheList = HELPER.isInsideTheList($moduleParent);
            try {
              fields = JSON.parse(settingData);
              if (fields && fields.length > 0) {
                const widgetIndex = fields.findIndex((x) => x.name == 'v6widget');
                if (widgetIndex && widgetIndex >= 0) {
                  const fullOptions = fields[widgetIndex].options || {};
                  const gType = $gfFrame.data('gfframe').getPageType();
                  const productOptions = {
                    section: 'Section',
                    badge: 'Star Badge',
                  };
                  const insideListOptions = {
                    badgeCollection: 'Star Badge in Collection',
                  };
                  const leftOptions = {
                    section: 'Section',
                  };
                  const defaultValue = fields[widgetIndex]['default_value'];
                  if (isInsideTheList) {
                    fields[widgetIndex].options = insideListOptions;
                    fields[widgetIndex]['default_value'] = 'badgeCollection';
                  } else {
                    const $parentProduct = $element.closest('[data-label="Product"]');
                    // if(gType == 'template-product' || $parentProduct.length>0){
                    if ($parentProduct.length > 0) {
                      fields[widgetIndex].options = productOptions;
                      if (productOptions[defaultValue]) {
                        fields[widgetIndex]['default_value'] = defaultValue;
                      } else {
                        fields[widgetIndex]['default_value'] = Object.keys(productOptions)[0];
                      }
                    } else {
                      fields[widgetIndex].options = leftOptions;
                      fields[widgetIndex]['default_value'] = 'section';
                    }
                  }
                }
              }
            } catch (err) {
              console.log(err);
            }
          }
        }
        if (moduleName == 'LAI AliExpress Reviews') {
          let isNew = true;
          const $moduleParent = $element.parent().closest('.module-wrap');
          const isInsideTheList = HELPER.isInsideTheList($moduleParent);
          if (!window.gemDragging) {
            window.gemDragging = {};
            window.gemDragging.newLAI = [];
          }
          if (window.gemDragging && window.gemDragging.newLAI && window.gemDragging.newLAI.length >= 0) {
            const moduleId = $element.attr('id');
            const index = window.gemDragging.newLAI.findIndex((x) => x.id == moduleId);
            const $module = $element.children('.module');
            const dataWidget = $module.attr('data-widget');
            if (index == -1) {
              if (isInsideTheList || dataWidget == 'list-rating') {
                window.gemDragging.newLAI.push({ id: moduleId, status: 'new' });
              } else {
                window.gemDragging.newLAI.push({ id: moduleId, status: 'update' });
              }
            }
            window.gemDragging.newLAI.forEach((dragItem) => {
              if (dragItem.id == moduleId && dragItem.status == 'update') {
                isNew = false;
              }
            });
          }
          if (isNew) {
            try {
              fields = JSON.parse(settingData);
              const widgetIndex = fields.findIndex((x) => x.name == 'widget');
              const pageType = $gfFrame.data('gfframe').getPageType();
              const subPageOption = {
                'product-rating': 'Star Ratings',
                'happy-page': 'Happy Customer Reviews',
              };
              const homePageOption = {
                'product-rating': 'Star Ratings',
                'home-section': 'Homepage Reviews',
              };
              const productPageOption = {
                'product-rating-anchorlink': 'Star Ratings',
                'product-section': 'Review Widget',
              };
              const $module = $element.children('.module');
              if (fields && fields.length > 0 && widgetIndex > -1) {
                let defaultValue = fields[widgetIndex]['default_value'];
                const $parentProduct = $element.closest('[data-label="Product"]');
                switch (pageType) {
                  case 'template-page': {
                    if (isInsideTheList) {
                      fields[widgetIndex].options = {
                        'list-rating': 'Star Ratings in the List',
                      };
                      defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                    } else {
                      fields[widgetIndex].options = subPageOption;
                      if ($parentProduct.length > 0) {
                        defaultValue = fields[widgetIndex]['default_value'] = 'product-rating';
                      } else {
                        defaultValue = fields[widgetIndex]['default_value'] = 'happy-page';
                      }
                    }
                    break;
                  }
                  case 'template-product': {
                    if (isInsideTheList) {
                      fields[widgetIndex].options = {
                        'list-rating': 'Star Ratings in the List',
                      };
                      defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                    } else {
                      fields[widgetIndex].options = productPageOption;
                      if ($parentProduct.length > 0) {
                        defaultValue = fields[widgetIndex]['default_value'] = 'product-rating-anchorlink';
                      } else {
                        defaultValue = fields[widgetIndex]['default_value'] = 'product-section';
                      }
                    }
                    break;
                  }
                  case 'template-index': {
                    if (isInsideTheList) {
                      fields[widgetIndex].options = {
                        'list-rating': 'Star Ratings in the List',
                      };
                      defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                    } else {
                      fields[widgetIndex].options = homePageOption;
                      if ($parentProduct.length > 0) {
                        defaultValue = fields[widgetIndex]['default_value'] = 'product-rating';
                      } else {
                        defaultValue = fields[widgetIndex]['default_value'] = 'home-section';
                      }
                    }
                    break;
                  }
                  default: {
                    if (isInsideTheList) {
                      fields[widgetIndex].options = {
                        'list-rating': 'Star Ratings in the List',
                      };
                      defaultValue = fields[widgetIndex]['default_value'] = 'list-rating';
                    } else {
                      fields[widgetIndex].options = {
                        'product-rating': 'Star Ratings',
                      };
                      defaultValue = fields[widgetIndex]['default_value'] = 'product-rating';
                    }
                    break;
                  }
                }
                const suffName = fields[widgetIndex].options[defaultValue];
                $module.attr('data-widget-name', suffName);
                $module.attr('data-widget', defaultValue);
                const $labelName = $element.find('.gf_uncompile-module-name').find('span.widget');
                if (suffName) {
                  $labelName.text(' - ' + suffName);
                }
              }
            } catch (err) {
              console.log(err);
            }
          }
        }

        if(moduleName === 'Product' || moduleName === 'Related Products') {
          _this.hideSelectAssignByPageType(fields);

          const selectedValue = _this.getProductValueSelected();
          _this.assignPreviewUpdate(moduleName, selectedValue);
        }

        const $settingsPanel = $gfLeftSideBar.find('#md-module .md-body.settings-panel');
        $settingsPanel.gfFormRender({
          fields: fields,
          onRender: function () {},
        });

        // GLOBAL STYLE
        // Before Render Setting Group --> Init Form Setting Global Style
        renderTabSettings.initGlobalStyle(moduleKey);

        if (moduleName == 'LAI AliExpress Reviews') {
          const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
          app.$store.commit('editor/SET_DATA_SETTINGS', {
            id: keySettings,
            value: JSON.stringify(fields),
          });
        }

        if (moduleName == 'Ali Reviews') {
          const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
          app.$store.commit('editor/SET_DATA_SETTINGS', {
            id: keySettings,
            value: JSON.stringify(fields),
          });
        }
        if ($settingsPanel.find('.repeator').length > 0) {
          $settingsPanel.find('.repeator').gfRepeator({
            targetElement: $element,
            dataHolder: dataHolder,
            detectChange: function (dataChanged) {
              // Update dataHolder by callback value
              dataHolder = dataChanged;
              saveSettings();
            },
          });
        }

        /**
         * comment chờ fix sau
         */
        /* if (moduleName == "Before and After Images") {
              if (checkKeyValid("lazyloadingSetSize")) {
                let target = '.gf_imagebeforeafter-item img';
                initSizeForElement($element, target);
              }
            } */
        // reload Tabs

        // GLOBAL STYLE
        renderTabSettings.applySettingSnipetGlobalStyle(moduleKey, _this.getModuleTargetId());

        switch (moduleName) {
          case 'Breadcrumbs':
          case '(P) Title':
          case '(P) Vendor':
          case '(P) SKU':
          case '(P) Description':
          case '(P) Price':
          // renderTabSettings.initSettingGlobalStyle(moduleName, "gs-text-main", "Typography");
          case '(P) Quantity':
          case '(P) Stock Counter':
          case '(P) Cart Button':
          case '(P) Dynamic Checkout Button':
          case '(P) View More':
          case '(P) Image':
          case '(P) Image List':
          case '(P) Variants':
          case '(P) Swatches':
          case '(P) Meta':
          case '(P) File Upload':

          case '(A) Title':
          case '(A) Image':
          case '(A) Content':
          case '(A) Excerpt':
          case '(A) Date':

          // social share has child items
          case 'Social Share':
            var moduleClass = _this.getTargetClass();
            $self = $element.find(moduleClass);
            if (!moduleClass || !$self || !$self.length) {
              $self = $element;
            }
            break;

          default:
            $self = $element;
            break;
        }
        $gfTabs = $activePanel.find('.simple-tabs');
        $gfTabs.gfTabs({
          targetElement: $self,
          onSettingsChanged: function ($input) {
            saveSettings($input);
          },
          onTabClick: function (tabName) {
            switch (tabName) {
              case 'Settings':
                var style = _this.getModuleCSS();
                var screenType =
                  $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

                $activePanel.find('.columns.field-hide-all').hide();
                $activePanel.find('.columns.field-visible-' + screenType).show();

                readStyle($element, $activePanel, _this, $self, moduleName, style, screenType);

                break;

              case 'Design':
                if ($gfTabs.data('gftabs') != undefined) {
                  $gfTabs.data('gftabs').onDesignOptionsTabClick();
                }
                break;
            }
            setTimeout(function () {
              // capture history setting
              if (capture != false) {
                $gryffEditor.data('gfhistory').captureMERSettings();
              }
            }, 100);
          },
        });
        // go to tab when drag padding
        if (tab != undefined && tab == 'Design') {
          $gfTabs.data('gftabs').gotoTab(1);
        }

        var saveSettings = function ($input) {
          validateInput($input);

          //kiểm tra Klaviyo Code
          const klaviyoKey = _this.getModuleKey();
          if (klaviyoKey == 'klaviyo-signup-form') {
            const code = $input.val();
            const parternKlaviyo = /"klaviyo-form-(.*)"/;
            const codeGroup = parternKlaviyo.exec(code);
            if (codeGroup && codeGroup[1]) {
              $input.val(codeGroup[1]).attr('value', codeGroup[1]).trigger('value-change');
              return;
            } else {
              //strip invalid
              const invalidCharactersPattern = /[\/\>\<\"]/g;
              if (invalidCharactersPattern.exec(code)) {
                const stripValue = code.replace(invalidCharactersPattern, '');
                $input.val(stripValue).attr('value', stripValue).trigger('value-change');
                return;
              }
            }
          }
          if (moduleName == 'Mailchimp') {
            const version = $element.attr('data-ver') != undefined ? parseFloat($element.attr('data-ver')) : 0;
            if (version > 2) {
              const code = $input.val();
              const parternMailchimp = /action="(.*?)"/g;
              const codeGroup = parternMailchimp.exec(code);
              if (codeGroup && codeGroup[1]) {
                $input.val(codeGroup[1]).attr('value', codeGroup[1]).trigger('value-change');
                return;
              } else {
                //chú ý invalid của mailchimp khác của Klaviyo
                const invalidCharactersPattern = /[\>\<\"\!]/g;
                if (invalidCharactersPattern.exec(code)) {
                  const stripValue = code.replace(invalidCharactersPattern, '');
                  $input.val(stripValue).attr('value', stripValue).trigger('value-change');
                  return;
                }
              }
            }
          }

          if (moduleName == 'Omnisend') {
            const code = $input.val();
            if ($element.children('.module').attr('data-option') === 'embedded') {
              const parternOmnisend = /"omnisend-embedded-(.*)"/;
              const codeGroup = parternOmnisend.exec(code);
              if (codeGroup && codeGroup[1]) {
                $input.val(codeGroup[1]).attr('value', codeGroup[1]).trigger('value-change');
                return;
              } else {
                //strip invalid
                const invalidCharactersPattern = /[\/\>\<\"]/g;
                if (invalidCharactersPattern.exec(code)) {
                  const stripValue = code.replace(invalidCharactersPattern, '');
                  $input.val(stripValue).attr('value', stripValue).trigger('value-change');
                  return;
                }
              }
            }
          }

          // apply settings
          _this._saveForm($activePanel);

          let jsonHtml = dataHolder;
          jsonHtml = HELPER.compressHTML(jsonHtml);
          jsonHtml = HELPER.formatJsonHtml(jsonHtml);

          // Update sidebar assigned product preview
          const controlId = $input?.attr('id');

          if(moduleName === 'Product' || moduleName === 'Related Products') {
            if(controlId === 'assign-product-data') {
              _this.assignPreviewUpdate(moduleName, $input.val());
            }
          }

          if (moduleName == 'Popup' || moduleName == '(P) Swatches') {
            _this.refresh($input);
          } else {
            _this.setModuleData(jsonHtml);
          }

          switch (moduleName) {
            case 'Breadcrumbs':

            case '(P) Variants':
            case '(P) Title':
            case '(P) Vendor':
            case '(P) SKU':
            case '(P) Description':
            case '(P) Price':
            case '(P) Quantity':
            case '(P) Stock Counter':
            case '(P) Cart Button':
            case '(P) Dynamic Checkout Button':
            case '(P) View More':
            case '(P) Image':
            case '(P) Image List':
            case '(P) Variants':
            case '(P) Swatches':
            case '(P) Meta':

            case '(A) Title':
            case '(A) Image':
            case '(A) Content':
            case '(A) Excerpt':
            case '(A) Date':

            // social share has child items
            case 'Social Share':
              var moduleClass = _this.getTargetClass();
              $self = $element.find(moduleClass);
              break;
            case 'Smart Search & Instant Search':
              var apiKey = $activePanel.find('input[name="apiKey"]').attr('value');
              var libUrlSave = 'https://www.searchanise.com/widgets/shopify/init.js?a=' + apiKey;
              var newLibsObj = {
                libs: [libUrlSave],
              };
              const keyLibs = HELPER.getKeyDataSetting(base._libs, moduleId);
              app.$store.commit('editor/SET_DATA_SETTINGS', {
                id: keyLibs,
                value: JSON.stringify(newLibsObj),
              });
              break;
            default:
              $self = $element;
              break;
          }

          // set target element
          $gfTabs.data('gftabs').setTargetElement($self);

          const screenType =
            $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

          // Cache biến screenType vào window.GemCurrentScreenTypePhotoPicker để kiểm tra khi thay đổi có thay đổi đúng màn hình không.
          // Fix lỗi khi thay đổi ảnh ở laptop xog bấm chuyển màn hình sang mobile thì bị nhận dữ liệu cho mobile vì thuộc tính change bị chậm
          if (
            $input &&
            $input.hasClass('gf_to-photoPicker') &&
            window.GemCurrentScreenTypePhotoPicker &&
            screenType != window.GemCurrentScreenTypePhotoPicker
          ) {
            return false;
          }

          const style = _this.getModuleCSS();
          // COLLECTION 2019
          writeStyle($element, $activePanel, _this, $self, moduleName, style, screenType, $input);

          /**
           * Before and After Images
           * Thêm settings cho cho image để filter lại dữ liệu width height cho image
           * Lấy ảnh từ setting ra rồi load image trên DOM ảo để lấy được data.
           *
           * Phần này có thể cải thiện bằng cách viết 1 function chung cho việc load ảnh(function ảnh), khi load được ảnh đó thì mình sẽ trả về dữ liệu của ảnh về width height
           * Vì ảnh chỉ cần load 1 lần nhưng đang phải hiển thị rất nhiều chỗ, sau này không biết nên lấy lại content thế nào
           * Cũng có trường hợp setting ảnh nhưng chưa kịp load đã publish => cần chờ để lấy đủ content rồi mới cho publish.
           */

          if (moduleKey == 'image-before-after') {
            //lấy link ảnh trong content
            const moduleId = _this.getModuleId();
            let $settings = '';
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);

            // const style = _this.getModuleCSS();
            let fields = [];

            try {
              fields = JSON.parse($settings);
              const dataFields = getValuesInFields(['image1', 'image2', 'image3', 'useImage3'], fields);
              const use3 = dataFields.get('useImage3');

              const dataPromise = [
                getNaturalSizeImage(dataFields.get('image1')),
                getNaturalSizeImage(dataFields.get('image2')),
              ];
              if (use3) {
                dataPromise.push(getNaturalSizeImage(dataFields.get('image3')));
              }

              Promise.all(dataPromise)
                .then((values) => {
                  const newValues = new Map();
                  if (values[0] && values[0].width && values[0].height) {
                    newValues.set('imageWidth1', values[0].width);
                    newValues.set('imageHeight1', values[0].height);
                  }
                  if (values[1] && values[1].width && values[1].height) {
                    newValues.set('imageWidth2', values[1].width);
                    newValues.set('imageHeight2', values[1].height);
                  }
                  if (values[2] && values[2].width && values[2].height) {
                    newValues.set('imageWidth3', values[2].width);
                    newValues.set('imageHeight3', values[2].height);
                  }

                  fields = setValuesToFields(newValues, fields);
                  const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
                  app.$store.commit('editor/SET_DATA_SETTINGS', {
                    id: keySettings,
                    value: JSON.stringify(fields),
                  });
                })
                .catch((e) => {
                  console.log("Image can't load", e);
                });
            } catch (err) {
              console.log(err.message);
            }
          }

          //hero banner
          if (moduleName == 'Hero Banner') {
            const moduleId = _this.getModuleId();
            let $settings = '';
            const keySettingsHero = HELPER.getKeyDataSetting(base._settings, moduleId);
            $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettingsHero);
            const style = _this.getModuleCSS();
            let fields = [];
            let bg = '';

            const arrScreen = ['lg', 'md', 'sm', 'xs'];
            //get fields & get default image
            try {
              fields = jQuery.parseJSON($settings);
              for (let i = 0; i < fields.length; i++) {
                if (fields[i].name == 'image') {
                  bg = fields[i].default_value;
                  continue;
                }

                for (let j = 0; j < arrScreen.length; j++) {
                  const screen = arrScreen[j];
                  if (fields[i].name == `image_${screen}`) {
                    //get bgUrl from css
                    const bgUrl = HELPER.getValueFromCSS($element, style, 'background-image', screen);
                    if (bgUrl) {
                      fields[i].default_value = trimUrlCss(bgUrl);
                    } else {
                      fields[i].default_value = fields[i].default_value ? fields[i].default_value : bg;
                    }
                  }
                }
              }
            } catch (err) {
              console.log(err.message);
            }
            const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });

            _this.refresh();
          }

          // Product List detect child change 1
          HELPER.flagListItemChange($element, 'settings');

          if (HELPER.isInsideTheList($element)) {
            var $itemContent = $element.closest('.item-content');
            HELPER.detectContentChange($itemContent);
          }

          // Product Meta
          if ($element.closest('[data-label="(P) Meta"]').length > 0) {
            var $itemContent = $element.closest('.item-content');
            HELPER.detectContentChange($itemContent);
          }

          if(moduleName === 'Product' && controlId === 'assign-product-data') {
            const $productSelectorInstance = getProductSelectorInstance();
            $productSelectorInstance.refreshVariantSelector();
          }

          // avoid module run refresh()
          return false;
        };

        if (columnOpen && columnOpen != '') {
          $gfLeftSideBar.find('.columns[data-caption="' + columnOpen + '"]').attr('data-toggle', 'true');
        }

        // GLOBAL STYLE
        renderTabSettings.visibleSettingGlobalStyle(moduleKey);
        store.setValue('renderColumnEnd', '');

        snippetSettingLinks(fields);
        app.$store.commit('sidebar/CHANGE_ACTIVE_TAB', {
          key: 'elements',
        });
      };

      const presetIsEdited = app.$store.getters['sidebar/PRESET_IS_EDITED'];
      if (presetIsEdited) {
        emitter.emit('WithoutPresetEdited');
        emitter.on('CallBackWithoutPresetEdited', () => {
          doOpenModuleSettings();
        });
      }

      if (presetIsEdited) return false;
      doOpenModuleSettings();
      return false;
    };

    this.hideSelectAssignByPageType = function(fields) {
      const keySettings = HELPER.getKeyDataSetting(base._settings, _this.getModuleId());
      assignProduct.hideSelectAssignByPageType(fields, keySettings);
    }

    this.runTemplate = function (jsonData) {
      const moduleId = _this.getModuleId();
      const moduleName = _this.getModuleName();
      const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
      let $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
      let templateTmp = _this.getModuleTemplate();

      let fields = [];
      try {
        let settingData = '';
        settingData = $settings;
        if (!settingData || !settingData.length) {
          settingData = `[]`;
        }

        fields = jQuery.parseJSON(settingData);
      } catch (err) {
        console.log(moduleName + ' - ' + err.message);
        HELPER.showNotify(err.name + ': Error in Snippet Settings JSON', 'error');
      }

      templateTmp = HELPER.replaceFields(fields, templateTmp);
      templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);

      const moduleIdSlug = moduleId.toString().replace(/-/g, '');
      templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);

      loop: switch (moduleName) {
        case 'Related Products':
        case 'Product List':

        // COLLECTION 2019
        case 'Collection Toolbar':
        case 'Paginator':
        case 'Collection Banner':
        case 'Collection Title':
        case 'Collection Desc':

        case 'Article List':
          var html = templateTmp;
          break;

        case '(P) Meta':
          if (jsonData != undefined) {
            var html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);
          } else {
            var html = 'There is no product data source.';
          }

          break;

        case '(P) Title':
        case '(P) Vendor':
        case '(P) SKU':
        case '(P) Description':
        case '(P) Price':
        case '(P) Stock Counter':
        case '(P) Cart Button':
        case '(P) View More':
        case '(P) Image':
        case '(P) Image List':
        case '(P) Variants':
        case '(P) Swatches':
          if (jsonData != undefined) {
            var html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);
          } else {
            var html = 'There is no product data source.';
          }
          break;

        case '(A) Title':
        case '(A) Image':
        case '(A) Content':
        case '(A) Excerpt':
        case '(A) Date':
          if (jsonData != undefined) {
            var html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);
          } else {
            var html = 'There is no article data source.';
          }
          break;
        case 'Liquid':
          var html = '';
          var flagCheck = false; //cần flag để check nếu bị vào catch

          try {
            let name = '';
            let settings;
            settings = JSON.parse($settings);
            for (var i = 0; i < settings.length; i++) {
              if (settings[i].name == 'name') {
                name = settings[i].default_value;
              }
            }
            if (name != '' && name != 'Custom Code') {
              $element.attr('data-name', name);
              flagCheck = true;
            }
          } catch (error) {
            console.log(error);
          }

          if (!flagCheck) {
            $element.attr('data-name', 'Right click on this, and choose Edit Code.');
          }

          break;

        default:
          var html = '';
          for (var i = 0; i < fields.length; i++) {
            if (fields[i].name == 'compile' && fields[i].default_value == 'false') {
              const $wrapper = jQuery('<div>' + templateTmp + '</div>');
              const keySnippet = HELPER.getKeyDataSetting(base._snippet, moduleId);
              const $snippet = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySnippet);
              let icon = '';

              icon =
                jQuery('<div />').html($snippet).children('.snippet-icon').html() ||
                '<svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4475 6C15.1927 6 14.9787 6.19157 14.9506 6.44478L13.0617 23.4448C13.0288 23.741 13.2606 24 13.5586 24H14.5525C14.8073 24 15.0213 23.8084 15.0494 23.5552L16.9383 6.55522C16.9712 6.25903 16.7394 6 16.4414 6H15.4475ZM19.5536 8.64645C19.3583 8.84171 19.3583 9.15829 19.5536 9.35355L24.8464 14.6464C25.0417 14.8417 25.0417 15.1583 24.8464 15.3536L19.5536 20.6464C19.3583 20.8417 19.3583 21.1583 19.5536 21.3536L20.2464 22.0464C20.4417 22.2417 20.7583 22.2417 20.9536 22.0464L27.6464 15.3536C27.8417 15.1583 27.8417 14.8417 27.6464 14.6464L20.9536 7.95355C20.7583 7.75829 20.4417 7.75829 20.2464 7.95355L19.5536 8.64645ZM2.35355 14.6464C2.15829 14.8417 2.15829 15.1583 2.35355 15.3536L9.04645 22.0464C9.24171 22.2417 9.55829 22.2417 9.75355 22.0464L10.4464 21.3536C10.6417 21.1583 10.6417 20.8417 10.4464 20.6464L5.15355 15.3536C4.95829 15.1583 4.95829 14.8417 5.15355 14.6464L10.4464 9.35355C10.6417 9.15829 10.6417 8.84171 10.4464 8.64645L9.75355 7.95355C9.55829 7.75829 9.24171 7.75829 9.04645 7.95355L2.35355 14.6464Z"/></svg>';

              const color = $wrapper.children('.module').attr('data-color');
              const widget = $wrapper.children('.module').attr('data-widget');
              let widgetLabel = '';

              if (fields.length > 0) {
                for (let j = 0; j < fields.length; j++) {
                  if (fields[j].name == 'widget' && fields[j].options) {
                    var options = fields[j].options ? fields[j].options : { widget: '' };
                    widgetLabel = options[widget];
                    break;
                  }
                  //check widget in group
                  if (
                    fields[j].type != undefined &&
                    fields[j].type == 'group' &&
                    fields[j].items &&
                    fields[j].items.length
                  ) {
                    for (let k = 0; k < fields[j].items.length; k++) {
                      const fieldItem = fields[j].items[k];
                      if (fieldItem.name == 'widget' && fieldItem.options) {
                        var options = fieldItem.options ? fieldItem.options : { widget: '' };
                        widgetLabel = options[widget];
                        break;
                      }
                    }
                    if (widgetLabel) {
                      break;
                    }
                  }
                }
              }
              if (moduleName == 'Ali Reviews') {
                widgetLabel = $element.children('.module').attr('data-aliname');
                if (fields.length > 0) {
                  const widgetIndex = fields.findIndex((x) => x.name == 'v6widget');
                  if (widgetIndex && widgetIndex >= 0) {
                    const defautValue = fields[widgetIndex]['default_value'];
                    if (defautValue !== 'section') {
                      widgetLabel = fields[widgetIndex].options[defautValue];
                    }
                  }
                }
              }
              if (moduleName == 'LAI AliExpress Reviews') {
                widgetLabel = $element.children('.module').attr('data-widget-name');
                if (fields.length > 0) {
                  const widgetIndex = fields.findIndex((x) => x.name == 'widget');
                  if (widgetIndex > -1) {
                    const defautValue = fields[widgetIndex]['default_value'];
                    widgetLabel = fields[widgetIndex].options[defautValue];
                  }
                }
              }
              const maxButtonWidth = $element.width() - 2 * 21; // Subtract by paddings
              const showWidgetType = maxButtonWidth >= 320;
              const showWidgetName = maxButtonWidth >= 250;
              var html = `<div class="gf_uncompile-module-icon" ${
                color ? 'style="background-color:' + color + '"' : ''
              }>${icon} <span class="gf_uncompile-module-name ${
                showWidgetName ? (showWidgetType ? '' : 'hide-type') : 'hide'
              }">${moduleName}${widgetLabel ? '<span class="widget"> - ' + widgetLabel + '</span>' : ''}</span></div>`;
              $wrapper.find('.module').html(html);
              html = $wrapper.html();
              $element.attr('data-compile', 'false');
              break loop;
            }
          }

          try {
            const jsonHtml = _this.getModuleData();
            var jsonData = jQuery.parseJSON(jsonHtml);
            var html = _this.getModuleHtmlByTemplate(templateTmp, jsonData);
          } catch (err) {
            console.log(moduleName, err);
          }
          break;
      }

      // console.log('html:', html);
      $element.html(html);

      return false;
    };

    this.runTemplateBlocked = function (module) {
      let html = '';
      if (module == 'Vimeo') {
        html = `
              <div class="gf_blocked-section">
                <div class="gf_blocked-header">
                  <div class="gf_icon-blocked">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0)">
                      <path d="M12.981 20.9544L20.9503 12.9851L22.0108 14.0456L14.0415 22.0149L12.981 20.9544Z" fill="#666666"/>
                      <path d="M17.5 24C13.916 24 11 21.084 11 17.5C11 13.916 13.916 11 17.5 11C21.084 11 24 13.916 24 17.5C24 21.084 21.084 24 17.5 24ZM17.5 12.5C14.743 12.5 12.5 14.743 12.5 17.5C12.5 20.257 14.743 22.5 17.5 22.5C20.257 22.5 22.5 20.257 22.5 17.5C22.5 14.743 20.257 12.5 17.5 12.5Z" fill="#666666"/>
                      <path d="M8.25 20H2.25C1.01 20 0 18.99 0 17.75V9.25002C0 8.01002 1.01 7.00002 2.25 7.00002H13.75C14.395 7.00002 15.005 7.27502 15.425 7.75702C15.697 8.06902 15.666 8.54202 15.354 8.81502C15.044 9.08802 14.569 9.05602 14.296 8.74402C14.16 8.58902 13.962 8.50002 13.75 8.50002H2.25C1.837 8.50002 1.5 8.83702 1.5 9.25002V17.75C1.5 18.163 1.837 18.5 2.25 18.5H8.25C8.664 18.5 9 18.836 9 19.25C9 19.664 8.664 20 8.25 20V20Z" fill="#666666"/>
                      <path d="M12.25 8.5C11.836 8.5 11.5 8.164 11.5 7.75V5C11.5 3.07 9.93 1.5 8 1.5C6.07 1.5 4.5 3.07 4.5 5V7.75C4.5 8.164 4.164 8.5 3.75 8.5C3.336 8.5 3 8.164 3 7.75V5C3 2.243 5.243 0 8 0C10.757 0 13 2.243 13 5V7.75C13 8.164 12.664 8.5 12.25 8.5Z" fill="#666666"/>
                      </g>
                      <defs>
                      <clipPath id="clip0">
                      <rect width="24" height="24" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <span>Blocked</span>
                </div>
                <div class="gf_blocked-content">
                  <p class="gf_txt-content">
                    This element is currently disabled because you may have rejected our
                    <b class="gf_txt-bold">Performance and Functionality cookies</b>.
                  </p>
                  <p class="gf_txt-content">To enable the element, please follow the steps below:</p>
                  <div class="gf_list-step">
                    <p>1. <b class="gf_txt-bold">Save your progress.</b></p>
                    <p>2. Open your <a class="gf_list-step gf_cookie-preferences">Cookie Preferences.</a></p>
                    <p>3. Select "<b class="gf_txt-bold">Accept All</b>" or "<b class="gf_txt-bold">Preferences</b>" to turn on Performance and Functionality cookies.</p>
                    <p>4. Wait for the Editor to reload.</p>
                  </div>
                </div>
              </div>
            `;
      }
      $element.html(html);
      return false;
    };

    // gfModule.runScript
    this.runScript = function () {
      return this.runScriptUseStore();
    };

    this.runScriptUseStore = function () {
      const moduleId = this.getModuleId();
      const modulename = this.getModuleName();
      const $bkScript = $moduleScriptContainer.find('#' + base._script + '-' + moduleId);
      let script = '';
      if ($bkScript.length > 0) {
        script = $bkScript.find('.script').html();
      }
      if (!script) {
        script = this.getModuleScript();
      }
      $bkScript.remove();
      try {
        $moduleScriptContainer.append(
          `<div id="${base._script}-${moduleId}"><script class="script" type="text/javascript" defer="defer">${script}</script></div>`,
        );
      } catch (err) {
        console.log(err.message);
      }
      return false;
    };

    this.assignPreviewUpdate = function(moduleName, productType) {
      assignProduct.updateAndChangePreviewAssignedProduct(moduleName, productType);
    }

    this.runScriptUseDom = function () {
      const moduleId = this.getModuleId();
      const modulename = this.getModuleName();
      const $bkActiveModule = $divContentBk.find('#module-' + moduleId);

      const $script = $bkActiveModule.find('.script');
      let script = $script.html();

      const dataFromId = $bkActiveModule.attr('data-from');
      if (dataFromId != undefined) {
        script = script.replace(dataFromId, moduleId);
      }

      $script.remove();
      try {
        $bkActiveModule.append('<script class="script" type="text/javascript" defer="defer">' + script + '</script>');
      } catch (err) {
        console.log(err.message);
      }

      return false;
    };

    // gfModule.runStyle
    this.runStyle = function (style) {
      const moduleId = this.getModuleId();
      let $styleModule = $moduleStyleContainer.find('#' + base._style + '-' + moduleId);
      if ($styleModule.length === 0) {
        jQuery(`<div id="${base._style}-${moduleId}"></div>`).appendTo($moduleStyleContainer);
        $styleModule = $moduleStyleContainer.find('#' + base._style + '-' + moduleId);
      }
      let $style = $styleModule.find('.style');
      if (!$style.length) {
        $style = jQuery('<style rel="stylesheet" class="style" type="text/css"></style>').appendTo($styleModule);
      }
      if (!style) {
        style = $style.html();
      }
      $style.attr('type', 'text/css').html(HELPER.formatCSS(style));
      const keyStyle = HELPER.getKeyDataSetting(base._style, moduleId);
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keyStyle,
        value: style,
      });
      return false;
    };

    /* ------------------------------------------ MODULE - Chris 01/07/2016 ----------------------------------------- */
    this.detectModuleChange = function (index, key, content) {
      const moduleName = _this.getModuleName();
      switch (moduleName) {
        case '(P) Meta':
          // PRODUCT META --
          HELPER.detectProductMetaChange($element, content);
          break;

        default:
          var jsonData = {};
          var $bkItemContent = jQuery('<div/>').html(HELPER.clearExportedData(content));

          if (checkKeyValid("removeDataArticleList")) {
            $bkItemContent.find('.module').removeAttr('data-articles').removeAttr('data-article');
          }

          $bkItemContent.find('>.module-wrap').each(function () {
            const $that = jQuery(this);
            const mId = $that.attr('data-id');
            $that.html('');
          });

          var moduleId = _this.getModuleId();
          var content = $bkItemContent.html();

          // Remove unnecessary quote mark in background-image url to avoid bug
          $bkItemContent.find('.module-wrap[data-label="(P) Swatches"] .gf_swatch').each(function () {
            const bgImage = this.style.backgroundImage;
            const trimBgImage = bgImage.replace('url(', '').replace(')', '').replace(/"/g, '');

            content = content
              .replace('url("' + trimBgImage + '")', 'url(' + trimBgImage + ')')
              .replace('url(&quot;' + trimBgImage + '&quot;)', 'url(' + trimBgImage + ')');
          });

          let $data = '';
          const keyData = HELPER.getKeyDataSetting(base._data, moduleId);
          $data = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyData);

          try {
            var jsonData = jQuery.parseJSON(getModuleData(moduleId));

            if (jsonData['items'][index] != undefined) {
              jsonData['items'][index][key] = content;
              const jsonHtml = JSON.stringify(jsonData, null, '\t');
              const replaceJsonHtml = jsonHtml.replaceAll(ACTIVE_CLASSES, '');

              const keyData = HELPER.getKeyDataSetting(base._data, moduleId);
              app.$store.commit('editor/SET_DATA_SETTINGS', {
                id: keyData,
                value: replaceJsonHtml,
              });

              // cap nhat lai dataHolder
              if (dataHolder != undefined) {
                dataHolder = jsonHtml;
              }
            }

            // PRODUCT LIST -- Product List / Related Products / Article List
            HELPER.detectListItemChange($element, content);

            // PRODUCT META --
            if ($element.closest('[data-label="(P) Meta').length > 0) {
              const $productMeta = $element.closest('[data-label="(P) Meta');
              $productMeta.find('.item-content').each(function () {
                const $itemContent = jQuery(this);
                if ($itemContent.closest('.module-wrap').is($productMeta)) {
                  HELPER.detectContentChange($itemContent);
                }
              });
            }
          } catch (err) {
            console.log(err.message);
          }
          return jsonData;
      }
    };

    this._saveForm = function ($activeModal) {
      const $settingsPanel = $activeModal.find('.settings-panel');

      const moduleId = _this.getModuleId();
      let settings = '';
      const keySettingsSaveForm = HELPER.getKeyDataSetting(base._settings, moduleId);
      settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettingsSaveForm);

      let fields = [];
      try {
        fields = JSON.parse(settings);
      } catch (err) {
        console.log(err);
      }

      jQuery.each(fields, function (key, val) {
        if (val.type == 'group' && val.items) {
          // Type group
          for (let h = 0; h < val.items.length; h++) {
            var _selfname = val.items[h].name;
            var _selfnewVal = $settingsPanel.find('[name="' + _selfname + '"]').attr('value');

            if (typeof fields[key].items[h].default_value != 'undefined') {
              fields[key].items[h].default_value = _selfnewVal;
            }

            //đoạn này khả năng lỗi. Vì không có advanced trong items của group thay bằng đoạn bên dưới chính xác hơn
            if (fields[key].items[h].advanced != undefined && fields[key].items[h].advanced.length > 0) {
              for (var i = 0; i < fields[key].items[h].advanced.length; i++) {
                var _selfname = fields[key].items[h].advanced[i].name;
                var _selfnewVal = $settingsPanel.find('[name="' + _selfname + '"]').attr('value');

                if (typeof fields[key].items[h].advanced[i].default_value != 'undefined') {
                  fields[key].items[h].advanced[i].default_value = _selfnewVal;
                }
              }
            }
          }

          if (fields[key].advanced != undefined && fields[key].advanced.length > 0) {
            for (var i = 0; i < fields[key].advanced.length; i++) {
              var _selfname = fields[key].advanced[i].name;
              var _selfnewVal = $settingsPanel.find('[name="' + _selfname + '"]').attr('value');

              if (typeof fields[key].advanced[i].default_value != 'undefined') {
                fields[key].advanced[i].default_value = _selfnewVal;
              }
            }
          }
        } else {
          // Type default
          var _selfname = val.name;
          var _selfnewVal = $settingsPanel.find('[name="' + _selfname + '"]').attr('value');

          if (typeof fields[key].default_value != 'undefined') {
            fields[key].default_value = _selfnewVal;
          }

          if (fields[key].advanced != undefined && fields[key].advanced.length > 0) {
            for (var i = 0; i < fields[key].advanced.length; i++) {
              var _selfname = fields[key].advanced[i].name;
              var _selfnewVal = $settingsPanel.find('[name="' + _selfname + '"]').attr('value');

              if (typeof fields[key].advanced[i].default_value != 'undefined') {
                fields[key].advanced[i].default_value = _selfnewVal;
              }
            }
          }
        }
      });
      const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: keySettings,
        value: JSON.stringify(fields),
      });

      return fields;
    };

    /**
     * The function will include script youtube api if element use youtube video
     * Elements can use video: Youtube, Video Popup, Video Bg
     * @param {JQuery} $element
     * @param {array} libs
     * @returns libs
     */
    this.shouldIncludesYoutubeAPI = function ($element, libs) {
      const $module = $element.find('.module');

      const moduleName = $element.attr('data-label');

      let url = '';

      let shouldInclude = false;

      switch (moduleName) {
        case 'Youtube': {
          url = $module.attr('data-url') || '';
          break;
        }

        case 'Video Popup': {
          const $videoPopup = $module.find('.video-popup');
          if ($videoPopup) {
            url = $videoPopup.attr('href') || '';
          }
          break;
        }

        case 'Video Bg': {
          const source = $module.attr('data-video-source') || '';
          if (source == 'youtube') {
            url = $module.attr('data-url-youtube') || '';
          }
          break;
        }

        
        case '(P) Image':
        case '(P) Image List': {
          if(checkKeyValid("removeYoutubeLib")){
            // do not include youtube embed
          }else{
            shouldInclude = true;
            break;
          }
          
        }
        default: {
          return libs;
        }
      }

      if (url.includes('youtube.com') || url.includes('youtu.be') || shouldInclude) {
        libs.push('https://www.youtube.com/player_api');
      }

      return libs;
    };

    this.productChangePidToLatestId = function() {
      // Kiểm tra giá trị của manual-select value hiện tại
      const fields = _this.getDataSettings();
      const pIndex = fields.findIndex((x) => x.id === 'product');
      const pIdIndex = fields.findIndex((x) => x.id === 'pid');

      const productItems = fields[pIndex]?.items;
      if(productItems) {
        const productType = productItems[0].default_value;
        const manualId = productItems[2].default_value_id;
        const pIdValue = fields[pIdIndex].default_value;
        const previewId = getProductPreview();
        const latestId = window._productLatest.id;

        if( productType === 'manual-select' && manualId === 'auto') {
          // change manual id
          fields[pIndex].items[2].default_value_id = latestId;
          // Change pid value
          fields[pIdIndex].default_value = latestId;
        }

        // Trường hợp kiểu assigned & pId = auto và chưa picked preview sản phẩm nào
        else if(productType === 'assigned-products' && pIdValue === 'auto' && previewId === 'auto') {
          // Change assigned default value
          fields[pIndex].items[1].default_value = latestId;
          // Change pid value
          fields[pIdIndex].default_value = latestId;
        }

        const keySettings= HELPER.getKeyDataSetting(base._settings, _this.getModuleId());
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: keySettings,
          value: JSON.stringify(fields),
        });

        if (!checkKeyValid('disabledRefreshModuleProduct')) {
          // Chỉ refresh preview với trường hợp module là product
          if(_this.getModuleName() === 'Product') {
            _this.refresh();
          }
        }
      }
    }

    this.handleProductData = function (callback, productData, productId) {
      if (productData != undefined && productData.id != undefined) {
        if (productId == 'auto') {
          window._productLatest = productData;
          productData.real_id = productData.id;
          productData.id = 'auto';
          productData.latest_product = true;
        }
        HELPER.updateProductInList(productData);
        setTimeout(function () {
          // Update product dynamic in window
          if (_this.isDynamicProduct()) {
            updateDynamicProduct(productData);
          }
        }, 100);
        HELPER.handleProductNotFound(false);
      } else {
        HELPER.handleProductNotFound(true);
      }
      callback({product: productData}, productId);
    }

    /**
     * The function check current module is Product and setted to dynamic
     */
    this.isDynamicProduct = function () {
      return $element.attr('data-status') == 'dynamic' && this.getModuleName() == 'Product';
    };

    this.syncBHandleForArticleList = async function () {
      try {
        const shopifyDomain = app.$store.state['app'].shopInfo?.shopifyDomain;
        const data = {
          shop: shopifyDomain,
          limit: 250,
        };
        
        let jsonData = [];
        if (window._blogsJsonData && Object.keys(window._blogsJsonData).length) {
          jsonData = window._blogsJsonData;
        } else {
          const res = await GET(api.getBlogs().url, data);
          jsonData = res.data
          window._blogsJsonData = jsonData;
        }

        if (jsonData && jsonData.blogs && jsonData.blogs.length) {
          const blogsData = jsonData['blogs'];
          const moduleId = _this.getModuleId();
          const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
          const $settings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
          let fields = [];
  
          try {
            fields = jQuery.parseJSON($settings);
          } catch (err) {
            console.log(err.message);
          }

          const currentBlogId = fields.find((item) => item.id == 'bId');
          const blog = blogsData.find((item) => item.id == currentBlogId?.default_value);
          if (blog) {
            const blogHandle = blog.handle;
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'bHandle') {
                fields[i].default_value = blogHandle;
              }
            }
            $element.find('.module').attr('data-bHandle', blogHandle);
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keySettings,
              value: JSON.stringify(fields),
            });
          }
        }
      } catch (error) {
        console.log(error.message);
      }
    }
    

    this.init();
  };
  jQuery.fn.gfModule = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfmodule')) {
        const plugin = new jQuery.gfModule(this, options);
        jQuery(this).data('gfmodule', plugin);
      }
    });
  };
})(jQuery);
